"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5900],{

/***/ 30369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YM": function() { return /* binding */ Array_head; },
  "S1": function() { return /* binding */ Array_init; },
  "Z$": function() { return /* binding */ Array_last; }
});

// UNUSED EXPORTS: Alt, Alternative, Applicative, Apply, Chain, ChainRecBreadthFirst, ChainRecDepthFirst, Compactable, Do, Extend, Filterable, FilterableWithIndex, Foldable, FoldableWithIndex, FromEither, Functor, FunctorWithIndex, Monad, Pointed, Traversable, TraversableWithIndex, URI, Unfoldable, Witherable, Zero, alt, altW, ap, apFirst, apS, apSecond, append, appendW, array, bind, bindTo, chain, chainFirst, chainRecBreadthFirst, chainRecDepthFirst, chainWithIndex, chop, chunksOf, compact, comprehension, concat, concatW, cons, copy, deleteAt, difference, dropLeft, dropLeftWhile, dropRight, duplicate, elem, empty, every, exists, extend, filter, filterE, filterMap, filterMapWithIndex, filterWithIndex, findFirst, findFirstMap, findIndex, findLast, findLastIndex, findLastMap, flap, flatten, foldLeft, foldMap, foldMapWithIndex, foldRight, fromEither, fromEitherK, fromOption, fromOptionK, fromPredicate, getDifferenceMagma, getEq, getIntersectionSemigroup, getMonoid, getOrd, getSemigroup, getShow, getUnionMonoid, getUnionSemigroup, guard, insertAt, intersection, intersperse, isEmpty, isNonEmpty, isOutOfBound, lefts, lookup, makeBy, map, mapWithIndex, match, matchLeft, matchLeftW, matchRight, matchRightW, matchW, modifyAt, of, partition, partitionMap, partitionMapWithIndex, partitionWithIndex, prepend, prependAll, prependToAll, prependW, range, reduce, reduceRight, reduceRightWithIndex, reduceWithIndex, replicate, reverse, rights, rotate, scanLeft, scanRight, separate, sequence, size, snoc, some, sort, sortBy, spanLeft, splitAt, tail, takeLeft, takeLeftWhile, takeRight, traverse, traverseWithIndex, unfold, union, uniq, unsafeDeleteAt, unsafeInsertAt, unsafeUpdateAt, unzip, updateAt, wilt, wither, zero, zip, zipWith

// EXTERNAL MODULE: ./node_modules/fp-ts/es6/function.js
var es6_function = __webpack_require__(3735);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/internal.js
var internal = __webpack_require__(59384);
;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/Eq.js

// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.0.0
 */
var fromEquals = function (equals) { return ({
    equals: function (x, y) { return x === y || equals(x, y); }
}); };
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category combinators
 * @since 2.10.0
 */
var struct = function (eqs) {
    return fromEquals(function (first, second) {
        for (var key in eqs) {
            if (!eqs[key].equals(first[key], second[key])) {
                return false;
            }
        }
        return true;
    });
};
/**
 * Given a tuple of `Eq`s returns a `Eq` for the tuple
 *
 * @example
 * import { tuple } from 'fp-ts/Eq'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import * as B from 'fp-ts/boolean'
 *
 * const E = tuple(S.Eq, N.Eq, B.Eq)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 1, true]), true)
 * assert.strictEqual(E.equals(['a', 1, true], ['b', 1, true]), false)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 2, true]), false)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 1, false]), false)
 *
 * @category combinators
 * @since 2.10.0
 */
var tuple = function () {
    var eqs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        eqs[_i] = arguments[_i];
    }
    return fromEquals(function (first, second) { return eqs.every(function (E, i) { return E.equals(first[i], second[i]); }); });
};
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
/* istanbul ignore next */
var contramap_ = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, contramap(f)); };
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * @category Contravariant
 * @since 2.0.0
 */
var contramap = function (f) { return function (fa) {
    return fromEquals(function (x, y) { return fa.equals(f(x), f(y)); });
}; };
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.0.0
 */
var URI = 'Eq';
/**
 * @category instances
 * @since 2.5.0
 */
var eqStrict = {
    equals: function (a, b) { return a === b; }
};
var empty = {
    equals: function () { return true; }
};
/**
 * @category instances
 * @since 2.10.0
 */
var Eq_getSemigroup = function () { return ({
    concat: function (x, y) { return fromEquals(function (a, b) { return x.equals(a, b) && y.equals(a, b); }); }
}); };
/**
 * @category instances
 * @since 2.6.0
 */
var Eq_getMonoid = function () { return ({
    concat: Eq_getSemigroup().concat,
    empty: empty
}); };
/**
 * @category instances
 * @since 2.7.0
 */
var Contravariant = {
    URI: URI,
    contramap: contramap_
};
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use [`tuple`](#tuple) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var getTupleEq = (/* unused pure expression or super */ null && (tuple));
/**
 * Use [`struct`](#struct) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var getStructEq = (/* unused pure expression or super */ null && (struct));
/**
 * Use [`eqStrict`](#eqstrict) instead
 *
 * @since 2.0.0
 * @deprecated
 */
var strictEqual = eqStrict.equals;
/**
 * Use small, specific instances instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var eq = (/* unused pure expression or super */ null && (Contravariant));
/**
 * Use [`Eq`](./boolean.ts.html#eq) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var eqBoolean = (/* unused pure expression or super */ null && (eqStrict));
/**
 * Use [`Eq`](./string.ts.html#eq) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var eqString = (/* unused pure expression or super */ null && (eqStrict));
/**
 * Use [`Eq`](./number.ts.html#eq) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var eqNumber = (/* unused pure expression or super */ null && (eqStrict));
/**
 * Use [`Eq`](./Date.ts.html#eq) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var eqDate = {
    equals: function (first, second) { return first.valueOf() === second.valueOf(); }
};

;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/Magma.js
/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @category combinators
 * @since 2.11.0
 */
var reverse = function (M) { return ({
    concat: function (first, second) { return M.concat(second, first); }
}); };
/**
 * @category combinators
 * @since 2.11.0
 */
var filterFirst = function (predicate) { return function (M) { return ({
    concat: function (first, second) { return (predicate(first) ? M.concat(first, second) : second); }
}); }; };
/**
 * @category combinators
 * @since 2.11.0
 */
var filterSecond = function (predicate) { return function (M) { return ({
    concat: function (first, second) { return (predicate(second) ? M.concat(first, second) : first); }
}); }; };
/**
 * @category combinators
 * @since 2.11.0
 */
var endo = function (f) { return function (M) { return ({
    concat: function (first, second) { return M.concat(f(first), f(second)); }
}); }; };
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(N.MagmaSub)(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), -6)
 *
 * @since 2.11.0
 */
var concatAll = function (M) { return function (startWith) { return function (as) {
    return as.reduce(function (a, acc) { return M.concat(a, acc); }, startWith);
}; }; };

;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/Ord.js


// -------------------------------------------------------------------------------------
// defaults
// -------------------------------------------------------------------------------------
/**
 * @category defaults
 * @since 2.10.0
 */
var equalsDefault = function (compare) { return function (first, second) {
    return first === second || compare(first, second) === 0;
}; };
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.0.0
 */
var fromCompare = function (compare) { return ({
    equals: equalsDefault(compare),
    compare: function (first, second) { return (first === second ? 0 : compare(first, second)); }
}); };
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * Given a tuple of `Ord`s returns an `Ord` for the tuple.
 *
 * @example
 * import { tuple } from 'fp-ts/Ord'
 * import * as B from 'fp-ts/boolean'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 *
 * const O = tuple(S.Ord, N.Ord, B.Ord)
 * assert.strictEqual(O.compare(['a', 1, true], ['b', 2, true]), -1)
 * assert.strictEqual(O.compare(['a', 1, true], ['a', 2, true]), -1)
 * assert.strictEqual(O.compare(['a', 1, true], ['a', 1, false]), 1)
 *
 * @category combinators
 * @since 2.10.0
 */
var Ord_tuple = function () {
    var ords = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        ords[_i] = arguments[_i];
    }
    return fromCompare(function (first, second) {
        var i = 0;
        for (; i < ords.length - 1; i++) {
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) {
                return r;
            }
        }
        return ords[i].compare(first[i], second[i]);
    });
};
/**
 * @category combinators
 * @since 2.10.0
 */
var Ord_reverse = function (O) { return fromCompare(function (first, second) { return O.compare(second, first); }); };
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
/* istanbul ignore next */
var Ord_contramap_ = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, Ord_contramap(f)); };
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * @category Contravariant
 * @since 2.0.0
 */
var Ord_contramap = function (f) { return function (fa) {
    return fromCompare(function (first, second) { return fa.compare(f(first), f(second)); });
}; };
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.0.0
 */
var Ord_URI = 'Ord';
/**
 * @category instances
 * @since 2.0.0
 */
var Ord_getSemigroup = function () { return ({
    concat: function (first, second) {
        return fromCompare(function (a, b) {
            var ox = first.compare(a, b);
            return ox !== 0 ? ox : second.compare(a, b);
        });
    }
}); };
/**
 * Returns a `Monoid` such that:
 *
 * - its `concat(ord1, ord2)` operation will order first by `ord1`, and then by `ord2`
 * - its `empty` value is an `Ord` that always considers compared elements equal
 *
 * @example
 * import { sort } from 'fp-ts/Array'
 * import { contramap, reverse, getMonoid } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as B from 'fp-ts/boolean'
 * import { pipe } from 'fp-ts/function'
 * import { concatAll } from 'fp-ts/Monoid'
 * import * as N from 'fp-ts/number'
 *
 * interface User {
 *   readonly id: number
 *   readonly name: string
 *   readonly age: number
 *   readonly rememberMe: boolean
 * }
 *
 * const byName = pipe(
 *   S.Ord,
 *   contramap((p: User) => p.name)
 * )
 *
 * const byAge = pipe(
 *   N.Ord,
 *   contramap((p: User) => p.age)
 * )
 *
 * const byRememberMe = pipe(
 *   B.Ord,
 *   contramap((p: User) => p.rememberMe)
 * )
 *
 * const M = getMonoid<User>()
 *
 * const users: Array<User> = [
 *   { id: 1, name: 'Guido', age: 47, rememberMe: false },
 *   { id: 2, name: 'Guido', age: 46, rememberMe: true },
 *   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
 *   { id: 4, name: 'Giulio', age: 44, rememberMe: true }
 * ]
 *
 * // sort by name, then by age, then by `rememberMe`
 * const O1 = concatAll(M)([byName, byAge, byRememberMe])
 * assert.deepStrictEqual(sort(O1)(users), [
 *   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
 *   { id: 4, name: 'Giulio', age: 44, rememberMe: true },
 *   { id: 2, name: 'Guido', age: 46, rememberMe: true },
 *   { id: 1, name: 'Guido', age: 47, rememberMe: false }
 * ])
 *
 * // now `rememberMe = true` first, then by name, then by age
 * const O2 = concatAll(M)([reverse(byRememberMe), byName, byAge])
 * assert.deepStrictEqual(sort(O2)(users), [
 *   { id: 4, name: 'Giulio', age: 44, rememberMe: true },
 *   { id: 2, name: 'Guido', age: 46, rememberMe: true },
 *   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
 *   { id: 1, name: 'Guido', age: 47, rememberMe: false }
 * ])
 *
 * @category instances
 * @since 2.4.0
 */
var Ord_getMonoid = function () { return ({
    concat: Ord_getSemigroup().concat,
    empty: fromCompare(function () { return 0; })
}); };
/**
 * @category instances
 * @since 2.7.0
 */
var Ord_Contravariant = {
    URI: Ord_URI,
    contramap: Ord_contramap_
};
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.11.0
 */
var trivial = {
    equals: es6_function/* constTrue */.W8,
    compare: 
    /*#__PURE__*/
    (0,es6_function/* constant */.a9)(0)
};
/**
 * @since 2.11.0
 */
var equals = function (O) { return function (second) { return function (first) {
    return first === second || O.compare(first, second) === 0;
}; }; };
// TODO: curry in v3
/**
 * Test whether one value is _strictly less than_ another
 *
 * @since 2.0.0
 */
var lt = function (O) { return function (first, second) { return O.compare(first, second) === -1; }; };
// TODO: curry in v3
/**
 * Test whether one value is _strictly greater than_ another
 *
 * @since 2.0.0
 */
var gt = function (O) { return function (first, second) { return O.compare(first, second) === 1; }; };
// TODO: curry in v3
/**
 * Test whether one value is _non-strictly less than_ another
 *
 * @since 2.0.0
 */
var leq = function (O) { return function (first, second) { return O.compare(first, second) !== 1; }; };
// TODO: curry in v3
/**
 * Test whether one value is _non-strictly greater than_ another
 *
 * @since 2.0.0
 */
var geq = function (O) { return function (first, second) { return O.compare(first, second) !== -1; }; };
// TODO: curry in v3
/**
 * Take the minimum of two values. If they are considered equal, the first argument is chosen
 *
 * @since 2.0.0
 */
var min = function (O) { return function (first, second) {
    return first === second || O.compare(first, second) < 1 ? first : second;
}; };
// TODO: curry in v3
/**
 * Take the maximum of two values. If they are considered equal, the first argument is chosen
 *
 * @since 2.0.0
 */
var max = function (O) { return function (first, second) {
    return first === second || O.compare(first, second) > -1 ? first : second;
}; };
/**
 * Clamp a value between a minimum and a maximum
 *
 * @since 2.0.0
 */
var clamp = function (O) {
    var minO = min(O);
    var maxO = max(O);
    return function (low, hi) { return function (a) { return maxO(minO(a, hi), low); }; };
};
/**
 * Test whether a value is between a minimum and a maximum (inclusive)
 *
 * @since 2.0.0
 */
var between = function (O) {
    var ltO = lt(O);
    var gtO = gt(O);
    return function (low, hi) { return function (a) { return (ltO(a, low) || gtO(a, hi) ? false : true); }; };
};
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
// tslint:disable: deprecation
/**
 * Use [`tuple`](#tuple) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var getTupleOrd = (/* unused pure expression or super */ null && (Ord_tuple));
/**
 * Use [`reverse`](#reverse) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var getDualOrd = (/* unused pure expression or super */ null && (Ord_reverse));
/**
 * Use [`Contravariant`](#contravariant) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var ord = (/* unused pure expression or super */ null && (Ord_Contravariant));
// default compare for primitive types
function compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var strictOrd = {
    equals: eqStrict.equals,
    compare: compare
};
/**
 * Use [`Ord`](./boolean.ts.html#ord) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var ordBoolean = (/* unused pure expression or super */ null && (strictOrd));
/**
 * Use [`Ord`](./string.ts.html#ord) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var ordString = (/* unused pure expression or super */ null && (strictOrd));
/**
 * Use [`Ord`](./number.ts.html#ord) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var ordNumber = (/* unused pure expression or super */ null && (strictOrd));
/**
 * Use [`Ord`](./Date.ts.html#ord) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var ordDate = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (pipe(ordNumber, 
/*#__PURE__*/
Ord_contramap(function (date) { return date.valueOf(); }))));

;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/Semigroup.js
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */




// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Get a semigroup where `concat` will return the minimum, based on the provided order.
 *
 * @example
 * import * as N from 'fp-ts/number'
 * import * as S from 'fp-ts/Semigroup'
 *
 * const S1 = S.min(N.Ord)
 *
 * assert.deepStrictEqual(S1.concat(1, 2), 1)
 *
 * @category constructors
 * @since 2.10.0
 */
var Semigroup_min = function (O) { return ({
    concat: min(O)
}); };
/**
 * Get a semigroup where `concat` will return the maximum, based on the provided order.
 *
 * @example
 * import * as N from 'fp-ts/number'
 * import * as S from 'fp-ts/Semigroup'
 *
 * const S1 = S.max(N.Ord)
 *
 * assert.deepStrictEqual(S1.concat(1, 2), 2)
 *
 * @category constructors
 * @since 2.10.0
 */
var Semigroup_max = function (O) { return ({
    concat: max(O)
}); };
/**
 * @category constructors
 * @since 2.10.0
 */
var constant = function (a) { return ({
    concat: function () { return a; }
}); };
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Semigroup`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse } from 'fp-ts/Semigroup'
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(reverse(S.Semigroup).concat('a', 'b'), 'ba')
 *
 * @category combinators
 * @since 2.10.0
 */
var Semigroup_reverse = reverse;
/**
 * Given a struct of semigroups returns a semigroup for the struct.
 *
 * @example
 * import { struct } from 'fp-ts/Semigroup'
 * import * as N from 'fp-ts/number'
 *
 * interface Point {
 *   readonly x: number
 *   readonly y: number
 * }
 *
 * const S = struct<Point>({
 *   x: N.SemigroupSum,
 *   y: N.SemigroupSum
 * })
 *
 * assert.deepStrictEqual(S.concat({ x: 1, y: 2 }, { x: 3, y: 4 }), { x: 4, y: 6 })
 *
 * @category combinators
 * @since 2.10.0
 */
var Semigroup_struct = function (semigroups) { return ({
    concat: function (first, second) {
        var r = {};
        for (var k in semigroups) {
            if (_.has.call(semigroups, k)) {
                r[k] = semigroups[k].concat(first[k], second[k]);
            }
        }
        return r;
    }
}); };
/**
 * Given a tuple of semigroups returns a semigroup for the tuple.
 *
 * @example
 * import { tuple } from 'fp-ts/Semigroup'
 * import * as B from 'fp-ts/boolean'
 * import * as N from 'fp-ts/number'
 * import * as S from 'fp-ts/string'
 *
 * const S1 = tuple(S.Semigroup, N.SemigroupSum)
 * assert.deepStrictEqual(S1.concat(['a', 1], ['b', 2]), ['ab', 3])
 *
 * const S2 = tuple(S.Semigroup, N.SemigroupSum, B.SemigroupAll)
 * assert.deepStrictEqual(S2.concat(['a', 1, true], ['b', 2, false]), ['ab', 3, false])
 *
 * @category combinators
 * @since 2.10.0
 */
var Semigroup_tuple = function () {
    var semigroups = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        semigroups[_i] = arguments[_i];
    }
    return ({
        concat: function (first, second) { return semigroups.map(function (s, i) { return s.concat(first[i], second[i]); }); }
    });
};
/**
 * Between each pair of elements insert `middle`.
 *
 * @example
 * import { intercalate } from 'fp-ts/Semigroup'
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * const S1 = pipe(S.Semigroup, intercalate(' + '))
 *
 * assert.strictEqual(S1.concat('a', 'b'), 'a + b')
 *
 * @category combinators
 * @since 2.10.0
 */
var intercalate = function (middle) { return function (S) { return ({
    concat: function (x, y) { return S.concat(x, S.concat(middle, y)); }
}); }; };
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * Always return the first argument.
 *
 * @example
 * import * as S from 'fp-ts/Semigroup'
 *
 * assert.deepStrictEqual(S.first<number>().concat(1, 2), 1)
 *
 * @category instances
 * @since 2.10.0
 */
var first = function () { return ({ concat: identity }); };
/**
 * Always return the last argument.
 *
 * @example
 * import * as S from 'fp-ts/Semigroup'
 *
 * assert.deepStrictEqual(S.last<number>().concat(1, 2), 2)
 *
 * @category instances
 * @since 2.10.0
 */
var last = function () { return ({ concat: function (_, y) { return y; } }); };
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Semigroup'
 * import * as N from 'fp-ts/number'
 *
 * const sum = concatAll(N.SemigroupSum)(0)
 *
 * assert.deepStrictEqual(sum([1, 2, 3]), 6)
 * assert.deepStrictEqual(sum([]), 0)
 *
 * @since 2.10.0
 */
var Semigroup_concatAll = concatAll;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `void` module instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var semigroupVoid = constant(undefined);
/**
 * Use [`getAssignSemigroup`](./struct.ts.html#getAssignSemigroup) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var getObjectSemigroup = function () { return ({
    concat: function (first, second) { return Object.assign({}, first, second); }
}); };
/**
 * Use [`last`](#last) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var getLastSemigroup = (/* unused pure expression or super */ null && (last));
/**
 * Use [`first`](#first) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var getFirstSemigroup = (/* unused pure expression or super */ null && (first));
/**
 * Use [`tuple`](#tuple) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var getTupleSemigroup = (/* unused pure expression or super */ null && (Semigroup_tuple));
/**
 * Use [`struct`](#struct) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var getStructSemigroup = (/* unused pure expression or super */ null && (Semigroup_struct));
/**
 * Use [`reverse`](#reverse) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var getDualSemigroup = (/* unused pure expression or super */ null && (Semigroup_reverse));
/**
 * Use [`max`](#max) instead.
 *
 * @category constructors
 * @since 2.0.0
 * @deprecated
 */
var getJoinSemigroup = (/* unused pure expression or super */ null && (Semigroup_max));
/**
 * Use [`min`](#min) instead.
 *
 * @category constructors
 * @since 2.0.0
 * @deprecated
 */
var getMeetSemigroup = (/* unused pure expression or super */ null && (Semigroup_min));
/**
 * Use [`intercalate`](#intercalate) instead.
 *
 * @category combinators
 * @since 2.5.0
 * @deprecated
 */
var getIntercalateSemigroup = (/* unused pure expression or super */ null && (intercalate));
function fold(S) {
    var concatAllS = Semigroup_concatAll(S);
    return function (startWith, as) { return (as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as)); };
}
/**
 * Use [`SemigroupAll`](./boolean.ts.html#SemigroupAll) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var semigroupAll = {
    concat: function (x, y) { return x && y; }
};
/**
 * Use [`SemigroupAny`](./boolean.ts.html#SemigroupAny) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var semigroupAny = {
    concat: function (x, y) { return x || y; }
};
/**
 * Use [`getSemigroup`](./function.ts.html#getSemigroup) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var getFunctionSemigroup = (/* unused pure expression or super */ null && (getSemigroup));
/**
 * Use [`Semigroup`](./string.ts.html#Semigroup) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var semigroupString = {
    concat: function (x, y) { return x + y; }
};
/**
 * Use [`SemigroupSum`](./number.ts.html#SemigroupSum) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var semigroupSum = {
    concat: function (x, y) { return x + y; }
};
/**
 * Use [`SemigroupProduct`](./number.ts.html#SemigroupProduct) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var semigroupProduct = {
    concat: function (x, y) { return x * y; }
};

;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/ReadonlyNonEmptyArray.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};








// -------------------------------------------------------------------------------------
// internal
// -------------------------------------------------------------------------------------
/**
 * @internal
 */
var ReadonlyNonEmptyArray_empty = internal/* emptyReadonlyArray */.Xl;
/**
 * @internal
 */
var isNonEmpty = internal/* isNonEmpty */.Od;
/**
 * @internal
 */
var isOutOfBound = function (i, as) { return i < 0 || i >= as.length; };
/**
 * @internal
 */
var prependW = function (head) { return function (tail) { return __spreadArray([head], tail); }; };
/**
 * @internal
 */
var prepend = prependW;
/**
 * @internal
 */
var appendW = function (end) { return function (init) { return __spreadArray(__spreadArray([], init), [end]); }; };
/**
 * @internal
 */
var append = appendW;
/**
 * @internal
 */
var unsafeInsertAt = function (i, a, as) {
    if (isNonEmpty(as)) {
        var xs = internal/* fromReadonlyNonEmptyArray */.r1(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [a];
};
/**
 * @internal
 */
var unsafeUpdateAt = function (i, a, as) {
    if (as[i] === a) {
        return as;
    }
    else {
        var xs = _.fromReadonlyNonEmptyArray(as);
        xs[i] = a;
        return xs;
    }
};
/**
 * Remove duplicates from a `ReadonlyNonEmptyArray`, keeping the first occurrence of an element.
 *
 * @example
 * import { uniq } from 'fp-ts/ReadonlyNonEmptyArray'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(uniq(N.Eq)([1, 2, 1]), [1, 2])
 *
 * @category combinators
 * @since 2.11.0
 */
var uniq = function (E) { return function (as) {
    if (as.length === 1) {
        return as;
    }
    var out = [head(as)];
    var rest = tail(as);
    var _loop_1 = function (a) {
        if (out.every(function (o) { return !E.equals(o, a); })) {
            out.push(a);
        }
    };
    for (var _i = 0, rest_1 = rest; _i < rest_1.length; _i++) {
        var a = rest_1[_i];
        _loop_1(a);
    }
    return out;
}; };
/**
 * Sort the elements of a `ReadonlyNonEmptyArray` in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import * as RNEA from 'fp-ts/ReadonlyNonEmptyArray'
 * import { contramap } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Person {
 *   name: string
 *   age: number
 * }
 *
 * const byName = pipe(S.Ord, contramap((p: Person) => p.name))
 *
 * const byAge = pipe(N.Ord, contramap((p: Person) => p.age))
 *
 * const sortByNameByAge = RNEA.sortBy([byName, byAge])
 *
 * const persons: RNEA.ReadonlyNonEmptyArray<Person> = [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 },
 *   { name: 'b', age: 2 }
 * ]
 *
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 * @category combinators
 * @since 2.11.0
 */
var sortBy = function (ords) {
    if (isNonEmpty(ords)) {
        var M = getMonoid();
        return sort(ords.reduce(M.concat, M.empty));
    }
    return identity;
};
/**
 * @category combinators
 * @since 2.11.0
 */
var union = function (E) {
    var uniqE = uniq(E);
    return function (second) { return function (first) { return uniqE(pipe(first, concat(second))); }; };
};
/**
 * Rotate a `ReadonlyNonEmptyArray` by `n` steps.
 *
 * @example
 * import { rotate } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(rotate(2)([1, 2, 3, 4, 5]), [4, 5, 1, 2, 3])
 * assert.deepStrictEqual(rotate(-2)([1, 2, 3, 4, 5]), [3, 4, 5, 1, 2])
 *
 * @category combinators
 * @since 2.11.0
 */
var rotate = function (n) { return function (as) {
    var len = as.length;
    var m = Math.round(n) % len;
    if (isOutOfBound(Math.abs(m), as) || m === 0) {
        return as;
    }
    if (m < 0) {
        var _a = splitAt(-m)(as), f = _a[0], s = _a[1];
        return pipe(s, concat(f));
    }
    else {
        return rotate(m - len)(as);
    }
}; };
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Return a `ReadonlyNonEmptyArray` from a `ReadonlyArray` returning `none` if the input is empty.
 *
 * @category constructors
 * @since 2.5.0
 */
var fromReadonlyArray = function (as) {
    return isNonEmpty(as) ? _.some(as) : _.none;
};
/**
 * Return a `ReadonlyNonEmptyArray` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to a natural number.
 *
 * @example
 * import { makeBy } from 'fp-ts/ReadonlyNonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const double = (n: number): number => n * 2
 * assert.deepStrictEqual(pipe(5, makeBy(double)), [0, 2, 4, 6, 8])
 *
 * @category constructors
 * @since 2.11.0
 */
var makeBy = function (f) { return function (n) {
    var j = Math.max(0, Math.floor(n));
    var out = [f(0)];
    for (var i = 1; i < j; i++) {
        out.push(f(i));
    }
    return out;
}; };
/**
 * Create a `ReadonlyNonEmptyArray` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to a natural number.
 *
 * @example
 * import { replicate } from 'fp-ts/ReadonlyNonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(3, replicate('a')), ['a', 'a', 'a'])
 *
 * @category constructors
 * @since 2.11.0
 */
var replicate = function (a) { return makeBy(function () { return a; }); };
/**
 * Create a `ReadonlyNonEmptyArray` containing a range of integers, including both endpoints.
 *
 * @example
 * import { range } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(range(1, 5), [1, 2, 3, 4, 5])
 *
 * @category constructors
 * @since 2.11.0
 */
var range = function (start, end) {
    return start <= end ? makeBy(function (i) { return start + i; })(end - start + 1) : [start];
};
// -------------------------------------------------------------------------------------
// destructors
// -------------------------------------------------------------------------------------
/**
 * Return the tuple of the `head` and the `tail`.
 *
 * @example
 * import { unprepend } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(unprepend([1, 2, 3, 4]), [1, [2, 3, 4]])
 *
 * @category destructors
 * @since 2.9.0
 */
var unprepend = function (as) { return [head(as), tail(as)]; };
/**
 * Return the tuple of the `init` and the `last`.
 *
 * @example
 * import { unappend } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(unappend([1, 2, 3, 4]), [[1, 2, 3], 4])
 *
 * @category destructors
 * @since 2.9.0
 */
var unappend = function (as) { return [init(as), ReadonlyNonEmptyArray_last(as)]; };
// -------------------------------------------------------------------------------------
// interop
// -------------------------------------------------------------------------------------
/**
 * @category interop
 * @since 2.5.0
 */
var fromArray = function (as) { return fromReadonlyArray(as.slice()); };
function concatW(second) {
    return function (first) { return first.concat(second); };
}
function concat(x, y) {
    return y ? x.concat(y) : function (y) { return y.concat(x); };
}
/**
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyNonEmptyArray_reverse = function (as) {
    return as.length === 1 ? as : __spreadArray([ReadonlyNonEmptyArray_last(as)], as.slice(0, -1).reverse());
};
function group(E) {
    return function (as) {
        var len = as.length;
        if (len === 0) {
            return ReadonlyNonEmptyArray_empty;
        }
        var out = [];
        var head = as[0];
        var nea = [head];
        for (var i = 1; i < len; i++) {
            var a = as[i];
            if (E.equals(a, head)) {
                nea.push(a);
            }
            else {
                out.push(nea);
                head = a;
                nea = [head];
            }
        }
        out.push(nea);
        return out;
    };
}
/**
 * Splits an array into sub-non-empty-arrays stored in an object, based on the result of calling a `string`-returning
 * function on each element, and grouping the results according to values returned
 *
 * @example
 * import { groupBy } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(groupBy((s: string) => String(s.length))(['a', 'b', 'ab']), {
 *   '1': ['a', 'b'],
 *   '2': ['ab']
 * })
 *
 * @category combinators
 * @since 2.5.0
 */
var groupBy = function (f) { return function (as) {
    var out = {};
    for (var _i = 0, as_1 = as; _i < as_1.length; _i++) {
        var a = as_1[_i];
        var k = f(a);
        if (out.hasOwnProperty(k)) {
            out[k].push(a);
        }
        else {
            out[k] = [a];
        }
    }
    return out;
}; };
/**
 * @category combinators
 * @since 2.5.0
 */
var sort = function (O) { return function (as) {
    return as.length === 1 ? as : as.slice().sort(O.compare);
}; };
/**
 * @category combinators
 * @since 2.5.0
 */
var updateAt = function (i, a) {
    return modifyAt(i, function () { return a; });
};
/**
 * @category combinators
 * @since 2.5.0
 */
var modifyAt = function (i, f) { return function (as) { return (isOutOfBound(i, as) ? _.none : _.some(unsafeUpdateAt(i, f(as[i]), as))); }; };
/**
 * @category combinators
 * @since 2.5.1
 */
var zipWith = function (as, bs, f) {
    var cs = [f(as[0], bs[0])];
    var len = Math.min(as.length, bs.length);
    for (var i = 1; i < len; i++) {
        cs[i] = f(as[i], bs[i]);
    }
    return cs;
};
function zip(as, bs) {
    if (bs === undefined) {
        return function (bs) { return zip(bs, as); };
    }
    return zipWith(as, bs, function (a, b) { return [a, b]; });
}
/**
 * @category combinators
 * @since 2.5.1
 */
var unzip = function (abs) {
    var fa = [abs[0][0]];
    var fb = [abs[0][1]];
    for (var i = 1; i < abs.length; i++) {
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [fa, fb];
};
/**
 * Prepend an element to every member of a `ReadonlyNonEmptyArray`.
 *
 * @example
 * import { prependAll } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(prependAll(9)([1, 2, 3, 4]), [9, 1, 9, 2, 9, 3, 9, 4])
 *
 * @category combinators
 * @since 2.10.0
 */
var prependAll = function (middle) { return function (as) {
    var out = [middle, as[0]];
    for (var i = 1; i < as.length; i++) {
        out.push(middle, as[i]);
    }
    return out;
}; };
/**
 * Places an element in between members of a `ReadonlyNonEmptyArray`.
 *
 * @example
 * import { intersperse } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(intersperse(9)([1, 2, 3, 4]), [1, 9, 2, 9, 3, 9, 4])
 *
 * @category combinators
 * @since 2.9.0
 */
var intersperse = function (middle) { return function (as) {
    var rest = tail(as);
    return isNonEmpty(rest) ? pipe(rest, prependAll(middle), prepend(head(as))) : as;
}; };
/**
 * @category combinators
 * @since 2.10.0
 */
var chainWithIndex = function (f) { return function (as) {
    var out = internal/* fromReadonlyNonEmptyArray */.r1(f(0, head(as)));
    for (var i = 1; i < as.length; i++) {
        out.push.apply(out, f(i, as[i]));
    }
    return out;
}; };
/**
 * A useful recursion pattern for processing a `ReadonlyNonEmptyArray` to produce a new `ReadonlyNonEmptyArray`, often used for "chopping" up the input
 * `ReadonlyNonEmptyArray`. Typically `chop` is called with some function that will consume an initial prefix of the `ReadonlyNonEmptyArray` and produce a
 * value and the tail of the `ReadonlyNonEmptyArray`.
 *
 * @category combinators
 * @since 2.10.0
 */
var chop = function (f) { return function (as) {
    var _a = f(as), b = _a[0], rest = _a[1];
    var out = [b];
    var next = rest;
    while (isNonEmpty(next)) {
        var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
        out.push(b_1);
        next = rest_2;
    }
    return out;
}; };
/**
 * Splits a `ReadonlyNonEmptyArray` into two pieces, the first piece has max `n` elements.
 *
 * @category combinators
 * @since 2.10.0
 */
var splitAt = function (n) { return function (as) {
    var m = Math.max(1, n);
    return m >= as.length ? [as, ReadonlyNonEmptyArray_empty] : [pipe(as.slice(1, m), prepend(head(as))), as.slice(m)];
}; };
/**
 * Splits a `ReadonlyNonEmptyArray` into length-`n` pieces. The last piece will be shorter if `n` does not evenly divide the length of
 * the `ReadonlyNonEmptyArray`.
 *
 * @category combinators
 * @since 2.10.0
 */
var chunksOf = function (n) { return chop(splitAt(n)); };
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var _map = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, map(f)); };
/* istanbul ignore next */
var _mapWithIndex = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, mapWithIndex(f)); };
var _ap = function (fab, fa) { return (0,es6_function/* pipe */.zG)(fab, ap(fa)); };
var _chain = function (ma, f) { return (0,es6_function/* pipe */.zG)(ma, chain(f)); };
/* istanbul ignore next */
var _extend = function (wa, f) { return (0,es6_function/* pipe */.zG)(wa, extend(f)); };
/* istanbul ignore next */
var _reduce = function (fa, b, f) { return (0,es6_function/* pipe */.zG)(fa, reduce(b, f)); };
/* istanbul ignore next */
var _foldMap = function (M) {
    var foldMapM = foldMap(M);
    return function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, foldMapM(f)); };
};
/* istanbul ignore next */
var _reduceRight = function (fa, b, f) { return (0,es6_function/* pipe */.zG)(fa, reduceRight(b, f)); };
/* istanbul ignore next */
var _traverse = function (F) {
    var traverseF = traverse(F);
    return function (ta, f) { return (0,es6_function/* pipe */.zG)(ta, traverseF(f)); };
};
/* istanbul ignore next */
var _alt = function (fa, that) { return (0,es6_function/* pipe */.zG)(fa, alt(that)); };
/* istanbul ignore next */
var _reduceWithIndex = function (fa, b, f) {
    return (0,es6_function/* pipe */.zG)(fa, reduceWithIndex(b, f));
};
/* istanbul ignore next */
var _foldMapWithIndex = function (M) {
    var foldMapWithIndexM = foldMapWithIndex(M);
    return function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, foldMapWithIndexM(f)); };
};
/* istanbul ignore next */
var _reduceRightWithIndex = function (fa, b, f) {
    return (0,es6_function/* pipe */.zG)(fa, reduceRightWithIndex(b, f));
};
/* istanbul ignore next */
var _traverseWithIndex = function (F) {
    var traverseWithIndexF = traverseWithIndex(F);
    return function (ta, f) { return (0,es6_function/* pipe */.zG)(ta, traverseWithIndexF(f)); };
};
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * @category Pointed
 * @since 2.5.0
 */
var of = internal/* singleton */.ri;
/**
 * Less strict version of [`alt`](#alt).
 *
 * @category Alt
 * @since 2.9.0
 */
var altW = function (that) { return function (as) { return (0,es6_function/* pipe */.zG)(as, concatW(that())); }; };
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * @category Alt
 * @since 2.6.2
 */
var alt = altW;
/**
 * @category Apply
 * @since 2.5.0
 */
var ap = function (as) { return chain(function (f) { return (0,es6_function/* pipe */.zG)(as, map(f)); }); };
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @category Monad
 * @since 2.5.0
 */
var chain = function (f) { return chainWithIndex(function (_, a) { return f(a); }); };
/**
 * @category Extend
 * @since 2.5.0
 */
var extend = function (f) { return function (as) {
    var next = tail(as);
    var out = [f(as)];
    while (isNonEmpty(next)) {
        out.push(f(next));
        next = tail(next);
    }
    return out;
}; };
/**
 * Derivable from `Extend`.
 *
 * @category combinators
 * @since 2.5.0
 */
var duplicate = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (extend(identity)));
/**
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.5.0
 */
var flatten = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (chain(identity)));
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category Functor
 * @since 2.5.0
 */
var map = function (f) {
    return mapWithIndex(function (_, a) { return f(a); });
};
/**
 * @category FunctorWithIndex
 * @since 2.5.0
 */
var mapWithIndex = function (f) { return function (as) {
    var out = [f(0, head(as))];
    for (var i = 1; i < as.length; i++) {
        out.push(f(i, as[i]));
    }
    return out;
}; };
/**
 * @category Foldable
 * @since 2.5.0
 */
var reduce = function (b, f) {
    return reduceWithIndex(b, function (_, b, a) { return f(b, a); });
};
/**
 * **Note**. The constraint is relaxed: a `Semigroup` instead of a `Monoid`.
 *
 * @category Foldable
 * @since 2.5.0
 */
var foldMap = function (S) { return function (f) { return function (as) {
    return as.slice(1).reduce(function (s, a) { return S.concat(s, f(a)); }, f(as[0]));
}; }; };
/**
 * @category Foldable
 * @since 2.5.0
 */
var reduceRight = function (b, f) {
    return reduceRightWithIndex(b, function (_, b, a) { return f(b, a); });
};
/**
 * @category FoldableWithIndex
 * @since 2.5.0
 */
var reduceWithIndex = function (b, f) { return function (as) {
    return as.reduce(function (b, a, i) { return f(i, b, a); }, b);
}; };
/**
 * **Note**. The constraint is relaxed: a `Semigroup` instead of a `Monoid`.
 *
 * @category FoldableWithIndex
 * @since 2.5.0
 */
var foldMapWithIndex = function (S) { return function (f) { return function (as) { return as.slice(1).reduce(function (s, a, i) { return S.concat(s, f(i + 1, a)); }, f(0, as[0])); }; }; };
/**
 * @category FoldableWithIndex
 * @since 2.5.0
 */
var reduceRightWithIndex = function (b, f) { return function (as) { return as.reduceRight(function (b, a, i) { return f(i, a, b); }, b); }; };
/**
 * @category Traversable
 * @since 2.6.3
 */
var traverse = function (F) {
    var traverseWithIndexF = traverseWithIndex(F);
    return function (f) { return traverseWithIndexF(function (_, a) { return f(a); }); };
};
/**
 * @category Traversable
 * @since 2.6.3
 */
var sequence = function (F) { return traverseWithIndex(F)(es6_function.SK); };
/**
 * @category TraversableWithIndex
 * @since 2.6.3
 */
var traverseWithIndex = function (F) { return function (f) { return function (as) {
    var out = F.map(f(0, head(as)), of);
    for (var i = 1; i < as.length; i++) {
        out = F.ap(F.map(out, function (bs) { return function (b) { return (0,es6_function/* pipe */.zG)(bs, append(b)); }; }), f(i, as[i]));
    }
    return out;
}; }; };
/**
 * @category Comonad
 * @since 2.6.3
 */
var extract = internal/* head */.YM;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.5.0
 */
var ReadonlyNonEmptyArray_URI = 'ReadonlyNonEmptyArray';
/**
 * @category instances
 * @since 2.5.0
 */
var getShow = function (S) { return ({
    show: function (as) { return "[" + as.map(S.show).join(', ') + "]"; }
}); };
/**
 * Builds a `Semigroup` instance for `ReadonlyNonEmptyArray`
 *
 * @category instances
 * @since 2.5.0
 */
var ReadonlyNonEmptyArray_getSemigroup = function () { return ({
    concat: concat
}); };
/**
 * @example
 * import { getEq } from 'fp-ts/ReadonlyNonEmptyArray'
 * import * as N from 'fp-ts/number'
 *
 * const E = getEq(N.Eq)
 * assert.strictEqual(E.equals([1, 2], [1, 2]), true)
 * assert.strictEqual(E.equals([1, 2], [1, 3]), false)
 *
 * @category instances
 * @since 2.5.0
 */
var getEq = function (E) {
    return fromEquals(function (xs, ys) { return xs.length === ys.length && xs.every(function (x, i) { return E.equals(x, ys[i]); }); });
};
/**
 * @category combinators
 * @since 2.11.0
 */
var getUnionSemigroup = function (E) {
    var unionE = union(E);
    return {
        concat: function (first, second) { return unionE(second)(first); }
    };
};
/**
 * @category instances
 * @since 2.7.0
 */
var Functor = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map
};
/**
 * Derivable from `Functor`.
 *
 * @category combinators
 * @since 2.10.0
 */
var flap = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (flap_(Functor)));
/**
 * @category instances
 * @since 2.10.0
 */
var Pointed = {
    URI: ReadonlyNonEmptyArray_URI,
    of: of
};
/**
 * @category instances
 * @since 2.7.0
 */
var FunctorWithIndex = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    mapWithIndex: _mapWithIndex
};
/**
 * @category instances
 * @since 2.10.0
 */
var Apply = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    ap: _ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.5.0
 */
var apFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apFirst_(Apply)));
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.5.0
 */
var apSecond = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apSecond_(Apply)));
/**
 * @category instances
 * @since 2.7.0
 */
var Applicative = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    ap: _ap,
    of: of
};
/**
 * @category instances
 * @since 2.10.0
 */
var Chain = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    ap: _ap,
    chain: _chain
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.5.0
 */
var chainFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (chainFirst_(Chain)));
/**
 * @category instances
 * @since 2.7.0
 */
var Monad = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    ap: _ap,
    of: of,
    chain: _chain
};
/**
 * @category instances
 * @since 2.7.0
 */
var Foldable = {
    URI: ReadonlyNonEmptyArray_URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */
var FoldableWithIndex = {
    URI: ReadonlyNonEmptyArray_URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */
var Traversable = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: sequence
};
/**
 * @category instances
 * @since 2.7.0
 */
var TraversableWithIndex = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: sequence,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverseWithIndex: _traverseWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */
var Alt = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    alt: _alt
};
/**
 * @category instances
 * @since 2.7.0
 */
var Comonad = {
    URI: ReadonlyNonEmptyArray_URI,
    map: _map,
    extend: _extend,
    extract: extract
};
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @since 2.9.0
 */
var Do = 
/*#__PURE__*/
of(internal/* emptyRecord */.F4);
/**
 * @since 2.8.0
 */
var bindTo = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bindTo_(Functor)));
/**
 * @since 2.8.0
 */
var bind = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bind_(Chain)));
// -------------------------------------------------------------------------------------
// pipeable sequence S
// -------------------------------------------------------------------------------------
/**
 * @since 2.8.0
 */
var apS = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apS_(Apply)));
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.5.0
 */
var head = extract;
/**
 * @since 2.5.0
 */
var tail = internal/* tail */.Gb;
/**
 * @since 2.5.0
 */
var ReadonlyNonEmptyArray_last = function (as) { return as[as.length - 1]; };
/**
 * Get all but the last element of a non empty array, creating a new array.
 *
 * @example
 * import { init } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), [1, 2])
 * assert.deepStrictEqual(init([1]), [])
 *
 * @since 2.5.0
 */
var init = function (as) { return as.slice(0, -1); };
/**
 * @since 2.5.0
 */
var ReadonlyNonEmptyArray_min = function (O) {
    var S = Semigroup_min(O);
    return function (as) { return as.reduce(S.concat); };
};
/**
 * @since 2.5.0
 */
var ReadonlyNonEmptyArray_max = function (O) {
    var S = Semigroup_max(O);
    return function (as) { return as.reduce(S.concat); };
};
/**
 * @since 2.10.0
 */
var ReadonlyNonEmptyArray_concatAll = function (S) { return function (as) { return as.reduce(S.concat); }; };
/**
 * Break a `ReadonlyArray` into its first element and remaining elements.
 *
 * @category destructors
 * @since 2.11.0
 */
var matchLeft = function (f) { return function (as) {
    return f(head(as), tail(as));
}; };
/**
 * Break a `ReadonlyArray` into its initial elements and the last element.
 *
 * @category destructors
 * @since 2.11.0
 */
var matchRight = function (f) { return function (as) {
    return f(init(as), ReadonlyNonEmptyArray_last(as));
}; };
/**
 * Apply a function to the head, creating a new `ReadonlyNonEmptyArray`.
 *
 * @since 2.11.0
 */
var modifyHead = function (f) { return function (as) { return __spreadArray([
    f(head(as))
], tail(as)); }; };
/**
 * Change the head, creating a new `ReadonlyNonEmptyArray`.
 *
 * @category combinators
 * @since 2.11.0
 */
var updateHead = function (a) { return modifyHead(function () { return a; }); };
/**
 * Apply a function to the last element, creating a new `ReadonlyNonEmptyArray`.
 *
 * @since 2.11.0
 */
var modifyLast = function (f) { return function (as) {
    return pipe(init(as), append(f(ReadonlyNonEmptyArray_last(as))));
}; };
/**
 * Change the last element, creating a new `ReadonlyNonEmptyArray`.
 *
 * @category combinators
 * @since 2.11.0
 */
var updateLast = function (a) { return modifyLast(function () { return a; }); };
function groupSort(O) {
    var sortO = sort(O);
    var groupO = group(O);
    return function (as) { return (isNonEmpty(as) ? groupO(sortO(as)) : ReadonlyNonEmptyArray_empty); };
}
function filter(predicate) {
    return filterWithIndex(function (_, a) { return predicate(a); });
}
/**
 * Use [`filterWithIndex`](./ReadonlyArray.ts.html#filterwithindex) instead.
 *
 * @category combinators
 * @since 2.5.0
 * @deprecated
 */
var filterWithIndex = function (predicate) { return function (as) { return fromReadonlyArray(as.filter(function (a, i) { return predicate(i, a); })); }; };
/**
 * Use [`unprepend`](#unprepend) instead.
 *
 * @category destructors
 * @since 2.10.0
 * @deprecated
 */
var uncons = (/* unused pure expression or super */ null && (unprepend));
/**
 * Use [`unappend`](#unappend) instead.
 *
 * @category destructors
 * @since 2.10.0
 * @deprecated
 */
var unsnoc = (/* unused pure expression or super */ null && (unappend));
function cons(head, tail) {
    return tail === undefined ? prepend(head) : (0,es6_function/* pipe */.zG)(tail, prepend(head));
}
/**
 * Use [`append`](./ReadonlyArray.ts.html#append) instead.
 *
 * @category constructors
 * @since 2.5.0
 * @deprecated
 */
var snoc = function (init, end) { return (0,es6_function/* pipe */.zG)(init, concat([end])); };
/**
 * Use [`insertAt`](./ReadonlyArray.ts.html#insertat) instead.
 *
 * @category combinators
 * @since 2.5.0
 * @deprecated
 */
var insertAt = function (i, a) { return function (as) {
    return i < 0 || i > as.length ? _.none : _.some(unsafeInsertAt(i, a, as));
}; };
/**
 * Use [`prependAll`](#prependall) instead.
 *
 * @category combinators
 * @since 2.9.0
 * @deprecated
 */
var prependToAll = (/* unused pure expression or super */ null && (prependAll));
/**
 * Use [`concatAll`](#concatall) instead.
 *
 * @since 2.5.0
 * @deprecated
 */
var ReadonlyNonEmptyArray_fold = (/* unused pure expression or super */ null && (ReadonlyNonEmptyArray_concatAll));
/**
 * Use small, specific instances instead.
 *
 * @category instances
 * @since 2.5.0
 * @deprecated
 */
var readonlyNonEmptyArray = {
    URI: ReadonlyNonEmptyArray_URI,
    of: of,
    map: _map,
    mapWithIndex: _mapWithIndex,
    ap: _ap,
    chain: _chain,
    extend: _extend,
    extract: extract,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: sequence,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverseWithIndex: _traverseWithIndex,
    alt: _alt
};

;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/NonEmptyArray.js
var NonEmptyArray_spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};







// -------------------------------------------------------------------------------------
// internal
// -------------------------------------------------------------------------------------
/**
 * @internal
 */
var NonEmptyArray_isNonEmpty = function (as) { return as.length > 0; };
/**
 * @internal
 */
var NonEmptyArray_isOutOfBound = function (i, as) { return i < 0 || i >= as.length; };
/**
 * @internal
 */
var NonEmptyArray_prependW = function (head) { return function (tail) { return NonEmptyArray_spreadArray([head], tail); }; };
/**
 * @internal
 */
var NonEmptyArray_prepend = NonEmptyArray_prependW;
/**
 * @internal
 */
var NonEmptyArray_appendW = function (end) { return function (init) { return NonEmptyArray_spreadArray(NonEmptyArray_spreadArray([], init), [end]); }; };
/**
 * @internal
 */
var NonEmptyArray_append = NonEmptyArray_appendW;
/**
 * @internal
 */
var NonEmptyArray_unsafeInsertAt = function (i, a, as) {
    if (NonEmptyArray_isNonEmpty(as)) {
        var xs = fromReadonlyNonEmptyArray(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [a];
};
/**
 * @internal
 */
var NonEmptyArray_unsafeUpdateAt = function (i, a, as) {
    var xs = fromReadonlyNonEmptyArray(as);
    xs[i] = a;
    return xs;
};
/**
 * Remove duplicates from a `NonEmptyArray`, keeping the first occurrence of an element.
 *
 * @example
 * import { uniq } from 'fp-ts/NonEmptyArray'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(uniq(N.Eq)([1, 2, 1]), [1, 2])
 *
 * @category combinators
 * @since 2.11.0
 */
var NonEmptyArray_uniq = function (E) { return function (as) {
    if (as.length === 1) {
        return copy(as);
    }
    var out = [NonEmptyArray_head(as)];
    var rest = NonEmptyArray_tail(as);
    var _loop_1 = function (a) {
        if (out.every(function (o) { return !E.equals(o, a); })) {
            out.push(a);
        }
    };
    for (var _i = 0, rest_1 = rest; _i < rest_1.length; _i++) {
        var a = rest_1[_i];
        _loop_1(a);
    }
    return out;
}; };
/**
 * Sort the elements of a `NonEmptyArray` in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import * as NEA from 'fp-ts/NonEmptyArray'
 * import { contramap } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Person {
 *   name: string
 *   age: number
 * }
 *
 * const byName = pipe(S.Ord, contramap((p: Person) => p.name))
 *
 * const byAge = pipe(N.Ord, contramap((p: Person) => p.age))
 *
 * const sortByNameByAge = NEA.sortBy([byName, byAge])
 *
 * const persons: NEA.NonEmptyArray<Person> = [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 },
 *   { name: 'b', age: 2 }
 * ]
 *
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 * @category combinators
 * @since 2.11.0
 */
var NonEmptyArray_sortBy = function (ords) {
    if (NonEmptyArray_isNonEmpty(ords)) {
        var M = getMonoid();
        return NonEmptyArray_sort(ords.reduce(M.concat, M.empty));
    }
    return copy;
};
/**
 * @category combinators
 * @since 2.11.0
 */
var NonEmptyArray_union = function (E) {
    var uniqE = NonEmptyArray_uniq(E);
    return function (second) { return function (first) { return uniqE(pipe(first, NonEmptyArray_concat(second))); }; };
};
/**
 * Rotate a `NonEmptyArray` by `n` steps.
 *
 * @example
 * import { rotate } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(rotate(2)([1, 2, 3, 4, 5]), [4, 5, 1, 2, 3])
 * assert.deepStrictEqual(rotate(-2)([1, 2, 3, 4, 5]), [3, 4, 5, 1, 2])
 *
 * @category combinators
 * @since 2.11.0
 */
var NonEmptyArray_rotate = function (n) { return function (as) {
    var len = as.length;
    var m = Math.round(n) % len;
    if (NonEmptyArray_isOutOfBound(Math.abs(m), as) || m === 0) {
        return copy(as);
    }
    if (m < 0) {
        var _a = NonEmptyArray_splitAt(-m)(as), f = _a[0], s = _a[1];
        return pipe(s, NonEmptyArray_concat(f));
    }
    else {
        return NonEmptyArray_rotate(m - len)(as);
    }
}; };
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.10.0
 */
var fromReadonlyNonEmptyArray = internal/* fromReadonlyNonEmptyArray */.r1;
/**
 * Builds a `NonEmptyArray` from an `Array` returning `none` if `as` is an empty array
 *
 * @category constructors
 * @since 2.0.0
 */
var NonEmptyArray_fromArray = function (as) { return (NonEmptyArray_isNonEmpty(as) ? _.some(as) : _.none); };
/**
 * Return a `NonEmptyArray` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to a natural number.
 *
 * @example
 * import { makeBy } from 'fp-ts/NonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const double = (n: number): number => n * 2
 * assert.deepStrictEqual(pipe(5, makeBy(double)), [0, 2, 4, 6, 8])
 *
 * @category constructors
 * @since 2.11.0
 */
var NonEmptyArray_makeBy = function (f) { return function (n) {
    var j = Math.max(0, Math.floor(n));
    var out = [f(0)];
    for (var i = 1; i < j; i++) {
        out.push(f(i));
    }
    return out;
}; };
/**
 * Create a `NonEmptyArray` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to a natural number.
 *
 * @example
 * import { replicate } from 'fp-ts/NonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(3, replicate('a')), ['a', 'a', 'a'])
 *
 * @category constructors
 * @since 2.11.0
 */
var NonEmptyArray_replicate = function (a) { return NonEmptyArray_makeBy(function () { return a; }); };
/**
 * Create a `NonEmptyArray` containing a range of integers, including both endpoints.
 *
 * @example
 * import { range } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(range(1, 5), [1, 2, 3, 4, 5])
 *
 * @category constructors
 * @since 2.11.0
 */
var NonEmptyArray_range = function (start, end) {
    return start <= end ? NonEmptyArray_makeBy(function (i) { return start + i; })(end - start + 1) : [start];
};
// -------------------------------------------------------------------------------------
// destructors
// -------------------------------------------------------------------------------------
/**
 * Return the tuple of the `head` and the `tail`.
 *
 * @example
 * import { unprepend } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(unprepend([1, 2, 3]), [1, [2, 3]])
 *
 * @category destructors
 * @since 2.9.0
 */
var NonEmptyArray_unprepend = function (as) { return [NonEmptyArray_head(as), NonEmptyArray_tail(as)]; };
/**
 * Return the tuple of the `init` and the `last`.
 *
 * @example
 * import { unappend } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(unappend([1, 2, 3, 4]), [[1, 2, 3], 4])
 *
 * @category destructors
 * @since 2.9.0
 */
var NonEmptyArray_unappend = function (as) { return [NonEmptyArray_init(as), NonEmptyArray_last(as)]; };
function NonEmptyArray_concatW(second) {
    return function (first) { return first.concat(second); };
}
function NonEmptyArray_concat(x, y) {
    return y ? x.concat(y) : function (y) { return y.concat(x); };
}
/**
 * @category combinators
 * @since 2.0.0
 */
var NonEmptyArray_reverse = function (as) { return NonEmptyArray_spreadArray([NonEmptyArray_last(as)], as.slice(0, -1).reverse()); };
function NonEmptyArray_group(E) {
    return function (as) {
        var len = as.length;
        if (len === 0) {
            return [];
        }
        var out = [];
        var head = as[0];
        var nea = [head];
        for (var i = 1; i < len; i++) {
            var a = as[i];
            if (E.equals(a, head)) {
                nea.push(a);
            }
            else {
                out.push(nea);
                head = a;
                nea = [head];
            }
        }
        out.push(nea);
        return out;
    };
}
/**
 * Splits an array into sub-non-empty-arrays stored in an object, based on the result of calling a `string`-returning
 * function on each element, and grouping the results according to values returned
 *
 * @example
 * import { groupBy } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(groupBy((s: string) => String(s.length))(['a', 'b', 'ab']), {
 *   '1': ['a', 'b'],
 *   '2': ['ab']
 * })
 *
 * @category combinators
 * @since 2.0.0
 */
var NonEmptyArray_groupBy = function (f) { return function (as) {
    var out = {};
    for (var _i = 0, as_1 = as; _i < as_1.length; _i++) {
        var a = as_1[_i];
        var k = f(a);
        if (out.hasOwnProperty(k)) {
            out[k].push(a);
        }
        else {
            out[k] = [a];
        }
    }
    return out;
}; };
/**
 * @category combinators
 * @since 2.0.0
 */
var NonEmptyArray_sort = function (O) { return function (as) {
    return as.slice().sort(O.compare);
}; };
/**
 * @category combinators
 * @since 2.0.0
 */
var NonEmptyArray_insertAt = function (i, a) { return function (as) {
    return i < 0 || i > as.length ? _.none : _.some(NonEmptyArray_unsafeInsertAt(i, a, as));
}; };
/**
 * @category combinators
 * @since 2.0.0
 */
var NonEmptyArray_updateAt = function (i, a) {
    return NonEmptyArray_modifyAt(i, function () { return a; });
};
/**
 * @category combinators
 * @since 2.0.0
 */
var NonEmptyArray_modifyAt = function (i, f) { return function (as) {
    return NonEmptyArray_isOutOfBound(i, as) ? _.none : _.some(NonEmptyArray_unsafeUpdateAt(i, f(as[i]), as));
}; };
/**
 * @category combinators
 * @since 2.0.0
 */
var copy = (/* unused pure expression or super */ null && (fromReadonlyNonEmptyArray));
/**
 * @category Pointed
 * @since 2.0.0
 */
var NonEmptyArray_of = function (a) { return [a]; };
/**
 * @category combinators
 * @since 2.5.1
 */
var NonEmptyArray_zipWith = function (as, bs, f) {
    var cs = [f(as[0], bs[0])];
    var len = Math.min(as.length, bs.length);
    for (var i = 1; i < len; i++) {
        cs[i] = f(as[i], bs[i]);
    }
    return cs;
};
function NonEmptyArray_zip(as, bs) {
    if (bs === undefined) {
        return function (bs) { return NonEmptyArray_zip(bs, as); };
    }
    return NonEmptyArray_zipWith(as, bs, function (a, b) { return [a, b]; });
}
/**
 * @category combinators
 * @since 2.5.1
 */
var NonEmptyArray_unzip = function (abs) {
    var fa = [abs[0][0]];
    var fb = [abs[0][1]];
    for (var i = 1; i < abs.length; i++) {
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [fa, fb];
};
/**
 * Prepend an element to every member of an array
 *
 * @example
 * import { prependAll } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(prependAll(9)([1, 2, 3, 4]), [9, 1, 9, 2, 9, 3, 9, 4])
 *
 * @category combinators
 * @since 2.10.0
 */
var NonEmptyArray_prependAll = function (middle) { return function (as) {
    var out = [middle, as[0]];
    for (var i = 1; i < as.length; i++) {
        out.push(middle, as[i]);
    }
    return out;
}; };
/**
 * Places an element in between members of an array
 *
 * @example
 * import { intersperse } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(intersperse(9)([1, 2, 3, 4]), [1, 9, 2, 9, 3, 9, 4])
 *
 * @category combinators
 * @since 2.9.0
 */
var NonEmptyArray_intersperse = function (middle) { return function (as) {
    var rest = NonEmptyArray_tail(as);
    return NonEmptyArray_isNonEmpty(rest) ? pipe(rest, NonEmptyArray_prependAll(middle), NonEmptyArray_prepend(NonEmptyArray_head(as))) : copy(as);
}; };
/**
 * @category combinators
 * @since 2.0.0
 */
var NonEmptyArray_foldMapWithIndex = foldMapWithIndex;
/**
 * @category combinators
 * @since 2.0.0
 */
var NonEmptyArray_foldMap = foldMap;
/**
 * @category combinators
 * @since 2.10.0
 */
var NonEmptyArray_chainWithIndex = function (f) { return function (as) {
    var out = fromReadonlyNonEmptyArray(f(0, NonEmptyArray_head(as)));
    for (var i = 1; i < as.length; i++) {
        out.push.apply(out, f(i, as[i]));
    }
    return out;
}; };
/**
 * @category combinators
 * @since 2.10.0
 */
var NonEmptyArray_chop = function (f) { return function (as) {
    var _a = f(as), b = _a[0], rest = _a[1];
    var out = [b];
    var next = rest;
    while (NonEmptyArray_isNonEmpty(next)) {
        var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
        out.push(b_1);
        next = rest_2;
    }
    return out;
}; };
/**
 * Splits a `NonEmptyArray` into two pieces, the first piece has max `n` elements.
 *
 * @category combinators
 * @since 2.10.0
 */
var NonEmptyArray_splitAt = function (n) { return function (as) {
    var m = Math.max(1, n);
    return m >= as.length ? [copy(as), []] : [pipe(as.slice(1, m), NonEmptyArray_prepend(NonEmptyArray_head(as))), as.slice(m)];
}; };
/**
 * @category combinators
 * @since 2.10.0
 */
var NonEmptyArray_chunksOf = function (n) { return NonEmptyArray_chop(NonEmptyArray_splitAt(n)); };
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
/* istanbul ignore next */
var NonEmptyArray_map = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_NonEmptyArray_map(f)); };
/* istanbul ignore next */
var NonEmptyArray_mapWithIndex = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_NonEmptyArray_mapWithIndex(f)); };
/* istanbul ignore next */
var NonEmptyArray_ap = function (fab, fa) { return (0,es6_function/* pipe */.zG)(fab, es6_NonEmptyArray_ap(fa)); };
/* istanbul ignore next */
var NonEmptyArray_chain = function (ma, f) { return (0,es6_function/* pipe */.zG)(ma, es6_NonEmptyArray_chain(f)); };
/* istanbul ignore next */
var NonEmptyArray_extend = function (wa, f) { return (0,es6_function/* pipe */.zG)(wa, es6_NonEmptyArray_extend(f)); };
/* istanbul ignore next */
var NonEmptyArray_reduce = function (fa, b, f) { return (0,es6_function/* pipe */.zG)(fa, es6_NonEmptyArray_reduce(b, f)); };
/* istanbul ignore next */
var es6_NonEmptyArray_foldMap = function (M) {
    var foldMapM = NonEmptyArray_foldMap(M);
    return function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, foldMapM(f)); };
};
/* istanbul ignore next */
var NonEmptyArray_reduceRight = function (fa, b, f) { return (0,es6_function/* pipe */.zG)(fa, es6_NonEmptyArray_reduceRight(b, f)); };
/* istanbul ignore next */
var NonEmptyArray_traverse = function (F) {
    var traverseF = es6_NonEmptyArray_traverse(F);
    return function (ta, f) { return (0,es6_function/* pipe */.zG)(ta, traverseF(f)); };
};
/* istanbul ignore next */
var NonEmptyArray_alt = function (fa, that) { return (0,es6_function/* pipe */.zG)(fa, es6_NonEmptyArray_alt(that)); };
/* istanbul ignore next */
var NonEmptyArray_reduceWithIndex = function (fa, b, f) {
    return (0,es6_function/* pipe */.zG)(fa, es6_NonEmptyArray_reduceWithIndex(b, f));
};
/* istanbul ignore next */
var es6_NonEmptyArray_foldMapWithIndex = function (M) {
    var foldMapWithIndexM = NonEmptyArray_foldMapWithIndex(M);
    return function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, foldMapWithIndexM(f)); };
};
/* istanbul ignore next */
var NonEmptyArray_reduceRightWithIndex = function (fa, b, f) {
    return (0,es6_function/* pipe */.zG)(fa, es6_NonEmptyArray_reduceRightWithIndex(b, f));
};
/* istanbul ignore next */
var NonEmptyArray_traverseWithIndex = function (F) {
    var traverseWithIndexF = es6_NonEmptyArray_traverseWithIndex(F);
    return function (ta, f) { return (0,es6_function/* pipe */.zG)(ta, traverseWithIndexF(f)); };
};
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * Less strict version of [`alt`](#alt).
 *
 * @category Alt
 * @since 2.9.0
 */
var NonEmptyArray_altW = function (that) { return function (as) {
    return (0,es6_function/* pipe */.zG)(as, NonEmptyArray_concatW(that()));
}; };
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * @category Alt
 * @since 2.6.2
 */
var es6_NonEmptyArray_alt = NonEmptyArray_altW;
/**
 * Apply a function to an argument under a type constructor.
 *
 * @category Apply
 * @since 2.0.0
 */
var es6_NonEmptyArray_ap = function (as) {
    return es6_NonEmptyArray_chain(function (f) { return (0,es6_function/* pipe */.zG)(as, es6_NonEmptyArray_map(f)); });
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @category Monad
 * @since 2.0.0
 */
var es6_NonEmptyArray_chain = function (f) {
    return NonEmptyArray_chainWithIndex(function (_, a) { return f(a); });
};
/**
 * @category Extend
 * @since 2.0.0
 */
var es6_NonEmptyArray_extend = function (f) { return function (as) {
    var next = NonEmptyArray_tail(as);
    var out = [f(as)];
    while (NonEmptyArray_isNonEmpty(next)) {
        out.push(f(next));
        next = NonEmptyArray_tail(next);
    }
    return out;
}; };
/**
 * Derivable from `Extend`.
 *
 * @category combinators
 * @since 2.5.0
 */
var NonEmptyArray_duplicate = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (es6_NonEmptyArray_extend(identity)));
/**
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.5.0
 */
var NonEmptyArray_flatten = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (es6_NonEmptyArray_chain(identity)));
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category Functor
 * @since 2.0.0
 */
var es6_NonEmptyArray_map = function (f) { return es6_NonEmptyArray_mapWithIndex(function (_, a) { return f(a); }); };
/**
 * @category FunctorWithIndex
 * @since 2.0.0
 */
var es6_NonEmptyArray_mapWithIndex = function (f) { return function (as) {
    var out = [f(0, NonEmptyArray_head(as))];
    for (var i = 1; i < as.length; i++) {
        out.push(f(i, as[i]));
    }
    return out;
}; };
/**
 * @category Foldable
 * @since 2.0.0
 */
var es6_NonEmptyArray_reduce = reduce;
/**
 * @category FoldableWithIndex
 * @since 2.0.0
 */
var es6_NonEmptyArray_reduceWithIndex = reduceWithIndex;
/**
 * @category Foldable
 * @since 2.0.0
 */
var es6_NonEmptyArray_reduceRight = reduceRight;
/**
 * @category FoldableWithIndex
 * @since 2.0.0
 */
var es6_NonEmptyArray_reduceRightWithIndex = reduceRightWithIndex;
/**
 * @since 2.6.3
 */
var es6_NonEmptyArray_traverse = function (F) {
    var traverseWithIndexF = es6_NonEmptyArray_traverseWithIndex(F);
    return function (f) { return traverseWithIndexF(function (_, a) { return f(a); }); };
};
/**
 * @since 2.6.3
 */
var NonEmptyArray_sequence = function (F) { return es6_NonEmptyArray_traverseWithIndex(F)(function (_, a) { return a; }); };
/**
 * @since 2.6.3
 */
var es6_NonEmptyArray_traverseWithIndex = function (F) { return function (f) { return function (as) {
    var out = F.map(f(0, NonEmptyArray_head(as)), NonEmptyArray_of);
    for (var i = 1; i < as.length; i++) {
        out = F.ap(F.map(out, function (bs) { return function (b) { return (0,es6_function/* pipe */.zG)(bs, NonEmptyArray_append(b)); }; }), f(i, as[i]));
    }
    return out;
}; }; };
/**
 * @since 2.7.0
 */
var NonEmptyArray_extract = head;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.0.0
 */
var NonEmptyArray_URI = 'NonEmptyArray';
/**
 * @category instances
 * @since 2.0.0
 */
var NonEmptyArray_getShow = getShow;
/**
 * Builds a `Semigroup` instance for `NonEmptyArray`
 *
 * @category instances
 * @since 2.0.0
 */
var NonEmptyArray_getSemigroup = function () { return ({
    concat: NonEmptyArray_concat
}); };
/**
 * @example
 * import { getEq } from 'fp-ts/NonEmptyArray'
 * import * as N from 'fp-ts/number'
 *
 * const E = getEq(N.Eq)
 * assert.strictEqual(E.equals([1, 2], [1, 2]), true)
 * assert.strictEqual(E.equals([1, 2], [1, 3]), false)
 *
 * @category instances
 * @since 2.0.0
 */
var NonEmptyArray_getEq = getEq;
/**
 * @category combinators
 * @since 2.11.0
 */
var NonEmptyArray_getUnionSemigroup = function (E) {
    var unionE = NonEmptyArray_union(E);
    return {
        concat: function (first, second) { return unionE(second)(first); }
    };
};
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_Functor = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map
};
/**
 * Derivable from `Functor`.
 *
 * @category combinators
 * @since 2.10.0
 */
var NonEmptyArray_flap = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (flap_(NonEmptyArray_Functor)));
/**
 * @category instances
 * @since 2.10.0
 */
var NonEmptyArray_Pointed = {
    URI: NonEmptyArray_URI,
    of: NonEmptyArray_of
};
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_FunctorWithIndex = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    mapWithIndex: NonEmptyArray_mapWithIndex
};
/**
 * @category instances
 * @since 2.10.0
 */
var NonEmptyArray_Apply = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    ap: NonEmptyArray_ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.5.0
 */
var NonEmptyArray_apFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apFirst_(NonEmptyArray_Apply)));
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.5.0
 */
var NonEmptyArray_apSecond = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apSecond_(NonEmptyArray_Apply)));
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_Applicative = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    ap: NonEmptyArray_ap,
    of: NonEmptyArray_of
};
/**
 * @category instances
 * @since 2.10.0
 */
var NonEmptyArray_Chain = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    ap: NonEmptyArray_ap,
    chain: NonEmptyArray_chain
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.5.0
 */
var NonEmptyArray_chainFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (chainFirst_(NonEmptyArray_Chain)));
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_Monad = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    ap: NonEmptyArray_ap,
    of: NonEmptyArray_of,
    chain: NonEmptyArray_chain
};
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_Foldable = {
    URI: NonEmptyArray_URI,
    reduce: NonEmptyArray_reduce,
    foldMap: es6_NonEmptyArray_foldMap,
    reduceRight: NonEmptyArray_reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_FoldableWithIndex = {
    URI: NonEmptyArray_URI,
    reduce: NonEmptyArray_reduce,
    foldMap: es6_NonEmptyArray_foldMap,
    reduceRight: NonEmptyArray_reduceRight,
    reduceWithIndex: NonEmptyArray_reduceWithIndex,
    foldMapWithIndex: es6_NonEmptyArray_foldMapWithIndex,
    reduceRightWithIndex: NonEmptyArray_reduceRightWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_Traversable = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    reduce: NonEmptyArray_reduce,
    foldMap: es6_NonEmptyArray_foldMap,
    reduceRight: NonEmptyArray_reduceRight,
    traverse: NonEmptyArray_traverse,
    sequence: NonEmptyArray_sequence
};
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_TraversableWithIndex = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    mapWithIndex: NonEmptyArray_mapWithIndex,
    reduce: NonEmptyArray_reduce,
    foldMap: es6_NonEmptyArray_foldMap,
    reduceRight: NonEmptyArray_reduceRight,
    traverse: NonEmptyArray_traverse,
    sequence: NonEmptyArray_sequence,
    reduceWithIndex: NonEmptyArray_reduceWithIndex,
    foldMapWithIndex: es6_NonEmptyArray_foldMapWithIndex,
    reduceRightWithIndex: NonEmptyArray_reduceRightWithIndex,
    traverseWithIndex: NonEmptyArray_traverseWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_Alt = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    alt: NonEmptyArray_alt
};
/**
 * @category instances
 * @since 2.7.0
 */
var NonEmptyArray_Comonad = {
    URI: NonEmptyArray_URI,
    map: NonEmptyArray_map,
    extend: NonEmptyArray_extend,
    extract: NonEmptyArray_extract
};
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @since 2.9.0
 */
var NonEmptyArray_Do = 
/*#__PURE__*/
NonEmptyArray_of(internal/* emptyRecord */.F4);
/**
 * @since 2.8.0
 */
var NonEmptyArray_bindTo = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bindTo_(NonEmptyArray_Functor)));
/**
 * @since 2.8.0
 */
var NonEmptyArray_bind = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bind_(NonEmptyArray_Chain)));
// -------------------------------------------------------------------------------------
// pipeable sequence S
// -------------------------------------------------------------------------------------
/**
 * @since 2.8.0
 */
var NonEmptyArray_apS = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apS_(NonEmptyArray_Apply)));
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.0.0
 */
var NonEmptyArray_head = head;
/**
 * @since 2.0.0
 */
var NonEmptyArray_tail = function (as) { return as.slice(1); };
/**
 * @since 2.0.0
 */
var NonEmptyArray_last = ReadonlyNonEmptyArray_last;
/**
 * Get all but the last element of a non empty array, creating a new array.
 *
 * @example
 * import { init } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), [1, 2])
 * assert.deepStrictEqual(init([1]), [])
 *
 * @since 2.2.0
 */
var NonEmptyArray_init = function (as) { return as.slice(0, -1); };
/**
 * @since 2.0.0
 */
var NonEmptyArray_min = ReadonlyNonEmptyArray_min;
/**
 * @since 2.0.0
 */
var NonEmptyArray_max = ReadonlyNonEmptyArray_max;
/**
 * @since 2.10.0
 */
var NonEmptyArray_concatAll = function (S) { return function (as) { return as.reduce(S.concat); }; };
/**
 * Break an `Array` into its first element and remaining elements.
 *
 * @category destructors
 * @since 2.11.0
 */
var NonEmptyArray_matchLeft = function (f) { return function (as) { return f(NonEmptyArray_head(as), NonEmptyArray_tail(as)); }; };
/**
 * Break an `Array` into its initial elements and the last element.
 *
 * @category destructors
 * @since 2.11.0
 */
var NonEmptyArray_matchRight = function (f) { return function (as) {
    return f(NonEmptyArray_init(as), NonEmptyArray_last(as));
}; };
/**
 * Apply a function to the head, creating a new `NonEmptyArray`.
 *
 * @since 2.11.0
 */
var NonEmptyArray_modifyHead = function (f) { return function (as) { return NonEmptyArray_spreadArray([
    f(NonEmptyArray_head(as))
], NonEmptyArray_tail(as)); }; };
/**
 * Change the head, creating a new `NonEmptyArray`.
 *
 * @category combinators
 * @since 2.11.0
 */
var NonEmptyArray_updateHead = function (a) { return NonEmptyArray_modifyHead(function () { return a; }); };
/**
 * Apply a function to the last element, creating a new `NonEmptyArray`.
 *
 * @since 2.11.0
 */
var NonEmptyArray_modifyLast = function (f) { return function (as) {
    return pipe(NonEmptyArray_init(as), NonEmptyArray_append(f(NonEmptyArray_last(as))));
}; };
/**
 * Change the last element, creating a new `NonEmptyArray`.
 *
 * @category combinators
 * @since 2.11.0
 */
var NonEmptyArray_updateLast = function (a) { return NonEmptyArray_modifyLast(function () { return a; }); };
function NonEmptyArray_groupSort(O) {
    var sortO = NonEmptyArray_sort(O);
    var groupO = NonEmptyArray_group(O);
    return function (as) { return (NonEmptyArray_isNonEmpty(as) ? groupO(sortO(as)) : []); };
}
function NonEmptyArray_filter(predicate) {
    return NonEmptyArray_filterWithIndex(function (_, a) { return predicate(a); });
}
/**
 * Use [`filterWithIndex`](./Array.ts.html#filterwithindex) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var NonEmptyArray_filterWithIndex = function (predicate) { return function (as) { return NonEmptyArray_fromArray(as.filter(function (a, i) { return predicate(i, a); })); }; };
/**
 * Use [`unprepend`](#unprepend) instead.
 *
 * @category destructors
 * @since 2.9.0
 * @deprecated
 */
var NonEmptyArray_uncons = (/* unused pure expression or super */ null && (NonEmptyArray_unprepend));
/**
 * Use [`unappend`](#unappend) instead.
 *
 * @category destructors
 * @since 2.9.0
 * @deprecated
 */
var NonEmptyArray_unsnoc = (/* unused pure expression or super */ null && (NonEmptyArray_unappend));
function NonEmptyArray_cons(head, tail) {
    return tail === undefined ? NonEmptyArray_prepend(head) : (0,es6_function/* pipe */.zG)(tail, NonEmptyArray_prepend(head));
}
/**
 * Use [`append`](./Array.ts.html#append) instead.
 *
 * @category constructors
 * @since 2.0.0
 * @deprecated
 */
var NonEmptyArray_snoc = function (init, end) { return (0,es6_function/* pipe */.zG)(init, NonEmptyArray_append(end)); };
/**
 * Use [`prependAll`](#prependall) instead.
 *
 * @category combinators
 * @since 2.9.0
 * @deprecated
 */
var NonEmptyArray_prependToAll = (/* unused pure expression or super */ null && (NonEmptyArray_prependAll));
/**
 * Use [`concatAll`](#concatall) instead.
 *
 * @since 2.5.0
 * @deprecated
 */
var NonEmptyArray_fold = ReadonlyNonEmptyArray_concatAll;
/**
 * Use small, specific instances instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var nonEmptyArray = {
    URI: NonEmptyArray_URI,
    of: NonEmptyArray_of,
    map: NonEmptyArray_map,
    mapWithIndex: NonEmptyArray_mapWithIndex,
    ap: NonEmptyArray_ap,
    chain: NonEmptyArray_chain,
    extend: NonEmptyArray_extend,
    extract: NonEmptyArray_extract,
    reduce: NonEmptyArray_reduce,
    foldMap: es6_NonEmptyArray_foldMap,
    reduceRight: NonEmptyArray_reduceRight,
    traverse: NonEmptyArray_traverse,
    sequence: NonEmptyArray_sequence,
    reduceWithIndex: NonEmptyArray_reduceWithIndex,
    foldMapWithIndex: es6_NonEmptyArray_foldMapWithIndex,
    reduceRightWithIndex: NonEmptyArray_reduceRightWithIndex,
    traverseWithIndex: NonEmptyArray_traverseWithIndex,
    alt: NonEmptyArray_alt
};

;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/number.js
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */
var isNumber = function (u) { return typeof u === 'number'; };
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.10.0
 */
var Eq = {
    equals: function (first, second) { return first === second; }
};
/**
 * @category instances
 * @since 2.10.0
 */
var Ord = {
    equals: Eq.equals,
    compare: function (first, second) { return (first < second ? -1 : first > second ? 1 : 0); }
};
/**
 * @category instances
 * @since 2.10.0
 */
var Bounded = {
    equals: Eq.equals,
    compare: Ord.compare,
    top: Infinity,
    bottom: -Infinity
};
/**
 * @category instances
 * @since 2.10.0
 */
var Show = {
    show: function (n) { return JSON.stringify(n); }
};
/**
 * @category instances
 * @since 2.11.0
 */
var MagmaSub = {
    concat: function (first, second) { return first - second; }
};
/**
 * `number` semigroup under addition.
 *
 * @example
 * import { SemigroupSum } from 'fp-ts/number'
 *
 * assert.deepStrictEqual(SemigroupSum.concat(2, 3), 5)
 *
 * @category instances
 * @since 2.10.0
 */
var SemigroupSum = {
    concat: function (first, second) { return first + second; }
};
/**
 * `number` semigroup under multiplication.
 *
 * @example
 * import { SemigroupProduct } from 'fp-ts/number'
 *
 * assert.deepStrictEqual(SemigroupProduct.concat(2, 3), 6)
 *
 * @category instances
 * @since 2.10.0
 */
var SemigroupProduct = {
    concat: function (first, second) { return first * second; }
};
/**
 * `number` monoid under addition.
 *
 * The `empty` value is `0`.
 *
 * @example
 * import { MonoidSum } from 'fp-ts/number'
 *
 * assert.deepStrictEqual(MonoidSum.concat(2, MonoidSum.empty), 2)
 *
 * @category instances
 * @since 2.10.0
 */
var MonoidSum = {
    concat: SemigroupSum.concat,
    empty: 0
};
/**
 * `number` monoid under multiplication.
 *
 * The `empty` value is `1`.
 *
 * @example
 * import { MonoidProduct } from 'fp-ts/number'
 *
 * assert.deepStrictEqual(MonoidProduct.concat(2, MonoidProduct.empty), 2)
 *
 * @category instances
 * @since 2.10.0
 */
var MonoidProduct = {
    concat: SemigroupProduct.concat,
    empty: 1
};
/**
 * @category instances
 * @since 2.10.0
 */
var Field = {
    add: SemigroupSum.concat,
    zero: 0,
    mul: SemigroupProduct.concat,
    one: 1,
    sub: MagmaSub.concat,
    degree: function (_) { return 1; },
    div: function (first, second) { return first / second; },
    mod: function (first, second) { return first % second; }
};

// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Separated.js
var Separated = __webpack_require__(64870);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Witherable.js
var Witherable = __webpack_require__(25605);
;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/ReadonlyArray.js
var ReadonlyArray_spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};













// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Test whether a `ReadonlyArray` is empty.
 *
 * @example
 * import { isEmpty } from 'fp-ts/ReadonlyArray'
 *
 * assert.strictEqual(isEmpty([]), true)
 *
 * @category refinements
 * @since 2.5.0
 */
var isEmpty = function (as) { return as.length === 0; };
/**
 * Test whether a `ReadonlyArray` is non empty.
 *
 * @category refinements
 * @since 2.5.0
 */
var ReadonlyArray_isNonEmpty = isNonEmpty;
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Prepend an element to the front of a `ReadonlyArray`, creating a new `ReadonlyNonEmptyArray`.
 *
 * @example
 * import { prepend } from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([2, 3, 4], prepend(1)), [1, 2, 3, 4])
 *
 * @category constructors
 * @since 2.10.0
 */
var ReadonlyArray_prepend = prepend;
/**
 * Less strict version of [`prepend`](#prepend).
 *
 * @category constructors
 * @since 2.11.0
 */
var ReadonlyArray_prependW = prependW;
/**
 * Append an element to the end of a `ReadonlyArray`, creating a new `ReadonlyNonEmptyArray`.
 *
 * @example
 * import { append } from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([1, 2, 3], append(4)), [1, 2, 3, 4])
 *
 * @category constructors
 * @since 2.10.0
 */
var ReadonlyArray_append = append;
/**
 * Less strict version of [`append`](#append).
 *
 * @category constructors
 * @since 2.11.0
 */
var ReadonlyArray_appendW = appendW;
/**
 * Return a `ReadonlyArray` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { makeBy } from 'fp-ts/ReadonlyArray'
 *
 * const double = (n: number): number => n * 2
 * assert.deepStrictEqual(makeBy(5, double), [0, 2, 4, 6, 8])
 *
 * @category constructors
 * @since 2.5.0
 */
var ReadonlyArray_makeBy = function (n, f) { return (n <= 0 ? ReadonlyArray_empty : RNEA.makeBy(f)(n)); };
/**
 * Create a `ReadonlyArray` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { replicate } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(replicate(3, 'a'), ['a', 'a', 'a'])
 *
 * @category constructors
 * @since 2.5.0
 */
var ReadonlyArray_replicate = function (n, a) { return ReadonlyArray_makeBy(n, function () { return a; }); };
function fromPredicate(predicate) {
    return function (a) { return (predicate(a) ? [a] : ReadonlyArray_empty); };
}
// -------------------------------------------------------------------------------------
// natural transformations
// -------------------------------------------------------------------------------------
/**
 * @category natural transformations
 * @since 2.11.0
 */
var fromOption = function (ma) { return (_.isNone(ma) ? ReadonlyArray_empty : [ma.value]); };
/**
 * Transforms an `Either` to a `ReadonlyArray`.
 *
 * @category natural transformations
 * @since 2.11.0
 */
var fromEither = function (e) { return (internal/* isLeft */.nM(e) ? ReadonlyArray_empty : [e.right]); };
// -------------------------------------------------------------------------------------
// destructors
// -------------------------------------------------------------------------------------
/**
 * Less strict version of [`match`](#match).
 *
 * @category destructors
 * @since 2.11.0
 */
var matchW = function (onEmpty, onNonEmpty) { return function (as) { return (ReadonlyArray_isNonEmpty(as) ? onNonEmpty(as) : onEmpty()); }; };
/**
 * @category destructors
 * @since 2.11.0
 */
var match = (/* unused pure expression or super */ null && (matchW));
/**
 * Less strict version of [`matchLeft`](#matchleft).
 *
 * @category destructors
 * @since 2.11.0
 */
var matchLeftW = function (onEmpty, onNonEmpty) { return function (as) { return (ReadonlyArray_isNonEmpty(as) ? onNonEmpty(RNEA.head(as), RNEA.tail(as)) : onEmpty()); }; };
/**
 * Break a `ReadonlyArray` into its first element and remaining elements.
 *
 * @example
 * import { matchLeft } from 'fp-ts/ReadonlyArray'
 *
 * const len: <A>(as: ReadonlyArray<A>) => number = matchLeft(() => 0, (_, tail) => 1 + len(tail))
 * assert.strictEqual(len([1, 2, 3]), 3)
 *
 * @category destructors
 * @since 2.10.0
 */
var ReadonlyArray_matchLeft = (/* unused pure expression or super */ null && (matchLeftW));
/**
 * Alias of [`matchLeft`](#matchleft).
 *
 * @category destructors
 * @since 2.5.0
 */
var foldLeft = (/* unused pure expression or super */ null && (ReadonlyArray_matchLeft));
/**
 * Less strict version of [`matchRight`](#matchright).
 *
 * @category destructors
 * @since 2.11.0
 */
var matchRightW = function (onEmpty, onNonEmpty) { return function (as) { return (ReadonlyArray_isNonEmpty(as) ? onNonEmpty(RNEA.init(as), RNEA.last(as)) : onEmpty()); }; };
/**
 * Break a `ReadonlyArray` into its initial elements and the last element.
 *
 * @category destructors
 * @since 2.10.0
 */
var ReadonlyArray_matchRight = (/* unused pure expression or super */ null && (matchRightW));
/**
 * Alias of [`matchRight`](#matchright).
 *
 * @category destructors
 * @since 2.5.0
 */
var foldRight = (/* unused pure expression or super */ null && (ReadonlyArray_matchRight));
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category combinators
 * @since 2.7.0
 */
var ReadonlyArray_chainWithIndex = function (f) { return function (as) {
    if (isEmpty(as)) {
        return ReadonlyArray_empty;
    }
    var out = [];
    for (var i = 0; i < as.length; i++) {
        out.push.apply(out, f(i, as[i]));
    }
    return out;
}; };
/**
 * Same as `reduce` but it carries over the intermediate steps.
 *
 * @example
 * import { scanLeft } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(scanLeft(10, (b, a: number) => b - a)([1, 2, 3]), [10, 9, 7, 4])
 *
 * @category combinators
 * @since 2.5.0
 */
var scanLeft = function (b, f) { return function (as) {
    var len = as.length;
    var out = new Array(len + 1);
    out[0] = b;
    for (var i = 0; i < len; i++) {
        out[i + 1] = f(out[i], as[i]);
    }
    return out;
}; };
/**
 * Fold an array from the right, keeping all intermediate results instead of only the final result
 *
 * @example
 * import { scanRight } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(scanRight(10, (a: number, b) => b - a)([1, 2, 3]), [4, 5, 7, 10])
 *
 * @category combinators
 * @since 2.5.0
 */
var scanRight = function (b, f) { return function (as) {
    var len = as.length;
    var out = new Array(len + 1);
    out[len] = b;
    for (var i = len - 1; i >= 0; i--) {
        out[i] = f(as[i], out[i + 1]);
    }
    return out;
}; };
/**
 * Calculate the number of elements in a `ReadonlyArray`.
 *
 * @since 2.10.0
 */
var size = function (as) { return as.length; };
/**
 * Test whether an array contains a particular index
 *
 * @since 2.5.0
 */
var ReadonlyArray_isOutOfBound = isOutOfBound;
function lookup(i, as) {
    return as === undefined ? function (as) { return lookup(i, as); } : ReadonlyArray_isOutOfBound(i, as) ? internal/* none */.YP : internal/* some */.G(as[i]);
}
/**
 * Get the first element in an array, or `None` if the array is empty
 *
 * @example
 * import { head } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(head([1, 2, 3]), some(1))
 * assert.deepStrictEqual(head([]), none)
 *
 * @since 2.5.0
 */
var ReadonlyArray_head = function (as) { return (ReadonlyArray_isNonEmpty(as) ? internal/* some */.G(head(as)) : internal/* none */.YP); };
/**
 * Get the last element in an array, or `None` if the array is empty
 *
 * @example
 * import { last } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(last([1, 2, 3]), some(3))
 * assert.deepStrictEqual(last([]), none)
 *
 * @since 2.5.0
 */
var ReadonlyArray_last = function (as) { return (ReadonlyArray_isNonEmpty(as) ? internal/* some */.G(ReadonlyNonEmptyArray_last(as)) : internal/* none */.YP); };
/**
 * Get all but the first element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { tail } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(tail([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(tail([]), none)
 *
 * @since 2.5.0
 */
var ReadonlyArray_tail = function (as) {
    return ReadonlyArray_isNonEmpty(as) ? _.some(RNEA.tail(as)) : _.none;
};
/**
 * Get all but the last element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { init } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), some([1, 2]))
 * assert.deepStrictEqual(init([]), none)
 *
 * @since 2.5.0
 */
var ReadonlyArray_init = function (as) {
    return ReadonlyArray_isNonEmpty(as) ? _.some(RNEA.init(as)) : _.none;
};
/**
 * Keep only a max number of elements from the start of an `ReadonlyArray`, creating a new `ReadonlyArray`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const input: ReadonlyArray<number> = [1, 2, 3]
 * assert.deepStrictEqual(pipe(input, RA.takeLeft(2)), [1, 2])
 *
 * // out of bounds
 * assert.strictEqual(pipe(input, RA.takeLeft(4)), input)
 * assert.strictEqual(pipe(input, RA.takeLeft(-1)), input)
 *
 * @category combinators
 * @since 2.5.0
 */
var takeLeft = function (n) { return function (as) {
    return ReadonlyArray_isOutOfBound(n, as) ? as : n === 0 ? ReadonlyArray_empty : as.slice(0, n);
}; };
/**
 * Keep only a max number of elements from the end of an `ReadonlyArray`, creating a new `ReadonlyArray`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const input: ReadonlyArray<number> = [1, 2, 3]
 * assert.deepStrictEqual(pipe(input, RA.takeRight(2)), [2, 3])
 *
 * // out of bounds
 * assert.strictEqual(pipe(input, RA.takeRight(4)), input)
 * assert.strictEqual(pipe(input, RA.takeRight(-1)), input)
 *
 * @category combinators
 * @since 2.5.0
 */
var takeRight = function (n) { return function (as) {
    return ReadonlyArray_isOutOfBound(n, as) ? as : n === 0 ? ReadonlyArray_empty : as.slice(-n);
}; };
function takeLeftWhile(predicate) {
    return function (as) {
        var out = [];
        for (var _i = 0, as_1 = as; _i < as_1.length; _i++) {
            var a = as_1[_i];
            if (!predicate(a)) {
                break;
            }
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? ReadonlyArray_empty : out;
    };
}
var spanLeftIndex = function (as, predicate) {
    var l = as.length;
    var i = 0;
    for (; i < l; i++) {
        if (!predicate(as[i])) {
            break;
        }
    }
    return i;
};
function spanLeft(predicate) {
    return function (as) {
        var _a = ReadonlyArray_splitAt(spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return { init: init, rest: rest };
    };
}
/**
 * Drop a max number of elements from the start of an `ReadonlyArray`, creating a new `ReadonlyArray`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const input: ReadonlyArray<number> = [1, 2, 3]
 * assert.deepStrictEqual(pipe(input, RA.dropLeft(2)), [3])
 * assert.strictEqual(pipe(input, RA.dropLeft(0)), input)
 * assert.strictEqual(pipe(input, RA.dropLeft(-1)), input)
 *
 * @category combinators
 * @since 2.5.0
 */
var dropLeft = function (n) { return function (as) {
    return n <= 0 || isEmpty(as) ? as : n >= as.length ? ReadonlyArray_empty : as.slice(n, as.length);
}; };
/**
 * Drop a max number of elements from the end of an `ReadonlyArray`, creating a new `ReadonlyArray`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const input: ReadonlyArray<number> = [1, 2, 3]
 * assert.deepStrictEqual(pipe(input, RA.dropRight(2)), [1])
 * assert.strictEqual(pipe(input, RA.dropRight(0)), input)
 * assert.strictEqual(pipe(input, RA.dropRight(-1)), input)
 *
 * @category combinators
 * @since 2.5.0
 */
var dropRight = function (n) { return function (as) {
    return n <= 0 || isEmpty(as) ? as : n >= as.length ? ReadonlyArray_empty : as.slice(0, as.length - n);
}; };
function dropLeftWhile(predicate) {
    return function (as) {
        var i = spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? ReadonlyArray_empty : as.slice(i);
    };
}
/**
 * Find the first index for which a predicate holds
 *
 * @example
 * import { findIndex } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(findIndex((n: number) => n === 2)([1, 2, 3]), some(1))
 * assert.deepStrictEqual(findIndex((n: number) => n === 2)([]), none)
 *
 * @since 2.5.0
 */
var findIndex = function (predicate) { return function (as) {
    for (var i = 0; i < as.length; i++) {
        if (predicate(as[i])) {
            return internal/* some */.G(i);
        }
    }
    return internal/* none */.YP;
}; };
function findFirst(predicate) {
    return function (as) {
        for (var i = 0; i < as.length; i++) {
            if (predicate(as[i])) {
                return _.some(as[i]);
            }
        }
        return _.none;
    };
}
/**
 * Find the first element returned by an option based selector function
 *
 * @example
 * import { findFirstMap } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age?: number
 * }
 *
 * const persons: ReadonlyArray<Person> = [{ name: 'John' }, { name: 'Mary', age: 45 }, { name: 'Joey', age: 28 }]
 *
 * // returns the name of the first person that has an age
 * assert.deepStrictEqual(findFirstMap((p: Person) => (p.age === undefined ? none : some(p.name)))(persons), some('Mary'))
 *
 * @since 2.5.0
 */
var findFirstMap = function (f) { return function (as) {
    for (var i = 0; i < as.length; i++) {
        var out = f(as[i]);
        if (internal/* isSome */.pC(out)) {
            return out;
        }
    }
    return internal/* none */.YP;
}; };
function findLast(predicate) {
    return function (as) {
        for (var i = as.length - 1; i >= 0; i--) {
            if (predicate(as[i])) {
                return _.some(as[i]);
            }
        }
        return _.none;
    };
}
/**
 * Find the last element returned by an option based selector function
 *
 * @example
 * import { findLastMap } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age?: number
 * }
 *
 * const persons: ReadonlyArray<Person> = [{ name: 'John' }, { name: 'Mary', age: 45 }, { name: 'Joey', age: 28 }]
 *
 * // returns the name of the last person that has an age
 * assert.deepStrictEqual(findLastMap((p: Person) => (p.age === undefined ? none : some(p.name)))(persons), some('Joey'))
 *
 * @since 2.5.0
 */
var findLastMap = function (f) { return function (as) {
    for (var i = as.length - 1; i >= 0; i--) {
        var out = f(as[i]);
        if (internal/* isSome */.pC(out)) {
            return out;
        }
    }
    return internal/* none */.YP;
}; };
/**
 * Returns the index of the last element of the list which matches the predicate
 *
 * @example
 * import { findLastIndex } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface X {
 *   readonly a: number
 *   readonly b: number
 * }
 * const xs: ReadonlyArray<X> = [{ a: 1, b: 0 }, { a: 1, b: 1 }]
 * assert.deepStrictEqual(findLastIndex((x: { readonly a: number }) => x.a === 1)(xs), some(1))
 * assert.deepStrictEqual(findLastIndex((x: { readonly a: number }) => x.a === 4)(xs), none)
 *
 *
 * @since 2.5.0
 */
var findLastIndex = function (predicate) { return function (as) {
    for (var i = as.length - 1; i >= 0; i--) {
        if (predicate(as[i])) {
            return internal/* some */.G(i);
        }
    }
    return internal/* none */.YP;
}; };
/**
 * Insert an element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { insertAt } from 'fp-ts/ReadonlyArray'
 * import { some } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(insertAt(2, 5)([1, 2, 3, 4]), some([1, 2, 5, 3, 4]))
 *
 * @since 2.5.0
 */
var ReadonlyArray_insertAt = function (i, a) { return function (as) {
    return i < 0 || i > as.length ? _.none : _.some(RNEA.unsafeInsertAt(i, a, as));
}; };
/**
 * Change the element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { updateAt } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(updateAt(1, 1)([1, 2, 3]), some([1, 1, 3]))
 * assert.deepStrictEqual(updateAt(1, 1)([]), none)
 *
 * @since 2.5.0
 */
var ReadonlyArray_updateAt = function (i, a) {
    return ReadonlyArray_modifyAt(i, function () { return a; });
};
/**
 * Delete the element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { deleteAt } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(deleteAt(0)([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(deleteAt(1)([]), none)
 *
 * @since 2.5.0
 */
var deleteAt = function (i) { return function (as) {
    return ReadonlyArray_isOutOfBound(i, as) ? _.none : _.some(unsafeDeleteAt(i, as));
}; };
/**
 * Apply a function to the element at the specified index, creating a new array, or returning `None` if the index is out
 * of bounds
 *
 * @example
 * import { modifyAt } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * const double = (x: number): number => x * 2
 * assert.deepStrictEqual(modifyAt(1, double)([1, 2, 3]), some([1, 4, 3]))
 * assert.deepStrictEqual(modifyAt(1, double)([]), none)
 *
 * @since 2.5.0
 */
var ReadonlyArray_modifyAt = function (i, f) { return function (as) {
    return ReadonlyArray_isOutOfBound(i, as) ? _.none : _.some(ReadonlyArray_unsafeUpdateAt(i, f(as[i]), as));
}; };
/**
 * Reverse an array, creating a new array
 *
 * @example
 * import { reverse } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(reverse([1, 2, 3]), [3, 2, 1])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_reverse = function (as) { return (as.length <= 1 ? as : as.slice().reverse()); };
/**
 * Extracts from an array of `Either` all the `Right` elements. All the `Right` elements are extracted in order
 *
 * @example
 * import { rights } from 'fp-ts/ReadonlyArray'
 * import { right, left } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(rights([right(1), left('foo'), right(2)]), [1, 2])
 *
 * @category combinators
 * @since 2.5.0
 */
var rights = function (as) {
    var r = [];
    for (var i = 0; i < as.length; i++) {
        var a = as[i];
        if (a._tag === 'Right') {
            r.push(a.right);
        }
    }
    return r;
};
/**
 * Extracts from an array of `Either` all the `Left` elements. All the `Left` elements are extracted in order
 *
 * @example
 * import { lefts } from 'fp-ts/ReadonlyArray'
 * import { left, right } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(lefts([right(1), left('foo'), right(2)]), ['foo'])
 *
 * @category combinators
 * @since 2.5.0
 */
var lefts = function (as) {
    var r = [];
    for (var i = 0; i < as.length; i++) {
        var a = as[i];
        if (a._tag === 'Left') {
            r.push(a.left);
        }
    }
    return r;
};
/**
 * Sort the elements of an array in increasing order, creating a new array
 *
 * @example
 * import { sort } from 'fp-ts/ReadonlyArray'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(sort(N.Ord)([3, 2, 1]), [1, 2, 3])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_sort = function (O) { return function (as) {
    return as.length <= 1 ? as : as.slice().sort(O.compare);
}; };
// TODO: curry and make data-last in v3
/**
 * Apply a function to pairs of elements at the same index in two arrays, collecting the results in a new array. If one
 * input array is short, excess elements of the longer array are discarded.
 *
 * @example
 * import { zipWith } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(zipWith([1, 2, 3], ['a', 'b', 'c', 'd'], (n, s) => s + n), ['a1', 'b2', 'c3'])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_zipWith = function (fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for (var i = 0; i < len; i++) {
        fc[i] = f(fa[i], fb[i]);
    }
    return fc;
};
function ReadonlyArray_zip(as, bs) {
    if (bs === undefined) {
        return function (bs) { return ReadonlyArray_zip(bs, as); };
    }
    return ReadonlyArray_zipWith(as, bs, function (a, b) { return [a, b]; });
}
/**
 * The function is reverse of `zip`. Takes an array of pairs and return two corresponding arrays
 *
 * @example
 * import { unzip } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(unzip([[1, 'a'], [2, 'b'], [3, 'c']]), [[1, 2, 3], ['a', 'b', 'c']])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_unzip = function (as) {
    var fa = [];
    var fb = [];
    for (var i = 0; i < as.length; i++) {
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [fa, fb];
};
/**
 * Prepend an element to every member of an array
 *
 * @example
 * import { prependAll } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(prependAll(9)([1, 2, 3, 4]), [9, 1, 9, 2, 9, 3, 9, 4])
 *
 * @category combinators
 * @since 2.10.0
 */
var ReadonlyArray_prependAll = function (middle) {
    var f = RNEA.prependAll(middle);
    return function (as) { return (ReadonlyArray_isNonEmpty(as) ? f(as) : as); };
};
/**
 * Places an element in between members of an array
 *
 * @example
 * import { intersperse } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(intersperse(9)([1, 2, 3, 4]), [1, 9, 2, 9, 3, 9, 4])
 *
 * @category combinators
 * @since 2.9.0
 */
var ReadonlyArray_intersperse = function (middle) {
    var f = RNEA.intersperse(middle);
    return function (as) { return (ReadonlyArray_isNonEmpty(as) ? f(as) : as); };
};
/**
 * Rotate a `ReadonlyArray` by `n` steps.
 *
 * @example
 * import { rotate } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(rotate(2)([1, 2, 3, 4, 5]), [4, 5, 1, 2, 3])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_rotate = function (n) {
    var f = RNEA.rotate(n);
    return function (as) { return (ReadonlyArray_isNonEmpty(as) ? f(as) : as); };
};
function elem(E) {
    return function (a, as) {
        if (as === undefined) {
            var elemE_1 = elem(E);
            return function (as) { return elemE_1(a, as); };
        }
        var predicate = function (element) { return E.equals(element, a); };
        var i = 0;
        for (; i < as.length; i++) {
            if (predicate(as[i])) {
                return true;
            }
        }
        return false;
    };
}
/**
 * Remove duplicates from an array, keeping the first occurrence of an element.
 *
 * @example
 * import { uniq } from 'fp-ts/ReadonlyArray'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(uniq(N.Eq)([1, 2, 1]), [1, 2])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_uniq = function (E) {
    var f = RNEA.uniq(E);
    return function (as) { return (ReadonlyArray_isNonEmpty(as) ? f(as) : as); };
};
/**
 * Sort the elements of an array in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import { sortBy } from 'fp-ts/ReadonlyArray'
 * import { contramap } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age: number
 * }
 * const byName = pipe(S.Ord, contramap((p: Person) => p.name))
 * const byAge = pipe(N.Ord, contramap((p: Person) => p.age))
 *
 * const sortByNameByAge = sortBy([byName, byAge])
 *
 * const persons = [{ name: 'a', age: 1 }, { name: 'b', age: 3 }, { name: 'c', age: 2 }, { name: 'b', age: 2 }]
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_sortBy = function (ords) {
    var f = RNEA.sortBy(ords);
    return function (as) { return (ReadonlyArray_isNonEmpty(as) ? f(as) : as); };
};
/**
 * A useful recursion pattern for processing a `ReadonlyArray` to produce a new `ReadonlyArray`, often used for "chopping" up the input
 * `ReadonlyArray`. Typically `chop` is called with some function that will consume an initial prefix of the `ReadonlyArray` and produce a
 * value and the tail of the `ReadonlyArray`.
 *
 * @example
 * import { Eq } from 'fp-ts/Eq'
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * const group = <A>(S: Eq<A>): ((as: ReadonlyArray<A>) => ReadonlyArray<ReadonlyArray<A>>) => {
 *   return RA.chop(as => {
 *     const { init, rest } = pipe(as, RA.spanLeft((a: A) => S.equals(a, as[0])))
 *     return [init, rest]
 *   })
 * }
 * assert.deepStrictEqual(group(N.Eq)([1, 1, 2, 3, 3, 4]), [[1, 1], [2], [3, 3], [4]])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_chop = function (f) {
    var g = RNEA.chop(f);
    return function (as) { return (ReadonlyArray_isNonEmpty(as) ? g(as) : ReadonlyArray_empty); };
};
/**
 * Splits a `ReadonlyArray` into two pieces, the first piece has max `n` elements.
 *
 * @example
 * import { splitAt } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(splitAt(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4, 5]])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_splitAt = function (n) { return function (as) {
    return n >= 1 && ReadonlyArray_isNonEmpty(as) ? RNEA.splitAt(n)(as) : isEmpty(as) ? [as, ReadonlyArray_empty] : [ReadonlyArray_empty, as];
}; };
/**
 * Splits a `ReadonlyArray` into length-`n` pieces. The last piece will be shorter if `n` does not evenly divide the length of
 * the `ReadonlyArray`. Note that `chunksOf(n)([])` is `[]`, not `[[]]`. This is intentional, and is consistent with a recursive
 * definition of `chunksOf`; it satisfies the property that:
 *
 * ```ts
 * chunksOf(n)(xs).concat(chunksOf(n)(ys)) == chunksOf(n)(xs.concat(ys)))
 * ```
 *
 * whenever `n` evenly divides the length of `as`.
 *
 * @example
 * import { chunksOf } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(chunksOf(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4], [5]])
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_chunksOf = function (n) {
    var f = RNEA.chunksOf(n);
    return function (as) { return (ReadonlyArray_isNonEmpty(as) ? f(as) : ReadonlyArray_empty); };
};
/**
 * @category combinators
 * @since 2.11.0
 */
var fromOptionK = function (f) { return function () {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
    }
    return fromOption(f.apply(void 0, a));
}; };
function comprehension(input, f, g) {
    if (g === void 0) { g = function () { return true; }; }
    var go = function (scope, input) {
        return ReadonlyArray_isNonEmpty(input)
            ? pipe(RNEA.head(input), es6_ReadonlyArray_chain(function (x) { return go(pipe(scope, ReadonlyArray_append(x)), RNEA.tail(input)); }))
            : g.apply(void 0, scope) ? [f.apply(void 0, scope)]
                : ReadonlyArray_empty;
    };
    return go(ReadonlyArray_empty, input);
}
/**
 * @category combinators
 * @since 2.11.0
 */
var ReadonlyArray_concatW = function (second) { return function (first) {
    return isEmpty(first) ? second : isEmpty(second) ? first : first.concat(second);
}; };
/**
 * @category combinators
 * @since 2.11.0
 */
var ReadonlyArray_concat = (/* unused pure expression or super */ null && (ReadonlyArray_concatW));
function ReadonlyArray_union(E) {
    var unionE = RNEA.union(E);
    return function (first, second) {
        if (second === undefined) {
            var unionE_1 = ReadonlyArray_union(E);
            return function (second) { return unionE_1(second, first); };
        }
        return ReadonlyArray_isNonEmpty(first) && ReadonlyArray_isNonEmpty(second) ? unionE(second)(first) : ReadonlyArray_isNonEmpty(first) ? first : second;
    };
}
function intersection(E) {
    var elemE = elem(E);
    return function (xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = intersection(E);
            return function (ys) { return intersectionE_1(ys, xs); };
        }
        return xs.filter(function (a) { return elemE(a, ys); });
    };
}
function difference(E) {
    var elemE = elem(E);
    return function (xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = difference(E);
            return function (ys) { return differenceE_1(ys, xs); };
        }
        return xs.filter(function (a) { return !elemE(a, ys); });
    };
}
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var ReadonlyArray_map = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_map(f)); };
var ReadonlyArray_mapWithIndex = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_mapWithIndex(f)); };
var ReadonlyArray_ap = function (fab, fa) { return (0,es6_function/* pipe */.zG)(fab, es6_ReadonlyArray_ap(fa)); };
var ReadonlyArray_chain = function (ma, f) { return (0,es6_function/* pipe */.zG)(ma, es6_ReadonlyArray_chain(f)); };
var _filter = function (fa, predicate) {
    return (0,es6_function/* pipe */.zG)(fa, ReadonlyArray_filter(predicate));
};
var _filterMap = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, filterMap(f)); };
var _partition = function (fa, predicate) {
    return (0,es6_function/* pipe */.zG)(fa, partition(predicate));
};
var _partitionMap = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, partitionMap(f)); };
var _partitionWithIndex = function (fa, predicateWithIndex) { return (0,es6_function/* pipe */.zG)(fa, partitionWithIndex(predicateWithIndex)); };
var _partitionMapWithIndex = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, partitionMapWithIndex(f)); };
var ReadonlyArray_alt = function (fa, that) { return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_alt(that)); };
var ReadonlyArray_reduce = function (fa, b, f) { return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_reduce(b, f)); };
var ReadonlyArray_foldMap = function (M) {
    var foldMapM = es6_ReadonlyArray_foldMap(M);
    return function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, foldMapM(f)); };
};
var ReadonlyArray_reduceRight = function (fa, b, f) { return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_reduceRight(b, f)); };
var ReadonlyArray_reduceWithIndex = function (fa, b, f) {
    return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_reduceWithIndex(b, f));
};
var ReadonlyArray_foldMapWithIndex = function (M) {
    var foldMapWithIndexM = es6_ReadonlyArray_foldMapWithIndex(M);
    return function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, foldMapWithIndexM(f)); };
};
var ReadonlyArray_reduceRightWithIndex = function (fa, b, f) {
    return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_reduceRightWithIndex(b, f));
};
var _filterMapWithIndex = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, filterMapWithIndex(f)); };
var _filterWithIndex = function (fa, predicateWithIndex) { return (0,es6_function/* pipe */.zG)(fa, ReadonlyArray_filterWithIndex(predicateWithIndex)); };
var ReadonlyArray_extend = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_extend(f)); };
var ReadonlyArray_traverse = function (F) {
    var traverseF = es6_ReadonlyArray_traverse(F);
    return function (ta, f) { return (0,es6_function/* pipe */.zG)(ta, traverseF(f)); };
};
/* istanbul ignore next */
var ReadonlyArray_traverseWithIndex = function (F) {
    var traverseWithIndexF = es6_ReadonlyArray_traverseWithIndex(F);
    return function (ta, f) { return (0,es6_function/* pipe */.zG)(ta, traverseWithIndexF(f)); };
};
/** @internal */
var _chainRecDepthFirst = function (a, f) { return (0,es6_function/* pipe */.zG)(a, chainRecDepthFirst(f)); };
/** @internal */
var _chainRecBreadthFirst = function (a, f) { return (0,es6_function/* pipe */.zG)(a, chainRecBreadthFirst(f)); };
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * @category Pointed
 * @since 2.5.0
 */
var ReadonlyArray_of = of;
/**
 * @category Zero
 * @since 2.7.0
 */
var zero = function () { return ReadonlyArray_empty; };
/**
 * Less strict version of [`alt`](#alt).
 *
 * @category Alt
 * @since 2.9.0
 */
var ReadonlyArray_altW = function (that) { return function (fa) {
    return fa.concat(that());
}; };
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * @category Alt
 * @since 2.5.0
 */
var es6_ReadonlyArray_alt = ReadonlyArray_altW;
/**
 * Apply a function to an argument under a type constructor.
 *
 * @category Apply
 * @since 2.5.0
 */
var es6_ReadonlyArray_ap = function (fa) {
    return es6_ReadonlyArray_chain(function (f) { return (0,es6_function/* pipe */.zG)(fa, es6_ReadonlyArray_map(f)); });
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @category Monad
 * @since 2.5.0
 */
var es6_ReadonlyArray_chain = function (f) { return function (ma) {
    return (0,es6_function/* pipe */.zG)(ma, ReadonlyArray_chainWithIndex(function (_, a) { return f(a); }));
}; };
/**
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_flatten = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (es6_ReadonlyArray_chain(identity)));
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category Functor
 * @since 2.5.0
 */
var es6_ReadonlyArray_map = function (f) { return function (fa) {
    return fa.map(function (a) { return f(a); });
}; };
/**
 * @category FunctorWithIndex
 * @since 2.5.0
 */
var es6_ReadonlyArray_mapWithIndex = function (f) { return function (fa) { return fa.map(function (a, i) { return f(i, a); }); }; };
/**
 * @category Compactable
 * @since 2.5.0
 */
var separate = function (fa) {
    var left = [];
    var right = [];
    for (var _i = 0, fa_1 = fa; _i < fa_1.length; _i++) {
        var e = fa_1[_i];
        if (e._tag === 'Left') {
            left.push(e.left);
        }
        else {
            right.push(e.right);
        }
    }
    return (0,Separated/* separated */.s4)(left, right);
};
/**
 * @category Filterable
 * @since 2.5.0
 */
var ReadonlyArray_filter = function (predicate) { return function (as) { return as.filter(predicate); }; };
/**
 * @category FilterableWithIndex
 * @since 2.5.0
 */
var filterMapWithIndex = function (f) { return function (fa) {
    var out = [];
    for (var i = 0; i < fa.length; i++) {
        var optionB = f(i, fa[i]);
        if (internal/* isSome */.pC(optionB)) {
            out.push(optionB.value);
        }
    }
    return out;
}; };
/**
 * @category Filterable
 * @since 2.5.0
 */
var filterMap = function (f) {
    return filterMapWithIndex(function (_, a) { return f(a); });
};
/**
 * @category Compactable
 * @since 2.5.0
 */
var compact = 
/*#__PURE__*/
filterMap(es6_function/* identity */.yR);
/**
 * @category Filterable
 * @since 2.5.0
 */
var partition = function (predicate) {
    return partitionWithIndex(function (_, a) { return predicate(a); });
};
/**
 * @category FilterableWithIndex
 * @since 2.5.0
 */
var partitionWithIndex = function (predicateWithIndex) { return function (as) {
    var left = [];
    var right = [];
    for (var i = 0; i < as.length; i++) {
        var a = as[i];
        if (predicateWithIndex(i, a)) {
            right.push(a);
        }
        else {
            left.push(a);
        }
    }
    return (0,Separated/* separated */.s4)(left, right);
}; };
/**
 * @category Filterable
 * @since 2.5.0
 */
var partitionMap = function (f) {
    return partitionMapWithIndex(function (_, a) { return f(a); });
};
/**
 * @category FilterableWithIndex
 * @since 2.5.0
 */
var partitionMapWithIndex = function (f) { return function (fa) {
    var left = [];
    var right = [];
    for (var i = 0; i < fa.length; i++) {
        var e = f(i, fa[i]);
        if (e._tag === 'Left') {
            left.push(e.left);
        }
        else {
            right.push(e.right);
        }
    }
    return (0,Separated/* separated */.s4)(left, right);
}; };
/**
 * @category FilterableWithIndex
 * @since 2.5.0
 */
var ReadonlyArray_filterWithIndex = function (predicateWithIndex) { return function (as) {
    return as.filter(function (a, i) { return predicateWithIndex(i, a); });
}; };
/**
 * @category Extend
 * @since 2.5.0
 */
var es6_ReadonlyArray_extend = function (f) { return function (wa) { return wa.map(function (_, i) { return f(wa.slice(i)); }); }; };
/**
 * Derivable from `Extend`.
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_duplicate = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (es6_ReadonlyArray_extend(identity)));
/**
 * @category FoldableWithIndex
 * @since 2.5.0
 */
var es6_ReadonlyArray_foldMapWithIndex = function (M) { return function (f) { return function (fa) {
    return fa.reduce(function (b, a, i) { return M.concat(b, f(i, a)); }, M.empty);
}; }; };
/**
 * @category Foldable
 * @since 2.5.0
 */
var es6_ReadonlyArray_reduce = function (b, f) {
    return es6_ReadonlyArray_reduceWithIndex(b, function (_, b, a) { return f(b, a); });
};
/**
 * @category Foldable
 * @since 2.5.0
 */
var es6_ReadonlyArray_foldMap = function (M) {
    var foldMapWithIndexM = es6_ReadonlyArray_foldMapWithIndex(M);
    return function (f) { return foldMapWithIndexM(function (_, a) { return f(a); }); };
};
/**
 * @category FoldableWithIndex
 * @since 2.5.0
 */
var es6_ReadonlyArray_reduceWithIndex = function (b, f) { return function (fa) {
    var len = fa.length;
    var out = b;
    for (var i = 0; i < len; i++) {
        out = f(i, out, fa[i]);
    }
    return out;
}; };
/**
 * @category Foldable
 * @since 2.5.0
 */
var es6_ReadonlyArray_reduceRight = function (b, f) {
    return es6_ReadonlyArray_reduceRightWithIndex(b, function (_, a, b) { return f(a, b); });
};
/**
 * @category FoldableWithIndex
 * @since 2.5.0
 */
var es6_ReadonlyArray_reduceRightWithIndex = function (b, f) { return function (fa) { return fa.reduceRight(function (b, a, i) { return f(i, a, b); }, b); }; };
/**
 * @category Traversable
 * @since 2.6.3
 */
var es6_ReadonlyArray_traverse = function (F) {
    var traverseWithIndexF = es6_ReadonlyArray_traverseWithIndex(F);
    return function (f) { return traverseWithIndexF(function (_, a) { return f(a); }); };
};
/**
 * @category Traversable
 * @since 2.6.3
 */
var ReadonlyArray_sequence = function (F) { return function (ta) {
    return ReadonlyArray_reduce(ta, F.of(zero()), function (fas, fa) {
        return F.ap(F.map(fas, function (as) { return function (a) { return (0,es6_function/* pipe */.zG)(as, ReadonlyArray_append(a)); }; }), fa);
    });
}; };
/**
 * @category TraversableWithIndex
 * @since 2.6.3
 */
var es6_ReadonlyArray_traverseWithIndex = function (F) { return function (f) {
    return es6_ReadonlyArray_reduceWithIndex(F.of(zero()), function (i, fbs, a) {
        return F.ap(F.map(fbs, function (bs) { return function (b) { return (0,es6_function/* pipe */.zG)(bs, ReadonlyArray_append(b)); }; }), f(i, a));
    });
}; };
/**
 * @category Witherable
 * @since 2.6.5
 */
var wither = function (F) {
    var _witherF = _wither(F);
    return function (f) { return function (fa) { return _witherF(fa, f); }; };
};
/**
 * @category Witherable
 * @since 2.6.5
 */
var wilt = function (F) {
    var _wiltF = _wilt(F);
    return function (f) { return function (fa) { return _wiltF(fa, f); }; };
};
/**
 * @category Unfoldable
 * @since 2.6.6
 */
var unfold = function (b, f) {
    var out = [];
    var bb = b;
    while (true) {
        var mt = f(bb);
        if (internal/* isSome */.pC(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        }
        else {
            break;
        }
    }
    return out;
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.5.0
 */
var ReadonlyArray_URI = 'ReadonlyArray';
/**
 * @category instances
 * @since 2.5.0
 */
var ReadonlyArray_getShow = function (S) { return ({
    show: function (as) { return "[" + as.map(S.show).join(', ') + "]"; }
}); };
/**
 * @category instances
 * @since 2.5.0
 */
var ReadonlyArray_getSemigroup = function () { return ({
    concat: function (first, second) { return (isEmpty(first) ? second : isEmpty(second) ? first : first.concat(second)); }
}); };
/**
 * Returns a `Monoid` for `ReadonlyArray<A>`.
 *
 * @example
 * import { getMonoid } from 'fp-ts/ReadonlyArray'
 *
 * const M = getMonoid<number>()
 * assert.deepStrictEqual(M.concat([1, 2], [3, 4]), [1, 2, 3, 4])
 *
 * @category instances
 * @since 2.5.0
 */
var ReadonlyArray_getMonoid = function () { return ({
    concat: ReadonlyArray_getSemigroup().concat,
    empty: ReadonlyArray_empty
}); };
/**
 * Derives an `Eq` over the `ReadonlyArray` of a given element type from the `Eq` of that type. The derived `Eq` defines two
 * arrays as equal if all elements of both arrays are compared equal pairwise with the given `E`. In case of arrays of
 * different lengths, the result is non equality.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { getEq } from 'fp-ts/ReadonlyArray'
 *
 * const E = getEq(S.Eq)
 * assert.strictEqual(E.equals(['a', 'b'], ['a', 'b']), true)
 * assert.strictEqual(E.equals(['a'], []), false)
 *
 * @category instances
 * @since 2.5.0
 */
var ReadonlyArray_getEq = function (E) {
    return fromEquals(function (xs, ys) { return xs.length === ys.length && xs.every(function (x, i) { return E.equals(x, ys[i]); }); });
};
/**
 * Derives an `Ord` over the `ReadonlyArray` of a given element type from the `Ord` of that type. The ordering between two such
 * arrays is equal to: the first non equal comparison of each arrays elements taken pairwise in increasing order, in
 * case of equality over all the pairwise elements; the longest array is considered the greatest, if both arrays have
 * the same length, the result is equality.
 *
 * @example
 * import { getOrd } from 'fp-ts/ReadonlyArray'
 * import * as S from 'fp-ts/string'
 *
 * const O = getOrd(S.Ord)
 * assert.strictEqual(O.compare(['b'], ['a']), 1)
 * assert.strictEqual(O.compare(['a'], ['a']), 0)
 * assert.strictEqual(O.compare(['a'], ['b']), -1)
 *
 *
 * @category instances
 * @since 2.5.0
 */
var getOrd = function (O) {
    return fromCompare(function (a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for (var i = 0; i < len; i++) {
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) {
                return ordering;
            }
        }
        return Ord.compare(aLen, bLen);
    });
};
/**
 * @category instances
 * @since 2.11.0
 */
var ReadonlyArray_getUnionSemigroup = function (E) {
    var unionE = ReadonlyArray_union(E);
    return {
        concat: function (first, second) { return unionE(second)(first); }
    };
};
/**
 * @category instances
 * @since 2.11.0
 */
var getUnionMonoid = function (E) { return ({
    concat: ReadonlyArray_getUnionSemigroup(E).concat,
    empty: ReadonlyArray_empty
}); };
/**
 * @category instances
 * @since 2.11.0
 */
var getIntersectionSemigroup = function (E) {
    var intersectionE = intersection(E);
    return {
        concat: function (first, second) { return intersectionE(second)(first); }
    };
};
/**
 * @category instances
 * @since 2.11.0
 */
var getDifferenceMagma = function (E) {
    var differenceE = difference(E);
    return {
        concat: function (first, second) { return differenceE(second)(first); }
    };
};
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_Functor = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map
};
/**
 * Derivable from `Functor`.
 *
 * @category combinators
 * @since 2.10.0
 */
var ReadonlyArray_flap = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (flap_(ReadonlyArray_Functor)));
/**
 * @category instances
 * @since 2.10.0
 */
var ReadonlyArray_Pointed = {
    URI: ReadonlyArray_URI,
    of: ReadonlyArray_of
};
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_FunctorWithIndex = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    mapWithIndex: ReadonlyArray_mapWithIndex
};
/**
 * @category instances
 * @since 2.10.0
 */
var ReadonlyArray_Apply = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    ap: ReadonlyArray_ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_apFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apFirst_(ReadonlyArray_Apply)));
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_apSecond = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apSecond_(ReadonlyArray_Apply)));
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_Applicative = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    ap: ReadonlyArray_ap,
    of: ReadonlyArray_of
};
/**
 * @category instances
 * @since 2.10.0
 */
var ReadonlyArray_Chain = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    ap: ReadonlyArray_ap,
    chain: ReadonlyArray_chain
};
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_Monad = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    ap: ReadonlyArray_ap,
    of: ReadonlyArray_of,
    chain: ReadonlyArray_chain
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.5.0
 */
var ReadonlyArray_chainFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (chainFirst_(ReadonlyArray_Chain)));
/**
 * @category instances
 * @since 2.7.0
 */
var Unfoldable = {
    URI: ReadonlyArray_URI,
    unfold: unfold
};
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_Alt = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    alt: ReadonlyArray_alt
};
/**
 * @category instances
 * @since 2.11.0
 */
var Zero = {
    URI: ReadonlyArray_URI,
    zero: zero
};
/**
 * @category constructors
 * @since 2.11.0
 */
var guard = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (guard_(Zero, ReadonlyArray_Pointed)));
/**
 * @category instances
 * @since 2.7.0
 */
var Alternative = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    ap: ReadonlyArray_ap,
    of: ReadonlyArray_of,
    alt: ReadonlyArray_alt,
    zero: zero
};
/**
 * @category instances
 * @since 2.7.0
 */
var Extend = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    extend: ReadonlyArray_extend
};
/**
 * @category instances
 * @since 2.7.0
 */
var Compactable = {
    URI: ReadonlyArray_URI,
    compact: compact,
    separate: separate
};
/**
 * @category instances
 * @since 2.7.0
 */
var Filterable = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    compact: compact,
    separate: separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap
};
/**
 * @category instances
 * @since 2.7.0
 */
var FilterableWithIndex = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    mapWithIndex: ReadonlyArray_mapWithIndex,
    compact: compact,
    separate: separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    partitionMapWithIndex: _partitionMapWithIndex,
    partitionWithIndex: _partitionWithIndex,
    filterMapWithIndex: _filterMapWithIndex,
    filterWithIndex: _filterWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_Foldable = {
    URI: ReadonlyArray_URI,
    reduce: ReadonlyArray_reduce,
    foldMap: ReadonlyArray_foldMap,
    reduceRight: ReadonlyArray_reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_FoldableWithIndex = {
    URI: ReadonlyArray_URI,
    reduce: ReadonlyArray_reduce,
    foldMap: ReadonlyArray_foldMap,
    reduceRight: ReadonlyArray_reduceRight,
    reduceWithIndex: ReadonlyArray_reduceWithIndex,
    foldMapWithIndex: ReadonlyArray_foldMapWithIndex,
    reduceRightWithIndex: ReadonlyArray_reduceRightWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_Traversable = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    reduce: ReadonlyArray_reduce,
    foldMap: ReadonlyArray_foldMap,
    reduceRight: ReadonlyArray_reduceRight,
    traverse: ReadonlyArray_traverse,
    sequence: ReadonlyArray_sequence
};
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_TraversableWithIndex = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    mapWithIndex: ReadonlyArray_mapWithIndex,
    reduce: ReadonlyArray_reduce,
    foldMap: ReadonlyArray_foldMap,
    reduceRight: ReadonlyArray_reduceRight,
    reduceWithIndex: ReadonlyArray_reduceWithIndex,
    foldMapWithIndex: ReadonlyArray_foldMapWithIndex,
    reduceRightWithIndex: ReadonlyArray_reduceRightWithIndex,
    traverse: ReadonlyArray_traverse,
    sequence: ReadonlyArray_sequence,
    traverseWithIndex: ReadonlyArray_traverseWithIndex
};
/**
 * @category ChainRec
 * @since 2.11.0
 */
var chainRecDepthFirst = function (f) { return function (a) {
    var todo = ReadonlyArray_spreadArray([], f(a));
    var out = [];
    while (todo.length > 0) {
        var e = todo.shift();
        if (internal/* isLeft */.nM(e)) {
            todo.unshift.apply(todo, f(e.left));
        }
        else {
            out.push(e.right);
        }
    }
    return out;
}; };
/**
 * @category instances
 * @since 2.11.0
 */
var ChainRecDepthFirst = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    ap: ReadonlyArray_ap,
    chain: ReadonlyArray_chain,
    chainRec: _chainRecDepthFirst
};
/**
 * @category ChainRec
 * @since 2.11.0
 */
var chainRecBreadthFirst = function (f) { return function (a) {
    var initial = f(a);
    var todo = [];
    var out = [];
    function go(e) {
        if (internal/* isLeft */.nM(e)) {
            f(e.left).forEach(function (v) { return todo.push(v); });
        }
        else {
            out.push(e.right);
        }
    }
    for (var _i = 0, initial_1 = initial; _i < initial_1.length; _i++) {
        var e = initial_1[_i];
        go(e);
    }
    while (todo.length > 0) {
        go(todo.shift());
    }
    return out;
}; };
/**
 * @category instances
 * @since 2.11.0
 */
var ChainRecBreadthFirst = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    ap: ReadonlyArray_ap,
    chain: ReadonlyArray_chain,
    chainRec: _chainRecBreadthFirst
};
var _wither = (0,Witherable/* witherDefault */.BL)(ReadonlyArray_Traversable, Compactable);
var _wilt = (0,Witherable/* wiltDefault */.Fj)(ReadonlyArray_Traversable, Compactable);
/**
 * @category instances
 * @since 2.7.0
 */
var ReadonlyArray_Witherable = {
    URI: ReadonlyArray_URI,
    map: ReadonlyArray_map,
    compact: compact,
    separate: separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    reduce: ReadonlyArray_reduce,
    foldMap: ReadonlyArray_foldMap,
    reduceRight: ReadonlyArray_reduceRight,
    traverse: ReadonlyArray_traverse,
    sequence: ReadonlyArray_sequence,
    wither: _wither,
    wilt: _wilt
};
/**
 * Filter values inside a context.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import * as T from 'fp-ts/Task'
 *
 * const filterE = RA.filterE(T.ApplicativePar)
 * async function test() {
 *   assert.deepStrictEqual(
 *     await pipe(
 *       [-1, 2, 3],
 *       filterE((n) => T.of(n > 0))
 *     )(),
 *     [2, 3]
 *   )
 * }
 * test()
 *
 * @since 2.11.0
 */
var filterE = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (filterE_(ReadonlyArray_Witherable)));
/**
 * @category instances
 * @since 2.11.0
 */
var FromEither = {
    URI: ReadonlyArray_URI,
    fromEither: fromEither
};
/**
 * @category combinators
 * @since 2.11.0
 */
var fromEitherK = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (fromEitherK_(FromEither)));
// -------------------------------------------------------------------------------------
// unsafe
// -------------------------------------------------------------------------------------
/**
 * @category unsafe
 * @since 2.5.0
 */
var ReadonlyArray_unsafeInsertAt = unsafeInsertAt;
/**
 * @category unsafe
 * @since 2.5.0
 */
var ReadonlyArray_unsafeUpdateAt = function (i, a, as) {
    return ReadonlyArray_isNonEmpty(as) ? RNEA.unsafeUpdateAt(i, a, as) : as;
};
/**
 * @category unsafe
 * @since 2.5.0
 */
var unsafeDeleteAt = function (i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
// -------------------------------------------------------------------------------------
// interop
// -------------------------------------------------------------------------------------
/**
 * @category interop
 * @since 2.5.0
 */
var toArray = function (as) { return as.slice(); };
/**
 * @category interop
 * @since 2.5.0
 */
var ReadonlyArray_fromArray = function (as) { return (isEmpty(as) ? ReadonlyArray_empty : as.slice()); };
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * An empty array
 *
 * @since 2.5.0
 */
var ReadonlyArray_empty = ReadonlyNonEmptyArray_empty;
/**
 * Check if a predicate holds true for every array member.
 *
 * @example
 * import { every } from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const isPositive = (n: number): boolean => n > 0
 *
 * assert.deepStrictEqual(pipe([1, 2, 3], every(isPositive)), true)
 * assert.deepStrictEqual(pipe([1, 2, -3], every(isPositive)), false)
 *
 * @since 2.9.0
 */
var every = function (predicate) { return function (as) { return as.every(predicate); }; };
/**
 * Check if a predicate holds true for any array member.
 *
 * @example
 * import { some } from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const isPositive = (n: number): boolean => n > 0
 *
 * assert.deepStrictEqual(pipe([-1, -2, 3], some(isPositive)), true)
 * assert.deepStrictEqual(pipe([-1, -2, -3], some(isPositive)), false)
 *
 * @since 2.9.0
 */
var some = function (predicate) { return function (as) {
    return as.some(predicate);
}; };
/**
 * Alias of [`some`](#some)
 *
 * @since 2.11.0
 */
var exists = (/* unused pure expression or super */ null && (some));
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @since 2.9.0
 */
var ReadonlyArray_Do = 
/*#__PURE__*/
ReadonlyArray_of(internal/* emptyRecord */.F4);
/**
 * @since 2.8.0
 */
var ReadonlyArray_bindTo = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bindTo_(ReadonlyArray_Functor)));
/**
 * @since 2.8.0
 */
var ReadonlyArray_bind = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bind_(ReadonlyArray_Chain)));
// -------------------------------------------------------------------------------------
// pipeable sequence S
// -------------------------------------------------------------------------------------
/**
 * @since 2.8.0
 */
var ReadonlyArray_apS = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apS_(ReadonlyArray_Apply)));
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
// tslint:disable: deprecation
/**
 * Use `ReadonlyNonEmptyArray` module instead.
 *
 * @category constructors
 * @since 2.5.0
 * @deprecated
 */
var ReadonlyArray_range = range;
/**
 * Use [`prepend`](#prepend) instead.
 *
 * @category constructors
 * @since 2.5.0
 * @deprecated
 */
var ReadonlyArray_cons = cons;
/**
 * Use [`append`](#append) instead.
 *
 * @category constructors
 * @since 2.5.0
 * @deprecated
 */
var ReadonlyArray_snoc = snoc;
/**
 * Use [`prependAll`](#prependall) instead.
 *
 * @category combinators
 * @since 2.9.0
 * @deprecated
 */
var ReadonlyArray_prependToAll = (/* unused pure expression or super */ null && (ReadonlyArray_prependAll));
/**
 * Use small, specific instances instead.
 *
 * @category instances
 * @since 2.5.0
 * @deprecated
 */
var readonlyArray = {
    URI: ReadonlyArray_URI,
    compact: compact,
    separate: separate,
    map: ReadonlyArray_map,
    ap: ReadonlyArray_ap,
    of: ReadonlyArray_of,
    chain: ReadonlyArray_chain,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    mapWithIndex: ReadonlyArray_mapWithIndex,
    partitionMapWithIndex: _partitionMapWithIndex,
    partitionWithIndex: _partitionWithIndex,
    filterMapWithIndex: _filterMapWithIndex,
    filterWithIndex: _filterWithIndex,
    alt: ReadonlyArray_alt,
    zero: zero,
    unfold: unfold,
    reduce: ReadonlyArray_reduce,
    foldMap: ReadonlyArray_foldMap,
    reduceRight: ReadonlyArray_reduceRight,
    traverse: ReadonlyArray_traverse,
    sequence: ReadonlyArray_sequence,
    reduceWithIndex: ReadonlyArray_reduceWithIndex,
    foldMapWithIndex: ReadonlyArray_foldMapWithIndex,
    reduceRightWithIndex: ReadonlyArray_reduceRightWithIndex,
    traverseWithIndex: ReadonlyArray_traverseWithIndex,
    extend: ReadonlyArray_extend,
    wither: _wither,
    wilt: _wilt
};

;// CONCATENATED MODULE: ./node_modules/fp-ts/es6/Array.js











// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Test whether an array is empty
 *
 * @example
 * import { isEmpty } from 'fp-ts/Array'
 *
 * assert.strictEqual(isEmpty([]), true)
 *
 * @category refinements
 * @since 2.0.0
 */
var Array_isEmpty = function (as) { return as.length === 0; };
/**
 * Test whether an array is non empty narrowing down the type to `NonEmptyArray<A>`
 *
 * @category refinements
 * @since 2.0.0
 */
var Array_isNonEmpty = NonEmptyArray_isNonEmpty;
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Prepend an element to the front of a `Array`, creating a new `NonEmptyArray`.
 *
 * @example
 * import { prepend } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([2, 3, 4], prepend(1)), [1, 2, 3, 4])
 *
 * @category constructors
 * @since 2.10.0
 */
var Array_prepend = NonEmptyArray_prepend;
/**
 * Less strict version of [`prepend`](#prepend).
 *
 * @category constructors
 * @since 2.11.0
 */
var Array_prependW = NonEmptyArray_prependW;
/**
 * Append an element to the end of a `Array`, creating a new `NonEmptyArray`.
 *
 * @example
 * import { append } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([1, 2, 3], append(4)), [1, 2, 3, 4])
 *
 * @category constructors
 * @since 2.10.0
 */
var Array_append = NonEmptyArray_append;
/**
 * Less strict version of [`append`](#append).
 *
 * @category constructors
 * @since 2.11.0
 */
var Array_appendW = NonEmptyArray_appendW;
/**
 * Return a `Array` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { makeBy } from 'fp-ts/Array'
 *
 * const double = (n: number): number => n * 2
 * assert.deepStrictEqual(makeBy(5, double), [0, 2, 4, 6, 8])
 *
 * @category constructors
 * @since 2.0.0
 */
var Array_makeBy = function (n, f) { return (n <= 0 ? [] : NEA.makeBy(f)(n)); };
/**
 * Create a `Array` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { replicate } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(replicate(3, 'a'), ['a', 'a', 'a'])
 *
 * @category constructors
 * @since 2.0.0
 */
var Array_replicate = function (n, a) { return Array_makeBy(n, function () { return a; }); };
function Array_fromPredicate(predicate) {
    return function (a) { return (predicate(a) ? [a] : []); };
}
// -------------------------------------------------------------------------------------
// natural transformations
// -------------------------------------------------------------------------------------
/**
 * @category natural transformations
 * @since 2.11.0
 */
var Array_fromOption = function (ma) { return (_.isNone(ma) ? [] : [ma.value]); };
/**
 * @category natural transformations
 * @since 2.11.0
 */
var Array_fromEither = function (e) { return (internal/* isLeft */.nM(e) ? [] : [e.right]); };
// -------------------------------------------------------------------------------------
// destructors
// -------------------------------------------------------------------------------------
/**
 * Less strict version of [`match`](#match).
 *
 * @category destructors
 * @since 2.11.0
 */
var Array_matchW = function (onEmpty, onNonEmpty) { return function (as) {
    return Array_isNonEmpty(as) ? onNonEmpty(as) : onEmpty();
}; };
/**
 * Less strict version of [`match`](#match).
 *
 * @category destructors
 * @since 2.11.0
 */
var Array_match = (/* unused pure expression or super */ null && (Array_matchW));
/**
 * Less strict version of [`matchLeft`](#matchleft).
 *
 * @category destructors
 * @since 2.11.0
 */
var Array_matchLeftW = function (onEmpty, onNonEmpty) { return function (as) { return (Array_isNonEmpty(as) ? onNonEmpty(NEA.head(as), NEA.tail(as)) : onEmpty()); }; };
/**
 * Break an `Array` into its first element and remaining elements.
 *
 * @example
 * import { matchLeft } from 'fp-ts/Array'
 *
 * const len: <A>(as: Array<A>) => number = matchLeft(() => 0, (_, tail) => 1 + len(tail))
 * assert.strictEqual(len([1, 2, 3]), 3)
 *
 * @category destructors
 * @since 2.10.0
 */
var Array_matchLeft = (/* unused pure expression or super */ null && (Array_matchLeftW));
/**
 * Alias of [`matchLeft`](#matchleft).
 *
 * @category destructors
 * @since 2.0.0
 */
var Array_foldLeft = (/* unused pure expression or super */ null && (Array_matchLeft));
/**
 * Less strict version of [`matchRight`](#matchright).
 *
 * @category destructors
 * @since 2.11.0
 */
var Array_matchRightW = function (onEmpty, onNonEmpty) { return function (as) { return (Array_isNonEmpty(as) ? onNonEmpty(NEA.init(as), NEA.last(as)) : onEmpty()); }; };
/**
 * Break an `Array` into its initial elements and the last element.
 *
 * @category destructors
 * @since 2.10.0
 */
var Array_matchRight = (/* unused pure expression or super */ null && (Array_matchRightW));
/**
 * Alias of [`matchRight`](#matchright).
 *
 * @category destructors
 * @since 2.0.0
 */
var Array_foldRight = (/* unused pure expression or super */ null && (Array_matchRight));
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category combinators
 * @since 2.7.0
 */
var Array_chainWithIndex = function (f) { return function (as) {
    var out = [];
    for (var i = 0; i < as.length; i++) {
        out.push.apply(out, f(i, as[i]));
    }
    return out;
}; };
/**
 * Same as `reduce` but it carries over the intermediate steps
 *
 * @example
 * import { scanLeft } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(scanLeft(10, (b, a: number) => b - a)([1, 2, 3]), [10, 9, 7, 4])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_scanLeft = function (b, f) { return function (as) {
    var len = as.length;
    var out = new Array(len + 1);
    out[0] = b;
    for (var i = 0; i < len; i++) {
        out[i + 1] = f(out[i], as[i]);
    }
    return out;
}; };
/**
 * Fold an array from the right, keeping all intermediate results instead of only the final result
 *
 * @example
 * import { scanRight } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(scanRight(10, (a: number, b) => b - a)([1, 2, 3]), [4, 5, 7, 10])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_scanRight = function (b, f) { return function (as) {
    var len = as.length;
    var out = new Array(len + 1);
    out[len] = b;
    for (var i = len - 1; i >= 0; i--) {
        out[i] = f(as[i], out[i + 1]);
    }
    return out;
}; };
/**
 * Calculate the number of elements in a `Array`.
 *
 * @since 2.10.0
 */
var Array_size = function (as) { return as.length; };
/**
 * Test whether an array contains a particular index
 *
 * @since 2.0.0
 */
var Array_isOutOfBound = NonEmptyArray_isOutOfBound;
// TODO: remove non-curried overloading in v3
/**
 * This function provides a safe way to read a value at a particular index from an array
 *
 * @example
 * import { lookup } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([1, 2, 3], lookup(1)), some(2))
 * assert.deepStrictEqual(pipe([1, 2, 3], lookup(3)), none)
 *
 * @since 2.0.0
 */
var Array_lookup = lookup;
/**
 * Get the first element in an array, or `None` if the array is empty
 *
 * @example
 * import { head } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(head([1, 2, 3]), some(1))
 * assert.deepStrictEqual(head([]), none)
 *
 * @category destructors
 * @since 2.0.0
 */
var Array_head = ReadonlyArray_head;
/**
 * Get the last element in an array, or `None` if the array is empty
 *
 * @example
 * import { last } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(last([1, 2, 3]), some(3))
 * assert.deepStrictEqual(last([]), none)
 *
 * @category destructors
 * @since 2.0.0
 */
var Array_last = ReadonlyArray_last;
/**
 * Get all but the first element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { tail } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(tail([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(tail([]), none)
 *
 * @category destructors
 * @since 2.0.0
 */
var Array_tail = function (as) { return (Array_isNonEmpty(as) ? _.some(NEA.tail(as)) : _.none); };
/**
 * Get all but the last element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { init } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), some([1, 2]))
 * assert.deepStrictEqual(init([]), none)
 *
 * @category destructors
 * @since 2.0.0
 */
var Array_init = function (as) { return (Array_isNonEmpty(as) ? internal/* some */.G(NonEmptyArray_init(as)) : internal/* none */.YP); };
/**
 * Keep only a max number of elements from the start of an `Array`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { takeLeft } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(takeLeft(2)([1, 2, 3]), [1, 2])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_takeLeft = function (n) { return function (as) { return (Array_isOutOfBound(n, as) ? Array_copy(as) : as.slice(0, n)); }; };
/**
 * Keep only a max number of elements from the end of an `Array`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { takeRight } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(takeRight(2)([1, 2, 3, 4, 5]), [4, 5])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_takeRight = function (n) { return function (as) {
    return Array_isOutOfBound(n, as) ? Array_copy(as) : n === 0 ? [] : as.slice(-n);
}; };
function Array_takeLeftWhile(predicate) {
    return function (as) {
        var out = [];
        for (var _i = 0, as_1 = as; _i < as_1.length; _i++) {
            var a = as_1[_i];
            if (!predicate(a)) {
                break;
            }
            out.push(a);
        }
        return out;
    };
}
var Array_spanLeftIndex = function (as, predicate) {
    var l = as.length;
    var i = 0;
    for (; i < l; i++) {
        if (!predicate(as[i])) {
            break;
        }
    }
    return i;
};
function Array_spanLeft(predicate) {
    return function (as) {
        var _a = Array_splitAt(Array_spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return { init: init, rest: rest };
    };
}
/**
 * Drop a max number of elements from the start of an `Array`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { dropLeft } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(dropLeft(2)([1, 2, 3]), [3])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_dropLeft = function (n) { return function (as) {
    return n <= 0 || Array_isEmpty(as) ? Array_copy(as) : n >= as.length ? [] : as.slice(n, as.length);
}; };
/**
 * Drop a max number of elements from the end of an `Array`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { dropRight } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(dropRight(2)([1, 2, 3, 4, 5]), [1, 2, 3])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_dropRight = function (n) { return function (as) {
    return n <= 0 || Array_isEmpty(as) ? Array_copy(as) : n >= as.length ? [] : as.slice(0, as.length - n);
}; };
function Array_dropLeftWhile(predicate) {
    return function (as) { return as.slice(Array_spanLeftIndex(as, predicate)); };
}
/**
 * Find the first index for which a predicate holds
 *
 * @example
 * import { findIndex } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(findIndex((n: number) => n === 2)([1, 2, 3]), some(1))
 * assert.deepStrictEqual(findIndex((n: number) => n === 2)([]), none)
 *
 * @since 2.0.0
 */
var Array_findIndex = findIndex;
function Array_findFirst(predicate) {
    return RA.findFirst(predicate);
}
/**
 * Find the first element returned by an option based selector function
 *
 * @example
 * import { findFirstMap } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age?: number
 * }
 *
 * const persons: Array<Person> = [{ name: 'John' }, { name: 'Mary', age: 45 }, { name: 'Joey', age: 28 }]
 *
 * // returns the name of the first person that has an age
 * assert.deepStrictEqual(findFirstMap((p: Person) => (p.age === undefined ? none : some(p.name)))(persons), some('Mary'))
 *
 * @category destructors
 * @since 2.0.0
 */
var Array_findFirstMap = findFirstMap;
function Array_findLast(predicate) {
    return RA.findLast(predicate);
}
/**
 * Find the last element returned by an option based selector function
 *
 * @example
 * import { findLastMap } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age?: number
 * }
 *
 * const persons: Array<Person> = [{ name: 'John' }, { name: 'Mary', age: 45 }, { name: 'Joey', age: 28 }]
 *
 * // returns the name of the last person that has an age
 * assert.deepStrictEqual(findLastMap((p: Person) => (p.age === undefined ? none : some(p.name)))(persons), some('Joey'))
 *
 * @category destructors
 * @since 2.0.0
 */
var Array_findLastMap = findLastMap;
/**
 * Returns the index of the last element of the list which matches the predicate
 *
 * @example
 * import { findLastIndex } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface X {
 *   readonly a: number
 *   readonly b: number
 * }
 * const xs: Array<X> = [{ a: 1, b: 0 }, { a: 1, b: 1 }]
 * assert.deepStrictEqual(findLastIndex((x: { readonly a: number }) => x.a === 1)(xs), some(1))
 * assert.deepStrictEqual(findLastIndex((x: { readonly a: number }) => x.a === 4)(xs), none)
 *
 *
 * @since 2.0.0
 */
var Array_findLastIndex = findLastIndex;
/**
 * @category combinators
 * @since 2.0.0
 */
var Array_copy = function (as) { return as.slice(); };
/**
 * Insert an element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { insertAt } from 'fp-ts/Array'
 * import { some } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(insertAt(2, 5)([1, 2, 3, 4]), some([1, 2, 5, 3, 4]))
 *
 * @since 2.0.0
 */
var Array_insertAt = function (i, a) { return function (as) {
    return i < 0 || i > as.length ? _.none : _.some(Array_unsafeInsertAt(i, a, as));
}; };
/**
 * Change the element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { updateAt } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(updateAt(1, 1)([1, 2, 3]), some([1, 1, 3]))
 * assert.deepStrictEqual(updateAt(1, 1)([]), none)
 *
 * @since 2.0.0
 */
var Array_updateAt = function (i, a) { return Array_modifyAt(i, function () { return a; }); };
/**
 * Delete the element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { deleteAt } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(deleteAt(0)([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(deleteAt(1)([]), none)
 *
 * @since 2.0.0
 */
var Array_deleteAt = function (i) { return function (as) {
    return Array_isOutOfBound(i, as) ? _.none : _.some(Array_unsafeDeleteAt(i, as));
}; };
/**
 * Apply a function to the element at the specified index, creating a new array, or returning `None` if the index is out
 * of bounds
 *
 * @example
 * import { modifyAt } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * const double = (x: number): number => x * 2
 * assert.deepStrictEqual(modifyAt(1, double)([1, 2, 3]), some([1, 4, 3]))
 * assert.deepStrictEqual(modifyAt(1, double)([]), none)
 *
 * @since 2.0.0
 */
var Array_modifyAt = function (i, f) { return function (as) {
    return Array_isOutOfBound(i, as) ? _.none : _.some(Array_unsafeUpdateAt(i, f(as[i]), as));
}; };
/**
 * Reverse an array, creating a new array
 *
 * @example
 * import { reverse } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(reverse([1, 2, 3]), [3, 2, 1])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_reverse = function (as) { return (Array_isEmpty(as) ? [] : as.slice().reverse()); };
/**
 * Extracts from an array of `Either` all the `Right` elements. All the `Right` elements are extracted in order
 *
 * @example
 * import { rights } from 'fp-ts/Array'
 * import { right, left } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(rights([right(1), left('foo'), right(2)]), [1, 2])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_rights = function (as) {
    var r = [];
    for (var i = 0; i < as.length; i++) {
        var a = as[i];
        if (a._tag === 'Right') {
            r.push(a.right);
        }
    }
    return r;
};
/**
 * Extracts from an array of `Either` all the `Left` elements. All the `Left` elements are extracted in order
 *
 * @example
 * import { lefts } from 'fp-ts/Array'
 * import { left, right } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(lefts([right(1), left('foo'), right(2)]), ['foo'])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_lefts = function (as) {
    var r = [];
    for (var i = 0; i < as.length; i++) {
        var a = as[i];
        if (a._tag === 'Left') {
            r.push(a.left);
        }
    }
    return r;
};
/**
 * Sort the elements of an array in increasing order, creating a new array
 *
 * @example
 * import { sort } from 'fp-ts/Array'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(sort(N.Ord)([3, 2, 1]), [1, 2, 3])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_sort = function (O) { return function (as) {
    return as.length <= 1 ? Array_copy(as) : as.slice().sort(O.compare);
}; };
/**
 * Apply a function to pairs of elements at the same index in two arrays, collecting the results in a new array. If one
 * input array is short, excess elements of the longer array are discarded.
 *
 * @example
 * import { zipWith } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(zipWith([1, 2, 3], ['a', 'b', 'c', 'd'], (n, s) => s + n), ['a1', 'b2', 'c3'])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_zipWith = function (fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for (var i = 0; i < len; i++) {
        fc[i] = f(fa[i], fb[i]);
    }
    return fc;
};
function Array_zip(as, bs) {
    if (bs === undefined) {
        return function (bs) { return Array_zip(bs, as); };
    }
    return Array_zipWith(as, bs, function (a, b) { return [a, b]; });
}
/**
 * The function is reverse of `zip`. Takes an array of pairs and return two corresponding arrays
 *
 * @example
 * import { unzip } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(unzip([[1, 'a'], [2, 'b'], [3, 'c']]), [[1, 2, 3], ['a', 'b', 'c']])
 *
 * @since 2.0.0
 */
var Array_unzip = function (as) {
    var fa = [];
    var fb = [];
    for (var i = 0; i < as.length; i++) {
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [fa, fb];
};
/**
 * Prepend an element to every member of an array
 *
 * @example
 * import { prependAll } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(prependAll(9)([1, 2, 3, 4]), [9, 1, 9, 2, 9, 3, 9, 4])
 *
 * @category combinators
 * @since 2.10.0
 */
var Array_prependAll = function (middle) {
    var f = NEA.prependAll(middle);
    return function (as) { return (Array_isNonEmpty(as) ? f(as) : []); };
};
/**
 * Places an element in between members of an array
 *
 * @example
 * import { intersperse } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(intersperse(9)([1, 2, 3, 4]), [1, 9, 2, 9, 3, 9, 4])
 *
 * @category combinators
 * @since 2.9.0
 */
var Array_intersperse = function (middle) {
    var f = NEA.intersperse(middle);
    return function (as) { return (Array_isNonEmpty(as) ? f(as) : Array_copy(as)); };
};
/**
 * Rotate a `Array` by `n` steps.
 *
 * @example
 * import { rotate } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(rotate(2)([1, 2, 3, 4, 5]), [4, 5, 1, 2, 3])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_rotate = function (n) {
    var f = NEA.rotate(n);
    return function (as) { return (Array_isNonEmpty(as) ? f(as) : Array_copy(as)); };
};
// TODO: remove non-curried overloading in v3
/**
 * Test if a value is a member of an array. Takes a `Eq<A>` as a single
 * argument which returns the function to use to search for a value of type `A` in
 * an array of type `Array<A>`.
 *
 * @example
 * import { elem } from 'fp-ts/Array'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(pipe([1, 2, 3], elem(N.Eq)(2)), true)
 * assert.strictEqual(pipe([1, 2, 3], elem(N.Eq)(0)), false)
 *
 * @since 2.0.0
 */
var Array_elem = elem;
/**
 * Remove duplicates from an array, keeping the first occurrence of an element.
 *
 * @example
 * import { uniq } from 'fp-ts/Array'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(uniq(N.Eq)([1, 2, 1]), [1, 2])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_uniq = function (E) {
    var f = NEA.uniq(E);
    return function (as) { return (Array_isNonEmpty(as) ? f(as) : Array_copy(as)); };
};
/**
 * Sort the elements of an array in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import { sortBy } from 'fp-ts/Array'
 * import { contramap } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age: number
 * }
 * const byName = pipe(S.Ord, contramap((p: Person) => p.name))
 * const byAge = pipe(N.Ord, contramap((p: Person) => p.age))
 *
 * const sortByNameByAge = sortBy([byName, byAge])
 *
 * const persons = [{ name: 'a', age: 1 }, { name: 'b', age: 3 }, { name: 'c', age: 2 }, { name: 'b', age: 2 }]
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_sortBy = function (ords) {
    var f = NEA.sortBy(ords);
    return function (as) { return (Array_isNonEmpty(as) ? f(as) : Array_copy(as)); };
};
/**
 * A useful recursion pattern for processing an array to produce a new array, often used for "chopping" up the input
 * array. Typically chop is called with some function that will consume an initial prefix of the array and produce a
 * value and the rest of the array.
 *
 * @example
 * import { Eq } from 'fp-ts/Eq'
 * import * as A from 'fp-ts/Array'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * const group = <A>(S: Eq<A>): ((as: Array<A>) => Array<Array<A>>) => {
 *   return A.chop(as => {
 *     const { init, rest } = pipe(as, A.spanLeft((a: A) => S.equals(a, as[0])))
 *     return [init, rest]
 *   })
 * }
 * assert.deepStrictEqual(group(N.Eq)([1, 1, 2, 3, 3, 4]), [[1, 1], [2], [3, 3], [4]])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_chop = function (f) {
    var g = NEA.chop(f);
    return function (as) { return (Array_isNonEmpty(as) ? g(as) : []); };
};
/**
 * Splits an `Array` into two pieces, the first piece has max `n` elements.
 *
 * @example
 * import { splitAt } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(splitAt(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4, 5]])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_splitAt = function (n) { return function (as) {
    return n >= 1 && Array_isNonEmpty(as) ? NEA.splitAt(n)(as) : Array_isEmpty(as) ? [Array_copy(as), []] : [[], Array_copy(as)];
}; };
/**
 * Splits an array into length-`n` pieces. The last piece will be shorter if `n` does not evenly divide the length of
 * the array. Note that `chunksOf(n)([])` is `[]`, not `[[]]`. This is intentional, and is consistent with a recursive
 * definition of `chunksOf`; it satisfies the property that
 *
 * ```ts
 * chunksOf(n)(xs).concat(chunksOf(n)(ys)) == chunksOf(n)(xs.concat(ys)))
 * ```
 *
 * whenever `n` evenly divides the length of `xs`.
 *
 * @example
 * import { chunksOf } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(chunksOf(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4], [5]])
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_chunksOf = function (n) {
    var f = NEA.chunksOf(n);
    return function (as) { return (Array_isNonEmpty(as) ? f(as) : []); };
};
/**
 * @category combinators
 * @since 2.11.0
 */
var Array_fromOptionK = function (f) { return function () {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
    }
    return Array_fromOption(f.apply(void 0, a));
}; };
function Array_comprehension(input, f, g) {
    if (g === void 0) { g = function () { return true; }; }
    var go = function (scope, input) {
        return Array_isNonEmpty(input)
            ? pipe(NEA.head(input), es6_Array_chain(function (x) { return go(pipe(scope, Array_append(x)), NEA.tail(input)); }))
            : g.apply(void 0, scope) ? [f.apply(void 0, scope)]
                : [];
    };
    return go([], input);
}
/**
 * @category combinators
 * @since 2.11.0
 */
var Array_concatW = function (second) { return function (first) {
    return Array_isEmpty(first) ? Array_copy(second) : Array_isEmpty(second) ? Array_copy(first) : first.concat(second);
}; };
/**
 * @category combinators
 * @since 2.11.0
 */
var Array_concat = (/* unused pure expression or super */ null && (Array_concatW));
function Array_union(E) {
    var unionE = NEA.union(E);
    return function (first, second) {
        if (second === undefined) {
            var unionE_1 = Array_union(E);
            return function (second) { return unionE_1(second, first); };
        }
        return Array_isNonEmpty(first) && Array_isNonEmpty(second)
            ? unionE(second)(first)
            : Array_isNonEmpty(first)
                ? Array_copy(first)
                : Array_copy(second);
    };
}
function Array_intersection(E) {
    var elemE = Array_elem(E);
    return function (xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = Array_intersection(E);
            return function (ys) { return intersectionE_1(ys, xs); };
        }
        return xs.filter(function (a) { return elemE(a, ys); });
    };
}
function Array_difference(E) {
    var elemE = Array_elem(E);
    return function (xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = Array_difference(E);
            return function (ys) { return differenceE_1(ys, xs); };
        }
        return xs.filter(function (a) { return !elemE(a, ys); });
    };
}
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var Array_map = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_map(f)); };
/* istanbul ignore next */
var Array_mapWithIndex = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_mapWithIndex(f)); };
var Array_ap = function (fab, fa) { return (0,es6_function/* pipe */.zG)(fab, es6_Array_ap(fa)); };
var Array_chain = function (ma, f) { return (0,es6_function/* pipe */.zG)(ma, es6_Array_chain(f)); };
/* istanbul ignore next */
var Array_filter = function (fa, predicate) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_filter(predicate)); };
/* istanbul ignore next */
var Array_filterMap = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_filterMap(f)); };
/* istanbul ignore next */
var Array_partition = function (fa, predicate) {
    return (0,es6_function/* pipe */.zG)(fa, es6_Array_partition(predicate));
};
/* istanbul ignore next */
var Array_partitionMap = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_partitionMap(f)); };
/* istanbul ignore next */
var Array_partitionWithIndex = function (fa, predicateWithIndex) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_partitionWithIndex(predicateWithIndex)); };
/* istanbul ignore next */
var Array_partitionMapWithIndex = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_partitionMapWithIndex(f)); };
/* istanbul ignore next */
var Array_alt = function (fa, that) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_alt(that)); };
var Array_reduce = function (fa, b, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_reduce(b, f)); };
/* istanbul ignore next */
var Array_foldMap = function (M) {
    var foldMapM = es6_Array_foldMap(M);
    return function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, foldMapM(f)); };
};
/* istanbul ignore next */
var Array_reduceRight = function (fa, b, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_reduceRight(b, f)); };
/* istanbul ignore next */
var Array_reduceWithIndex = function (fa, b, f) {
    return (0,es6_function/* pipe */.zG)(fa, es6_Array_reduceWithIndex(b, f));
};
/* istanbul ignore next */
var Array_foldMapWithIndex = function (M) {
    var foldMapWithIndexM = es6_Array_foldMapWithIndex(M);
    return function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, foldMapWithIndexM(f)); };
};
/* istanbul ignore next */
var Array_reduceRightWithIndex = function (fa, b, f) {
    return (0,es6_function/* pipe */.zG)(fa, es6_Array_reduceRightWithIndex(b, f));
};
/* istanbul ignore next */
var Array_filterMapWithIndex = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_filterMapWithIndex(f)); };
/* istanbul ignore next */
var Array_filterWithIndex = function (fa, predicateWithIndex) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_filterWithIndex(predicateWithIndex)); };
/* istanbul ignore next */
var Array_extend = function (fa, f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_extend(f)); };
/* istanbul ignore next */
var Array_traverse = function (F) {
    var traverseF = es6_Array_traverse(F);
    return function (ta, f) { return (0,es6_function/* pipe */.zG)(ta, traverseF(f)); };
};
/* istanbul ignore next */
var Array_traverseWithIndex = function (F) {
    var traverseWithIndexF = es6_Array_traverseWithIndex(F);
    return function (ta, f) { return (0,es6_function/* pipe */.zG)(ta, traverseWithIndexF(f)); };
};
var Array_chainRecDepthFirst = _chainRecDepthFirst;
var Array_chainRecBreadthFirst = _chainRecBreadthFirst;
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * @category Pointed
 * @since 2.0.0
 */
var Array_of = NonEmptyArray_of;
/**
 * @category Zero
 * @since 2.7.0
 */
var Array_zero = function () { return []; };
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category Functor
 * @since 2.0.0
 */
var es6_Array_map = function (f) { return function (fa) { return fa.map(function (a) { return f(a); }); }; };
/**
 * Apply a function to an argument under a type constructor.
 *
 * @category Apply
 * @since 2.0.0
 */
var es6_Array_ap = function (fa) { return es6_Array_chain(function (f) { return (0,es6_function/* pipe */.zG)(fa, es6_Array_map(f)); }); };
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @category Monad
 * @since 2.0.0
 */
var es6_Array_chain = function (f) { return function (ma) {
    return (0,es6_function/* pipe */.zG)(ma, Array_chainWithIndex(function (_, a) { return f(a); }));
}; };
/**
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.5.0
 */
var Array_flatten = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (es6_Array_chain(identity)));
/**
 * @category FunctorWithIndex
 * @since 2.0.0
 */
var es6_Array_mapWithIndex = function (f) { return function (fa) {
    return fa.map(function (a, i) { return f(i, a); });
}; };
/**
 * @category FilterableWithIndex
 * @since 2.0.0
 */
var es6_Array_filterMapWithIndex = function (f) { return function (fa) {
    var out = [];
    for (var i = 0; i < fa.length; i++) {
        var optionB = f(i, fa[i]);
        if (internal/* isSome */.pC(optionB)) {
            out.push(optionB.value);
        }
    }
    return out;
}; };
/**
 * @category Filterable
 * @since 2.0.0
 */
var es6_Array_filterMap = function (f) {
    return es6_Array_filterMapWithIndex(function (_, a) { return f(a); });
};
/**
 * @category Compactable
 * @since 2.0.0
 */
var Array_compact = 
/*#__PURE__*/
es6_Array_filterMap(es6_function/* identity */.yR);
/**
 * @category Compactable
 * @since 2.0.0
 */
var Array_separate = function (fa) {
    var left = [];
    var right = [];
    for (var _i = 0, fa_1 = fa; _i < fa_1.length; _i++) {
        var e = fa_1[_i];
        if (e._tag === 'Left') {
            left.push(e.left);
        }
        else {
            right.push(e.right);
        }
    }
    return (0,Separated/* separated */.s4)(left, right);
};
/**
 * @category Filterable
 * @since 2.0.0
 */
var es6_Array_filter = function (predicate) { return function (as) { return as.filter(predicate); }; };
/**
 * @category Filterable
 * @since 2.0.0
 */
var es6_Array_partition = function (predicate) {
    return es6_Array_partitionWithIndex(function (_, a) { return predicate(a); });
};
/**
 * @category FilterableWithIndex
 * @since 2.0.0
 */
var es6_Array_partitionWithIndex = function (predicateWithIndex) { return function (as) {
    var left = [];
    var right = [];
    for (var i = 0; i < as.length; i++) {
        var b = as[i];
        if (predicateWithIndex(i, b)) {
            right.push(b);
        }
        else {
            left.push(b);
        }
    }
    return (0,Separated/* separated */.s4)(left, right);
}; };
/**
 * @category Filterable
 * @since 2.0.0
 */
var es6_Array_partitionMap = function (f) { return es6_Array_partitionMapWithIndex(function (_, a) { return f(a); }); };
/**
 * @category FilterableWithIndex
 * @since 2.0.0
 */
var es6_Array_partitionMapWithIndex = function (f) { return function (fa) {
    var left = [];
    var right = [];
    for (var i = 0; i < fa.length; i++) {
        var e = f(i, fa[i]);
        if (e._tag === 'Left') {
            left.push(e.left);
        }
        else {
            right.push(e.right);
        }
    }
    return (0,Separated/* separated */.s4)(left, right);
}; };
/**
 * Less strict version of [`alt`](#alt).
 *
 * @category Alt
 * @since 2.9.0
 */
var Array_altW = function (that) { return function (fa) { return fa.concat(that()); }; };
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * @category Alt
 * @since 2.0.0
 */
var es6_Array_alt = Array_altW;
/**
 * @category FilterableWithIndex
 * @since 2.0.0
 */
var es6_Array_filterWithIndex = function (predicateWithIndex) { return function (as) {
    return as.filter(function (b, i) { return predicateWithIndex(i, b); });
}; };
/**
 * @category Extend
 * @since 2.0.0
 */
var es6_Array_extend = function (f) { return function (wa) {
    return wa.map(function (_, i) { return f(wa.slice(i)); });
}; };
/**
 * Derivable from `Extend`.
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_duplicate = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (es6_Array_extend(identity)));
/**
 * @category Foldable
 * @since 2.0.0
 */
var es6_Array_foldMap = es6_ReadonlyArray_foldMap;
/**
 * @category FoldableWithIndex
 * @since 2.0.0
 */
var es6_Array_foldMapWithIndex = es6_ReadonlyArray_foldMapWithIndex;
/**
 * @category Foldable
 * @since 2.0.0
 */
var es6_Array_reduce = es6_ReadonlyArray_reduce;
/**
 * @category FoldableWithIndex
 * @since 2.0.0
 */
var es6_Array_reduceWithIndex = es6_ReadonlyArray_reduceWithIndex;
/**
 * @category Foldable
 * @since 2.0.0
 */
var es6_Array_reduceRight = es6_ReadonlyArray_reduceRight;
/**
 * @category FoldableWithIndex
 * @since 2.0.0
 */
var es6_Array_reduceRightWithIndex = es6_ReadonlyArray_reduceRightWithIndex;
/**
 * @category Traversable
 * @since 2.6.3
 */
var es6_Array_traverse = function (F) {
    var traverseWithIndexF = es6_Array_traverseWithIndex(F);
    return function (f) { return traverseWithIndexF(function (_, a) { return f(a); }); };
};
/**
 * @category Traversable
 * @since 2.6.3
 */
var Array_sequence = function (F) { return function (ta) {
    return Array_reduce(ta, F.of(Array_zero()), function (fas, fa) {
        return F.ap(F.map(fas, function (as) { return function (a) { return (0,es6_function/* pipe */.zG)(as, Array_append(a)); }; }), fa);
    });
}; };
/**
 * @category TraversableWithIndex
 * @since 2.6.3
 */
var es6_Array_traverseWithIndex = function (F) { return function (f) {
    return es6_Array_reduceWithIndex(F.of(Array_zero()), function (i, fbs, a) {
        return F.ap(F.map(fbs, function (bs) { return function (b) { return (0,es6_function/* pipe */.zG)(bs, Array_append(b)); }; }), f(i, a));
    });
}; };
/**
 * @category Witherable
 * @since 2.6.5
 */
var Array_wither = function (F) {
    var _witherF = es6_Array_wither(F);
    return function (f) { return function (fa) { return _witherF(fa, f); }; };
};
/**
 * @category Witherable
 * @since 2.6.5
 */
var Array_wilt = function (F) {
    var _wiltF = es6_Array_wilt(F);
    return function (f) { return function (fa) { return _wiltF(fa, f); }; };
};
/**
 * Creates an `Array` from the results of `f(b)`, where `b` is an initial value.
 * `unfold` stops when `f` returns `Option.none`.
 * @example
 * import { unfold } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(
 *   unfold(5, (n) => (n > 0 ? some([n, n - 1]) : none)),
 *   [5, 4, 3, 2, 1]
 * )
 *
 * @category Unfoldable
 * @since 2.6.6
 */
var Array_unfold = function (b, f) {
    var out = [];
    var bb = b;
    while (true) {
        var mt = f(bb);
        if (internal/* isSome */.pC(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        }
        else {
            break;
        }
    }
    return out;
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.0.0
 */
var Array_URI = 'Array';
/**
 * @category instances
 * @since 2.0.0
 */
var Array_getShow = ReadonlyArray_getShow;
/**
 * @category instances
 * @since 2.10.0
 */
var Array_getSemigroup = function () { return ({
    concat: function (first, second) { return first.concat(second); }
}); };
/**
 * Returns a `Monoid` for `Array<A>`
 *
 * @example
 * import { getMonoid } from 'fp-ts/Array'
 *
 * const M = getMonoid<number>()
 * assert.deepStrictEqual(M.concat([1, 2], [3, 4]), [1, 2, 3, 4])
 *
 * @category instances
 * @since 2.0.0
 */
var Array_getMonoid = function () { return ({
    concat: Array_getSemigroup().concat,
    empty: []
}); };
/**
 * Derives an `Eq` over the `Array` of a given element type from the `Eq` of that type. The derived `Eq` defines two
 * arrays as equal if all elements of both arrays are compared equal pairwise with the given `E`. In case of arrays of
 * different lengths, the result is non equality.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { getEq } from 'fp-ts/Array'
 *
 * const E = getEq(S.Eq)
 * assert.strictEqual(E.equals(['a', 'b'], ['a', 'b']), true)
 * assert.strictEqual(E.equals(['a'], []), false)
 *
 * @category instances
 * @since 2.0.0
 */
var Array_getEq = ReadonlyArray_getEq;
/**
 * Derives an `Ord` over the `Array` of a given element type from the `Ord` of that type. The ordering between two such
 * arrays is equal to: the first non equal comparison of each arrays elements taken pairwise in increasing order, in
 * case of equality over all the pairwise elements; the longest array is considered the greatest, if both arrays have
 * the same length, the result is equality.
 *
 * @example
 * import { getOrd } from 'fp-ts/Array'
 * import * as S from 'fp-ts/string'
 *
 * const O = getOrd(S.Ord)
 * assert.strictEqual(O.compare(['b'], ['a']), 1)
 * assert.strictEqual(O.compare(['a'], ['a']), 0)
 * assert.strictEqual(O.compare(['a'], ['b']), -1)
 *
 * @category instances
 * @since 2.0.0
 */
var Array_getOrd = getOrd;
/**
 * @category instances
 * @since 2.11.0
 */
var Array_getUnionSemigroup = function (E) {
    var unionE = Array_union(E);
    return {
        concat: function (first, second) { return unionE(second)(first); }
    };
};
/**
 * @category instances
 * @since 2.11.0
 */
var Array_getUnionMonoid = function (E) { return ({
    concat: Array_getUnionSemigroup(E).concat,
    empty: []
}); };
/**
 * @category instances
 * @since 2.11.0
 */
var Array_getIntersectionSemigroup = function (E) {
    var intersectionE = Array_intersection(E);
    return {
        concat: function (first, second) { return intersectionE(second)(first); }
    };
};
/**
 * @category instances
 * @since 2.11.0
 */
var Array_getDifferenceMagma = function (E) {
    var differenceE = Array_difference(E);
    return {
        concat: function (first, second) { return differenceE(second)(first); }
    };
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Functor = {
    URI: Array_URI,
    map: Array_map
};
/**
 * Derivable from `Functor`.
 *
 * @category combinators
 * @since 2.10.0
 */
var Array_flap = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (flap_(Array_Functor)));
/**
 * @category instances
 * @since 2.10.0
 */
var Array_Pointed = {
    URI: Array_URI,
    of: Array_of
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_FunctorWithIndex = {
    URI: Array_URI,
    map: Array_map,
    mapWithIndex: Array_mapWithIndex
};
/**
 * @category instances
 * @since 2.10.0
 */
var Array_Apply = {
    URI: Array_URI,
    map: Array_map,
    ap: Array_ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.5.0
 */
var Array_apFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apFirst_(Array_Apply)));
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.5.0
 */
var Array_apSecond = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apSecond_(Array_Apply)));
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Applicative = {
    URI: Array_URI,
    map: Array_map,
    ap: Array_ap,
    of: Array_of
};
/**
 * @category instances
 * @since 2.10.0
 */
var Array_Chain = {
    URI: Array_URI,
    map: Array_map,
    ap: Array_ap,
    chain: Array_chain
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.0.0
 */
var Array_chainFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (chainFirst_(Array_Chain)));
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Monad = {
    URI: Array_URI,
    map: Array_map,
    ap: Array_ap,
    of: Array_of,
    chain: Array_chain
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Unfoldable = {
    URI: Array_URI,
    unfold: Array_unfold
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Alt = {
    URI: Array_URI,
    map: Array_map,
    alt: Array_alt
};
/**
 * @category instances
 * @since 2.11.0
 */
var Array_Zero = {
    URI: Array_URI,
    zero: Array_zero
};
/**
 * @category constructors
 * @since 2.11.0
 */
var Array_guard = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (guard_(Array_Zero, Array_Pointed)));
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Alternative = {
    URI: Array_URI,
    map: Array_map,
    ap: Array_ap,
    of: Array_of,
    alt: Array_alt,
    zero: Array_zero
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Extend = {
    URI: Array_URI,
    map: Array_map,
    extend: Array_extend
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Compactable = {
    URI: Array_URI,
    compact: Array_compact,
    separate: Array_separate
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Filterable = {
    URI: Array_URI,
    map: Array_map,
    compact: Array_compact,
    separate: Array_separate,
    filter: Array_filter,
    filterMap: Array_filterMap,
    partition: Array_partition,
    partitionMap: Array_partitionMap
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_FilterableWithIndex = {
    URI: Array_URI,
    map: Array_map,
    mapWithIndex: Array_mapWithIndex,
    compact: Array_compact,
    separate: Array_separate,
    filter: Array_filter,
    filterMap: Array_filterMap,
    partition: Array_partition,
    partitionMap: Array_partitionMap,
    partitionMapWithIndex: Array_partitionMapWithIndex,
    partitionWithIndex: Array_partitionWithIndex,
    filterMapWithIndex: Array_filterMapWithIndex,
    filterWithIndex: Array_filterWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Foldable = {
    URI: Array_URI,
    reduce: Array_reduce,
    foldMap: Array_foldMap,
    reduceRight: Array_reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_FoldableWithIndex = {
    URI: Array_URI,
    reduce: Array_reduce,
    foldMap: Array_foldMap,
    reduceRight: Array_reduceRight,
    reduceWithIndex: Array_reduceWithIndex,
    foldMapWithIndex: Array_foldMapWithIndex,
    reduceRightWithIndex: Array_reduceRightWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Traversable = {
    URI: Array_URI,
    map: Array_map,
    reduce: Array_reduce,
    foldMap: Array_foldMap,
    reduceRight: Array_reduceRight,
    traverse: Array_traverse,
    sequence: Array_sequence
};
/**
 * @category instances
 * @since 2.7.0
 */
var Array_TraversableWithIndex = {
    URI: Array_URI,
    map: Array_map,
    mapWithIndex: Array_mapWithIndex,
    reduce: Array_reduce,
    foldMap: Array_foldMap,
    reduceRight: Array_reduceRight,
    reduceWithIndex: Array_reduceWithIndex,
    foldMapWithIndex: Array_foldMapWithIndex,
    reduceRightWithIndex: Array_reduceRightWithIndex,
    traverse: Array_traverse,
    sequence: Array_sequence,
    traverseWithIndex: Array_traverseWithIndex
};
var es6_Array_wither = (0,Witherable/* witherDefault */.BL)(Array_Traversable, Array_Compactable);
var es6_Array_wilt = (0,Witherable/* wiltDefault */.Fj)(Array_Traversable, Array_Compactable);
/**
 * @category instances
 * @since 2.7.0
 */
var Array_Witherable = {
    URI: Array_URI,
    map: Array_map,
    compact: Array_compact,
    separate: Array_separate,
    filter: Array_filter,
    filterMap: Array_filterMap,
    partition: Array_partition,
    partitionMap: Array_partitionMap,
    reduce: Array_reduce,
    foldMap: Array_foldMap,
    reduceRight: Array_reduceRight,
    traverse: Array_traverse,
    sequence: Array_sequence,
    wither: es6_Array_wither,
    wilt: es6_Array_wilt
};
/**
 * @category ChainRec
 * @since 2.11.0
 */
var es6_Array_chainRecDepthFirst = chainRecDepthFirst;
/**
 * @category instances
 * @since 2.11.0
 */
var Array_ChainRecDepthFirst = {
    URI: Array_URI,
    map: Array_map,
    ap: Array_ap,
    chain: Array_chain,
    chainRec: Array_chainRecDepthFirst
};
/**
 * @category ChainRec
 * @since 2.11.0
 */
var es6_Array_chainRecBreadthFirst = chainRecBreadthFirst;
/**
 * @category instances
 * @since 2.11.0
 */
var Array_ChainRecBreadthFirst = {
    URI: Array_URI,
    map: Array_map,
    ap: Array_ap,
    chain: Array_chain,
    chainRec: Array_chainRecBreadthFirst
};
/**
 * Filter values inside a context.
 *
 * @since 2.11.0
 */
var Array_filterE = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (filterE_(Array_Witherable)));
/**
 * @category instances
 * @since 2.11.0
 */
var Array_FromEither = {
    URI: Array_URI,
    fromEither: Array_fromEither
};
/**
 * @category combinators
 * @since 2.11.0
 */
var Array_fromEitherK = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (fromEitherK_(Array_FromEither)));
// -------------------------------------------------------------------------------------
// unsafe
// -------------------------------------------------------------------------------------
/**
 * @category unsafe
 * @since 2.0.0
 */
var Array_unsafeInsertAt = NonEmptyArray_unsafeInsertAt;
/**
 * @category unsafe
 * @since 2.0.0
 */
var Array_unsafeUpdateAt = function (i, a, as) {
    return Array_isNonEmpty(as) ? NEA.unsafeUpdateAt(i, a, as) : [];
};
/**
 * @category unsafe
 * @since 2.0.0
 */
var Array_unsafeDeleteAt = function (i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.9.0
 */
var Array_every = every;
/**
 * @since 2.9.0
 */
var Array_some = function (predicate) { return function (as) { return as.some(predicate); }; };
/**
 * Alias of [`some`](#some)
 *
 * @since 2.11.0
 */
var Array_exists = (/* unused pure expression or super */ null && (Array_some));
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @since 2.9.0
 */
var Array_Do = 
/*#__PURE__*/
Array_of(internal/* emptyRecord */.F4);
/**
 * @since 2.8.0
 */
var Array_bindTo = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bindTo_(Array_Functor)));
/**
 * @since 2.8.0
 */
var Array_bind = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bind_(Array_Chain)));
// -------------------------------------------------------------------------------------
// pipeable sequence S
// -------------------------------------------------------------------------------------
/**
 * @since 2.8.0
 */
var Array_apS = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apS_(Array_Apply)));
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
// tslint:disable: deprecation
/**
 * Use `NonEmptyArray` module instead.
 *
 * @category constructors
 * @since 2.0.0
 * @deprecated
 */
var Array_range = NonEmptyArray_range;
/**
 * Use a new `[]` instead.
 *
 * @since 2.0.0
 * @deprecated
 */
var Array_empty = (/* unused pure expression or super */ null && ([]));
/**
 * Use `prepend` instead.
 *
 * @category constructors
 * @since 2.0.0
 * @deprecated
 */
var Array_cons = NonEmptyArray_cons;
/**
 * Use `append` instead.
 *
 * @category constructors
 * @since 2.0.0
 * @deprecated
 */
var Array_snoc = NonEmptyArray_snoc;
/**
 * Use `prependAll` instead
 *
 * @category combinators
 * @since 2.9.0
 * @deprecated
 */
var Array_prependToAll = (/* unused pure expression or super */ null && (Array_prependAll));
/**
 * Use small, specific instances instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var array = {
    URI: Array_URI,
    compact: Array_compact,
    separate: Array_separate,
    map: Array_map,
    ap: Array_ap,
    of: Array_of,
    chain: Array_chain,
    filter: Array_filter,
    filterMap: Array_filterMap,
    partition: Array_partition,
    partitionMap: Array_partitionMap,
    mapWithIndex: Array_mapWithIndex,
    partitionMapWithIndex: Array_partitionMapWithIndex,
    partitionWithIndex: Array_partitionWithIndex,
    filterMapWithIndex: Array_filterMapWithIndex,
    filterWithIndex: Array_filterWithIndex,
    alt: Array_alt,
    zero: Array_zero,
    unfold: Array_unfold,
    reduce: Array_reduce,
    foldMap: Array_foldMap,
    reduceRight: Array_reduceRight,
    traverse: Array_traverse,
    sequence: Array_sequence,
    reduceWithIndex: Array_reduceWithIndex,
    foldMapWithIndex: Array_foldMapWithIndex,
    reduceRightWithIndex: Array_reduceRightWithIndex,
    traverseWithIndex: Array_traverseWithIndex,
    extend: Array_extend,
    wither: es6_Array_wither,
    wilt: es6_Array_wilt
};


/***/ }),

/***/ 36567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ toUndefined; }
/* harmony export */ });
/* unused harmony exports none, some, fromPredicate, getLeft, getRight, URI, getShow, getEq, getOrd, getMonoid, map, Functor, of, Pointed, ap, Apply, Applicative, chain, Chain, Monad, reduce, foldMap, reduceRight, Foldable, altW, alt, Alt, zero, Zero, guard, Alternative, extend, Extend, compact, separate, Compactable, filter, filterMap, partition, partitionMap, Filterable, traverse, sequence, Traversable, wither, wilt, Witherable, throwError, MonadThrow, fromEither, FromEither, isSome, isNone, matchW, foldW, match, fold, getOrElseW, getOrElse, flap, apFirst, apSecond, flatten, chainFirst, duplicate, fromEitherK, chainEitherK, fromNullable, tryCatch, tryCatchK, fromNullableK, chainNullableK, toNullable, elem, exists, Do, bindTo, bind, apS, ApT, traverseReadonlyNonEmptyArrayWithIndex, traverseReadonlyArrayWithIndex, traverseArrayWithIndex, traverseArray, sequenceArray, getRefinement, mapNullable, option, getApplySemigroup, getApplyMonoid, getFirstMonoid, getLastMonoid */
/* harmony import */ var _function__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3735);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59384);
/* harmony import */ var _Predicate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16017);
/* harmony import */ var _Separated__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64870);
/* harmony import */ var _Witherable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25605);












// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * `None` doesn't have a constructor, instead you can use it directly as a value. Represents a missing value.
 *
 * @category constructors
 * @since 2.0.0
 */
var none = _internal__WEBPACK_IMPORTED_MODULE_0__/* .none */ .YP;
/**
 * Constructs a `Some`. Represents an optional value that exists.
 *
 * @category constructors
 * @since 2.0.0
 */
var some = _internal__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G;
function fromPredicate(predicate) {
    return function (a) { return (predicate(a) ? some(a) : none); };
}
/**
 * Returns the `Left` value of an `Either` if possible.
 *
 * @example
 * import { getLeft, none, some } from 'fp-ts/Option'
 * import { right, left } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(getLeft(right(1)), none)
 * assert.deepStrictEqual(getLeft(left('a')), some('a'))
 *
 * @category constructors
 * @since 2.0.0
 */
var getLeft = function (ma) { return (ma._tag === 'Right' ? none : some(ma.left)); };
/**
 * Returns the `Right` value of an `Either` if possible.
 *
 * @example
 * import { getRight, none, some } from 'fp-ts/Option'
 * import { right, left } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(getRight(right(1)), some(1))
 * assert.deepStrictEqual(getRight(left('a')), none)
 *
 * @category constructors
 * @since 2.0.0
 */
var getRight = function (ma) { return (ma._tag === 'Left' ? none : some(ma.right)); };
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var _map = function (fa, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, map(f)); };
var _ap = function (fab, fa) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fab, ap(fa)); };
var _chain = function (ma, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(ma, chain(f)); };
var _reduce = function (fa, b, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, reduce(b, f)); };
var _foldMap = function (M) {
    var foldMapM = foldMap(M);
    return function (fa, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, foldMapM(f)); };
};
var _reduceRight = function (fa, b, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, reduceRight(b, f)); };
var _traverse = function (F) {
    var traverseF = traverse(F);
    return function (ta, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(ta, traverseF(f)); };
};
/* istanbul ignore next */
var _alt = function (fa, that) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, alt(that)); };
var _filter = function (fa, predicate) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, filter(predicate)); };
/* istanbul ignore next */
var _filterMap = function (fa, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, filterMap(f)); };
/* istanbul ignore next */
var _extend = function (wa, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(wa, extend(f)); };
/* istanbul ignore next */
var _partition = function (fa, predicate) {
    return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, partition(predicate));
};
/* istanbul ignore next */
var _partitionMap = function (fa, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fa, partitionMap(f)); };
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.0.0
 */
var URI = 'Option';
/**
 * @category instances
 * @since 2.0.0
 */
var getShow = function (S) { return ({
    show: function (ma) { return (isNone(ma) ? 'none' : "some(" + S.show(ma.value) + ")"); }
}); };
/**
 * @example
 * import { none, some, getEq } from 'fp-ts/Option'
 * import * as N from 'fp-ts/number'
 *
 * const E = getEq(N.Eq)
 * assert.strictEqual(E.equals(none, none), true)
 * assert.strictEqual(E.equals(none, some(1)), false)
 * assert.strictEqual(E.equals(some(1), none), false)
 * assert.strictEqual(E.equals(some(1), some(2)), false)
 * assert.strictEqual(E.equals(some(1), some(1)), true)
 *
 * @category instances
 * @since 2.0.0
 */
var getEq = function (E) { return ({
    equals: function (x, y) { return x === y || (isNone(x) ? isNone(y) : isNone(y) ? false : E.equals(x.value, y.value)); }
}); };
/**
 * The `Ord` instance allows `Option` values to be compared with
 * `compare`, whenever there is an `Ord` instance for
 * the type the `Option` contains.
 *
 * `None` is considered to be less than any `Some` value.
 *
 *
 * @example
 * import { none, some, getOrd } from 'fp-ts/Option'
 * import * as N from 'fp-ts/number'
 *
 * const O = getOrd(N.Ord)
 * assert.strictEqual(O.compare(none, none), 0)
 * assert.strictEqual(O.compare(none, some(1)), -1)
 * assert.strictEqual(O.compare(some(1), none), 1)
 * assert.strictEqual(O.compare(some(1), some(2)), -1)
 * assert.strictEqual(O.compare(some(1), some(1)), 0)
 *
 * @category instances
 * @since 2.0.0
 */
var getOrd = function (O) { return ({
    equals: getEq(O).equals,
    compare: function (x, y) { return (x === y ? 0 : isSome(x) ? (isSome(y) ? O.compare(x.value, y.value) : 1) : -1); }
}); };
/**
 * Monoid returning the left-most non-`None` value. If both operands are `Some`s then the inner values are
 * concatenated using the provided `Semigroup`
 *
 * | x       | y       | concat(x, y)       |
 * | ------- | ------- | ------------------ |
 * | none    | none    | none               |
 * | some(a) | none    | some(a)            |
 * | none    | some(b) | some(b)            |
 * | some(a) | some(b) | some(concat(a, b)) |
 *
 * @example
 * import { getMonoid, some, none } from 'fp-ts/Option'
 * import { SemigroupSum } from 'fp-ts/number'
 *
 * const M = getMonoid(SemigroupSum)
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(1)), some(1))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(3))
 *
 * @category instances
 * @since 2.0.0
 */
var getMonoid = function (S) { return ({
    concat: function (x, y) { return (isNone(x) ? y : isNone(y) ? x : some(S.concat(x.value, y.value))); },
    empty: none
}); };
/**
 * @category instance operations
 * @since 2.0.0
 */
var map = function (f) { return function (fa) {
    return isNone(fa) ? none : some(f(fa.value));
}; };
/**
 * @category instances
 * @since 2.7.0
 */
var Functor = {
    URI: URI,
    map: _map
};
/**
 * @category instance operations
 * @since 2.7.0
 */
var of = some;
/**
 * @category instances
 * @since 2.10.0
 */
var Pointed = {
    URI: URI,
    of: of
};
/**
 * @category instance operations
 * @since 2.0.0
 */
var ap = function (fa) { return function (fab) {
    return isNone(fab) ? none : isNone(fa) ? none : some(fab.value(fa.value));
}; };
/**
 * @category instances
 * @since 2.10.0
 */
var Apply = {
    URI: URI,
    map: _map,
    ap: _ap
};
/**
 * @category instances
 * @since 2.7.0
 */
var Applicative = {
    URI: URI,
    map: _map,
    ap: _ap,
    of: of
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @category instance operations
 * @since 2.0.0
 */
var chain = function (f) { return function (ma) {
    return isNone(ma) ? none : f(ma.value);
}; };
/**
 * @category instances
 * @since 2.10.0
 */
var Chain = {
    URI: URI,
    map: _map,
    ap: _ap,
    chain: _chain
};
/**
 * @category instances
 * @since 2.7.0
 */
var Monad = {
    URI: URI,
    map: _map,
    ap: _ap,
    of: of,
    chain: _chain
};
/**
 * @category instance operations
 * @since 2.0.0
 */
var reduce = function (b, f) { return function (fa) {
    return isNone(fa) ? b : f(b, fa.value);
}; };
/**
 * @category instance operations
 * @since 2.0.0
 */
var foldMap = function (M) { return function (f) { return function (fa) {
    return isNone(fa) ? M.empty : f(fa.value);
}; }; };
/**
 * @category instance operations
 * @since 2.0.0
 */
var reduceRight = function (b, f) { return function (fa) {
    return isNone(fa) ? b : f(fa.value, b);
}; };
/**
 * @category instances
 * @since 2.7.0
 */
var Foldable = {
    URI: URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
};
/**
 * Less strict version of [`alt`](#alt).
 *
 * @category instance operations
 * @since 2.9.0
 */
var altW = function (that) { return function (fa) {
    return isNone(fa) ? that() : fa;
}; };
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * In case of `Option` returns the left-most non-`None` value.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     O.some('a'),
 *     O.alt(() => O.some('b'))
 *   ),
 *   O.some('a')
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     O.none,
 *     O.alt(() => O.some('b'))
 *   ),
 *   O.some('b')
 * )
 *
 * @category instance operations
 * @since 2.0.0
 */
var alt = altW;
/**
 * @category instances
 * @since 2.7.0
 */
var Alt = {
    URI: URI,
    map: _map,
    alt: _alt
};
/**
 * @category instance operations
 * @since 2.7.0
 */
var zero = function () { return none; };
/**
 * @category instances
 * @since 2.11.0
 */
var Zero = {
    URI: URI,
    zero: zero
};
/**
 * @category constructors
 * @since 2.11.0
 */
var guard = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (guard_(Zero, Pointed)));
/**
 * @category instances
 * @since 2.7.0
 */
var Alternative = {
    URI: URI,
    map: _map,
    ap: _ap,
    of: of,
    alt: _alt,
    zero: zero
};
/**
 * @category instance operations
 * @since 2.0.0
 */
var extend = function (f) { return function (wa) {
    return isNone(wa) ? none : some(f(wa));
}; };
/**
 * @category instances
 * @since 2.7.0
 */
var Extend = {
    URI: URI,
    map: _map,
    extend: _extend
};
/**
 * @category instance operations
 * @since 2.0.0
 */
var compact = 
/*#__PURE__*/
chain(_function__WEBPACK_IMPORTED_MODULE_1__/* .identity */ .yR);
var defaultSeparated = 
/*#__PURE__*/
(0,_Separated__WEBPACK_IMPORTED_MODULE_2__/* .separated */ .s4)(none, none);
/**
 * @category instance operations
 * @since 2.0.0
 */
var separate = function (ma) {
    return isNone(ma) ? defaultSeparated : (0,_Separated__WEBPACK_IMPORTED_MODULE_2__/* .separated */ .s4)(getLeft(ma.value), getRight(ma.value));
};
/**
 * @category instances
 * @since 2.7.0
 */
var Compactable = {
    URI: URI,
    compact: compact,
    separate: separate
};
/**
 * @category instance operations
 * @since 2.0.0
 */
var filter = function (predicate) { return function (fa) { return (isNone(fa) ? none : predicate(fa.value) ? fa : none); }; };
/**
 * @category instance operations
 * @since 2.0.0
 */
var filterMap = function (f) { return function (fa) {
    return isNone(fa) ? none : f(fa.value);
}; };
/**
 * @category instance operations
 * @since 2.0.0
 */
var partition = function (predicate) { return function (fa) { return (0,_Separated__WEBPACK_IMPORTED_MODULE_2__/* .separated */ .s4)(_filter(fa, (0,_Predicate__WEBPACK_IMPORTED_MODULE_3__/* .not */ .ff)(predicate)), _filter(fa, predicate)); }; };
/**
 * @category instance operations
 * @since 2.0.0
 */
var partitionMap = function (f) { return (0,_function__WEBPACK_IMPORTED_MODULE_1__/* .flow */ .ls)(map(f), separate); };
/**
 * @category instances
 * @since 2.7.0
 */
var Filterable = {
    URI: URI,
    map: _map,
    compact: compact,
    separate: separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap
};
/**
 * @category instance operations
 * @since 2.6.3
 */
var traverse = function (F) { return function (f) { return function (ta) { return (isNone(ta) ? F.of(none) : F.map(f(ta.value), some)); }; }; };
/**
 * @category instance operations
 * @since 2.6.3
 */
var sequence = function (F) { return function (ta) { return (isNone(ta) ? F.of(none) : F.map(ta.value, some)); }; };
/**
 * @category instances
 * @since 2.7.0
 */
var Traversable = {
    URI: URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: sequence
};
var _wither = 
/*#__PURE__*/
(0,_Witherable__WEBPACK_IMPORTED_MODULE_4__/* .witherDefault */ .BL)(Traversable, Compactable);
var _wilt = 
/*#__PURE__*/
(0,_Witherable__WEBPACK_IMPORTED_MODULE_4__/* .wiltDefault */ .Fj)(Traversable, Compactable);
/**
 * @category instance operations
 * @since 2.6.5
 */
var wither = function (F) {
    var _witherF = _wither(F);
    return function (f) { return function (fa) { return _witherF(fa, f); }; };
};
/**
 * @category instance operations
 * @since 2.6.5
 */
var wilt = function (F) {
    var _wiltF = _wilt(F);
    return function (f) { return function (fa) { return _wiltF(fa, f); }; };
};
/**
 * @category instances
 * @since 2.7.0
 */
var Witherable = {
    URI: URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: sequence,
    compact: compact,
    separate: separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    wither: _wither,
    wilt: _wilt
};
/**
 * @category instance operations
 * @since 2.7.0
 */
var throwError = function () { return none; };
/**
 * @category instances
 * @since 2.7.0
 */
var MonadThrow = {
    URI: URI,
    map: _map,
    ap: _ap,
    of: of,
    chain: _chain,
    throwError: throwError
};
/**
 * Transforms an `Either` to an `Option` discarding the error.
 *
 * Alias of [getRight](#getright)
 *
 * @category natural transformations
 * @since 2.0.0
 */
var fromEither = getRight;
/**
 * @category instances
 * @since 2.11.0
 */
var FromEither = {
    URI: URI,
    fromEither: fromEither
};
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Returns `true` if the option is an instance of `Some`, `false` otherwise.
 *
 * @example
 * import { some, none, isSome } from 'fp-ts/Option'
 *
 * assert.strictEqual(isSome(some(1)), true)
 * assert.strictEqual(isSome(none), false)
 *
 * @category refinements
 * @since 2.0.0
 */
var isSome = _internal__WEBPACK_IMPORTED_MODULE_0__/* .isSome */ .pC;
/**
 * Returns `true` if the option is `None`, `false` otherwise.
 *
 * @example
 * import { some, none, isNone } from 'fp-ts/Option'
 *
 * assert.strictEqual(isNone(some(1)), false)
 * assert.strictEqual(isNone(none), true)
 *
 * @category refinements
 * @since 2.0.0
 */
var isNone = function (fa) { return fa._tag === 'None'; };
// -------------------------------------------------------------------------------------
// destructors
// -------------------------------------------------------------------------------------
/**
 * Less strict version of [`match`](#match).
 *
 * @category destructors
 * @since 2.10.0
 */
var matchW = function (onNone, onSome) { return function (ma) {
    return isNone(ma) ? onNone() : onSome(ma.value);
}; };
/**
 * Alias of [`matchW`](#matchw).
 *
 * @category destructors
 * @since 2.10.0
 */
var foldW = (/* unused pure expression or super */ null && (matchW));
/**
 * Takes a (lazy) default value, a function, and an `Option` value, if the `Option` value is `None` the default value is
 * returned, otherwise the function is applied to the value inside the `Some` and the result is returned.
 *
 * @example
 * import { some, none, match } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     match(() => 'a none', a => `a some containing ${a}`)
 *   ),
 *   'a some containing 1'
 * )
 *
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     match(() => 'a none', a => `a some containing ${a}`)
 *   ),
 *   'a none'
 * )
 *
 * @category destructors
 * @since 2.10.0
 */
var match = matchW;
/**
 * Alias of [`match`](#match).
 *
 * @category destructors
 * @since 2.0.0
 */
var fold = (/* unused pure expression or super */ null && (match));
/**
 * Less strict version of [`getOrElse`](#getorelse).
 *
 * @category destructors
 * @since 2.6.0
 */
var getOrElseW = function (onNone) { return function (ma) { return (isNone(ma) ? onNone() : ma.value); }; };
/**
 * Extracts the value out of the structure, if it exists. Otherwise returns the given default value
 *
 * @example
 * import { some, none, getOrElse } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     getOrElse(() => 0)
 *   ),
 *   1
 * )
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     getOrElse(() => 0)
 *   ),
 *   0
 * )
 *
 * @category destructors
 * @since 2.0.0
 */
var getOrElse = (/* unused pure expression or super */ null && (getOrElseW));
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * Derivable from `Functor`.
 *
 * @category combinators
 * @since 2.10.0
 */
var flap = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (flap_(Functor)));
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.0.0
 */
var apFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apFirst_(Apply)));
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * Derivable from `Apply`.
 *
 * @category combinators
 * @since 2.0.0
 */
var apSecond = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apSecond_(Apply)));
/**
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.0.0
 */
var flatten = (/* unused pure expression or super */ null && (compact));
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * Derivable from `Chain`.
 *
 * @category combinators
 * @since 2.0.0
 */
var chainFirst = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (chainFirst_(Chain)));
/**
 * Derivable from `Extend`.
 *
 * @category combinators
 * @since 2.0.0
 */
var duplicate = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (extend(identity)));
/**
 * @category combinators
 * @since 2.11.0
 */
var fromEitherK = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (fromEitherK_(FromEither)));
/**
 * @category combinators
 * @since 2.11.0
 */
var chainEitherK = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (chainEitherK_(FromEither, Chain)));
// -------------------------------------------------------------------------------------
// interop
// -------------------------------------------------------------------------------------
/**
 * Constructs a new `Option` from a nullable type. If the value is `null` or `undefined`, returns `None`, otherwise
 * returns the value wrapped in a `Some`.
 *
 * @example
 * import { none, some, fromNullable } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(fromNullable(undefined), none)
 * assert.deepStrictEqual(fromNullable(null), none)
 * assert.deepStrictEqual(fromNullable(1), some(1))
 *
 * @category interop
 * @since 2.0.0
 */
var fromNullable = function (a) { return (a == null ? none : some(a)); };
/**
 * Transforms an exception into an `Option`. If `f` throws, returns `None`, otherwise returns the output wrapped in a
 * `Some`.
 *
 * See also [`tryCatchK`](#trycatchk).
 *
 * @example
 * import { none, some, tryCatch } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(
 *   tryCatch(() => {
 *     throw new Error()
 *   }),
 *   none
 * )
 * assert.deepStrictEqual(tryCatch(() => 1), some(1))
 *
 * @category interop
 * @since 2.0.0
 */
var tryCatch = function (f) {
    try {
        return some(f());
    }
    catch (e) {
        return none;
    }
};
/**
 * Converts a function that may throw to one returning a `Option`.
 *
 * @category interop
 * @since 2.10.0
 */
var tryCatchK = function (f) { return function () {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
    }
    return tryCatch(function () { return f.apply(void 0, a); });
}; };
/**
 * Returns a *smart constructor* from a function that returns a nullable value.
 *
 * @example
 * import { fromNullableK, none, some } from 'fp-ts/Option'
 *
 * const f = (s: string): number | undefined => {
 *   const n = parseFloat(s)
 *   return isNaN(n) ? undefined : n
 * }
 *
 * const g = fromNullableK(f)
 *
 * assert.deepStrictEqual(g('1'), some(1))
 * assert.deepStrictEqual(g('a'), none)
 *
 * @category interop
 * @since 2.9.0
 */
var fromNullableK = function (f) { return flow(f, fromNullable); };
/**
 * This is `chain` + `fromNullable`, useful when working with optional values.
 *
 * @example
 * import { some, none, fromNullable, chainNullableK } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Employee {
 *   readonly company?: {
 *     readonly address?: {
 *       readonly street?: {
 *         readonly name?: string
 *       }
 *     }
 *   }
 * }
 *
 * const employee1: Employee = { company: { address: { street: { name: 'high street' } } } }
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     fromNullable(employee1.company),
 *     chainNullableK(company => company.address),
 *     chainNullableK(address => address.street),
 *     chainNullableK(street => street.name)
 *   ),
 *   some('high street')
 * )
 *
 * const employee2: Employee = { company: { address: { street: {} } } }
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     fromNullable(employee2.company),
 *     chainNullableK(company => company.address),
 *     chainNullableK(address => address.street),
 *     chainNullableK(street => street.name)
 *   ),
 *   none
 * )
 *
 * @category interop
 * @since 2.9.0
 */
var chainNullableK = function (f) { return function (ma) {
    return isNone(ma) ? none : fromNullable(f(ma.value));
}; };
/**
 * Extracts the value out of the structure, if it exists. Otherwise returns `null`.
 *
 * @example
 * import { some, none, toNullable } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     toNullable
 *   ),
 *   1
 * )
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     toNullable
 *   ),
 *   null
 * )
 *
 * @category interop
 * @since 2.0.0
 */
var toNullable = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (match(constNull, identity)));
/**
 * Extracts the value out of the structure, if it exists. Otherwise returns `undefined`.
 *
 * @example
 * import { some, none, toUndefined } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     toUndefined
 *   ),
 *   1
 * )
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     toUndefined
 *   ),
 *   undefined
 * )
 *
 * @category interop
 * @since 2.0.0
 */
var toUndefined = 
/*#__PURE__*/
match(_function__WEBPACK_IMPORTED_MODULE_1__/* .constUndefined */ .r5, _function__WEBPACK_IMPORTED_MODULE_1__/* .identity */ .yR);
function elem(E) {
    return function (a, ma) {
        if (ma === undefined) {
            var elemE_1 = elem(E);
            return function (ma) { return elemE_1(a, ma); };
        }
        return isNone(ma) ? false : E.equals(a, ma.value);
    };
}
/**
 * Returns `true` if the predicate is satisfied by the wrapped value
 *
 * @example
 * import { some, none, exists } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     exists(n => n > 0)
 *   ),
 *   true
 * )
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     exists(n => n > 1)
 *   ),
 *   false
 * )
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     exists(n => n > 0)
 *   ),
 *   false
 * )
 *
 * @since 2.0.0
 */
var exists = function (predicate) { return function (ma) {
    return isNone(ma) ? false : predicate(ma.value);
}; };
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @since 2.9.0
 */
var Do = 
/*#__PURE__*/
of(_internal__WEBPACK_IMPORTED_MODULE_0__/* .emptyRecord */ .F4);
/**
 * @since 2.8.0
 */
var bindTo = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bindTo_(Functor)));
/**
 * @since 2.8.0
 */
var bind = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (bind_(Chain)));
// -------------------------------------------------------------------------------------
// pipeable sequence S
// -------------------------------------------------------------------------------------
/**
 * @since 2.8.0
 */
var apS = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (apS_(Apply)));
// -------------------------------------------------------------------------------------
// sequence T
// -------------------------------------------------------------------------------------
/**
 * @since 2.11.0
 */
var ApT = 
/*#__PURE__*/
of(_internal__WEBPACK_IMPORTED_MODULE_0__/* .emptyReadonlyArray */ .Xl);
// -------------------------------------------------------------------------------------
// array utils
// -------------------------------------------------------------------------------------
/**
 * Equivalent to `ReadonlyNonEmptyArray#traverseWithIndex(Applicative)`.
 *
 * @since 2.11.0
 */
var traverseReadonlyNonEmptyArrayWithIndex = function (f) { return function (as) {
    var o = f(0, _.head(as));
    if (isNone(o)) {
        return none;
    }
    var out = [o.value];
    for (var i = 1; i < as.length; i++) {
        var o_1 = f(i, as[i]);
        if (isNone(o_1)) {
            return none;
        }
        out.push(o_1.value);
    }
    return some(out);
}; };
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(Applicative)`.
 *
 * @since 2.11.0
 */
var traverseReadonlyArrayWithIndex = function (f) {
    var g = traverseReadonlyNonEmptyArrayWithIndex(f);
    return function (as) { return (_.isNonEmpty(as) ? g(as) : ApT); };
};
/**
 * @since 2.9.0
 */
var traverseArrayWithIndex = (/* unused pure expression or super */ null && (traverseReadonlyArrayWithIndex));
/**
 * @since 2.9.0
 */
var traverseArray = function (f) {
    return traverseReadonlyArrayWithIndex(function (_, a) { return f(a); });
};
/**
 * @since 2.9.0
 */
var sequenceArray = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (traverseArray(identity)));
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
// tslint:disable: deprecation
/**
 * Use `Refinement` module instead.
 *
 * @since 2.0.0
 * @deprecated
 */
function getRefinement(getOption) {
    return function (a) { return isSome(getOption(a)); };
}
/**
 * Use [`chainNullableK`](#chainnullablek) instead.
 *
 * @category combinators
 * @since 2.0.0
 * @deprecated
 */
var mapNullable = (/* unused pure expression or super */ null && (chainNullableK));
/**
 * Use small, specific instances instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var option = {
    URI: URI,
    map: _map,
    of: of,
    ap: _ap,
    chain: _chain,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: sequence,
    zero: zero,
    alt: _alt,
    extend: _extend,
    compact: compact,
    separate: separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    wither: _wither,
    wilt: _wilt,
    throwError: throwError
};
/**
 * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var getApplySemigroup = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (getApplySemigroup_(Apply)));
/**
 * Use [`getApplicativeMonoid`](./Applicative.ts.html#getapplicativemonoid) instead.
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var getApplyMonoid = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (getApplicativeMonoid(Applicative)));
/**
 * Use
 *
 * ```ts
 * import { first } from 'fp-ts/Semigroup'
 * import { getMonoid } from 'fp-ts/Option'
 *
 * getMonoid(first())
 * ```
 *
 * instead.
 *
 * Monoid returning the left-most non-`None` value
 *
 * | x       | y       | concat(x, y) |
 * | ------- | ------- | ------------ |
 * | none    | none    | none         |
 * | some(a) | none    | some(a)      |
 * | none    | some(b) | some(b)      |
 * | some(a) | some(b) | some(a)      |
 *
 * @example
 * import { getFirstMonoid, some, none } from 'fp-ts/Option'
 *
 * const M = getFirstMonoid<number>()
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(2)), some(2))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(1))
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var getFirstMonoid = function () { return getMonoid(first()); };
/**
 * Use
 *
 * ```ts
 * import { last } from 'fp-ts/Semigroup'
 * import { getMonoid } from 'fp-ts/Option'
 *
 * getMonoid(last())
 * ```
 *
 * instead.
 *
 * Monoid returning the right-most non-`None` value
 *
 * | x       | y       | concat(x, y) |
 * | ------- | ------- | ------------ |
 * | none    | none    | none         |
 * | some(a) | none    | some(a)      |
 * | none    | some(b) | some(b)      |
 * | some(a) | some(b) | some(b)      |
 *
 * @example
 * import { getLastMonoid, some, none } from 'fp-ts/Option'
 *
 * const M = getLastMonoid<number>()
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(2)), some(2))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(2))
 *
 * @category instances
 * @since 2.0.0
 * @deprecated
 */
var getLastMonoid = function () { return getMonoid(last()); };


/***/ }),

/***/ 64870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s4": function() { return /* binding */ separated; }
/* harmony export */ });
/* unused harmony exports map, mapLeft, bimap, URI, Bifunctor, Functor, flap, left, right */
/* harmony import */ var _function__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3735);
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */


// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.10.0
 */
var separated = function (left, right) { return ({ left: left, right: right }); };
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var _map = function (fa, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_0__/* .pipe */ .zG)(fa, map(f)); };
var _mapLeft = function (fa, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_0__/* .pipe */ .zG)(fa, mapLeft(f)); };
var _bimap = function (fa, g, f) { return (0,_function__WEBPACK_IMPORTED_MODULE_0__/* .pipe */ .zG)(fa, bimap(g, f)); };
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category Functor
 * @since 2.10.0
 */
var map = function (f) { return function (fa) {
    return separated(left(fa), f(right(fa)));
}; };
/**
 * Map a function over the first type argument of a bifunctor.
 *
 * @category Bifunctor
 * @since 2.10.0
 */
var mapLeft = function (f) { return function (fa) {
    return separated(f(left(fa)), right(fa));
}; };
/**
 * Map a pair of functions over the two type arguments of the bifunctor.
 *
 * @category Bifunctor
 * @since 2.10.0
 */
var bimap = function (f, g) { return function (fa) {
    return separated(f(left(fa)), g(right(fa)));
}; };
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.10.0
 */
var URI = 'Separated';
/**
 * @category instances
 * @since 2.10.0
 */
var Bifunctor = {
    URI: URI,
    mapLeft: _mapLeft,
    bimap: _bimap
};
/**
 * @category instances
 * @since 2.10.0
 */
var Functor = {
    URI: URI,
    map: _map
};
/**
 * Derivable from `Functor`.
 *
 * @category combinators
 * @since 2.10.0
 */
var flap = 
/*#__PURE__*/
(/* unused pure expression or super */ null && (flap_(Functor)));
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.10.0
 */
var left = function (s) { return s.left; };
/**
 * @since 2.10.0
 */
var right = function (s) { return s.right; };


/***/ }),

/***/ 25605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ witherDefault; },
/* harmony export */   "Fj": function() { return /* binding */ wiltDefault; }
/* harmony export */ });
/* unused harmony export filterE */

function wiltDefault(T, C) {
    return function (F) {
        var traverseF = T.traverse(F);
        return function (wa, f) { return F.map(traverseF(wa, f), C.separate); };
    };
}
function witherDefault(T, C) {
    return function (F) {
        var traverseF = T.traverse(F);
        return function (wa, f) { return F.map(traverseF(wa, f), C.compact); };
    };
}
function filterE(W) {
    return function (F) {
        var witherF = W.wither(F);
        return function (predicate) { return function (ga) { return witherF(ga, function (a) { return F.map(predicate(a), function (b) { return (b ? _.some(a) : _.none); }); }); }; };
    };
}


/***/ }),

/***/ 59384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ emptyRecord; },
/* harmony export */   "G": function() { return /* binding */ some; },
/* harmony export */   "Gb": function() { return /* binding */ tail; },
/* harmony export */   "Od": function() { return /* binding */ isNonEmpty; },
/* harmony export */   "Xl": function() { return /* binding */ emptyReadonlyArray; },
/* harmony export */   "YM": function() { return /* binding */ head; },
/* harmony export */   "YP": function() { return /* binding */ none; },
/* harmony export */   "nM": function() { return /* binding */ isLeft; },
/* harmony export */   "pC": function() { return /* binding */ isSome; },
/* harmony export */   "r1": function() { return /* binding */ fromReadonlyNonEmptyArray; },
/* harmony export */   "ri": function() { return /* binding */ singleton; }
/* harmony export */ });
/* unused harmony exports isNone, isRight, left, right, has */
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
// -------------------------------------------------------------------------------------
// Option
// -------------------------------------------------------------------------------------
/** @internal */
var isNone = function (fa) { return fa._tag === 'None'; };
/** @internal */
var isSome = function (fa) { return fa._tag === 'Some'; };
/** @internal */
var none = { _tag: 'None' };
/** @internal */
var some = function (a) { return ({ _tag: 'Some', value: a }); };
// -------------------------------------------------------------------------------------
// Either
// -------------------------------------------------------------------------------------
/** @internal */
var isLeft = function (ma) { return ma._tag === 'Left'; };
/** @internal */
var isRight = function (ma) { return ma._tag === 'Right'; };
/** @internal */
var left = function (e) { return ({ _tag: 'Left', left: e }); };
/** @internal */
var right = function (a) { return ({ _tag: 'Right', right: a }); };
// -------------------------------------------------------------------------------------
// ReadonlyNonEmptyArray
// -------------------------------------------------------------------------------------
/** @internal */
var singleton = function (a) { return [a]; };
/** @internal */
var isNonEmpty = function (as) { return as.length > 0; };
/** @internal */
var head = function (as) { return as[0]; };
/** @internal */
var tail = function (as) { return as.slice(1); };
// -------------------------------------------------------------------------------------
// empty
// -------------------------------------------------------------------------------------
/** @internal */
var emptyReadonlyArray = [];
/** @internal */
var emptyRecord = {};
// -------------------------------------------------------------------------------------
// Record
// -------------------------------------------------------------------------------------
/** @internal */
var has = Object.prototype.hasOwnProperty;
// -------------------------------------------------------------------------------------
// NonEmptyArray
// -------------------------------------------------------------------------------------
/** @internal */
var fromReadonlyNonEmptyArray = function (as) { return __spreadArray([as[0]], as.slice(1)); };


/***/ })

}]);